/* prettier-ignore */
 export const CONMAN_DATA = {
  "cities": [
    {
      "is_live": true,
      "regex_key": "south goa",
      "name": "South Goa",
      "key": "city_south_goa_v2",
      "seo_city_key": "India|South Goa",
      "customer_city": "city_south_goa_v2",
      "state": "Goa",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "South Goa",
        "south goa",
        "South Goa"
      ],
      "subcities": [
        "south goa"
      ],
      "city_address_hint": "449F+3H9, Pirl, Goa 403703, India",
      "url_name": "south goa",
      "country_name": "India",
      "postal_code": "403703",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 15.11766,
        "long": 74.12399599999999,
        "details": "449F+3H9, Pirl, Goa 403703, India",
        "google_place_id": "ChIJixLkOu6zvzsRgGFikAr04_w"
      },
      "bounds": [
        14.997952,
        73.783155,
        15.361694,
        74.230694
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "srikakulam",
      "name": "Srikakulam",
      "key": "city_srikakulam_v2",
      "seo_city_key": "India|Srikakulam",
      "customer_city": "city_srikakulam_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Srikakulam",
        "srikakulam",
        "Srikakulam"
      ],
      "subcities": [
        "srikakulam"
      ],
      "city_address_hint": "7VVV+XG7, Seven Rd Junction Area, New Colony, Srikakulam, Andhra Pradesh 532001, India",
      "url_name": "srikakulam",
      "country_name": "India",
      "postal_code": "532001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 18.2949165,
        "long": 83.89380179999999,
        "details": "7VVV+XG7, Seven Rd Junction Area, New Colony, Srikakulam, Andhra Pradesh 532001, India",
        "google_place_id": "ChIJIXNz8Q4VPDoRt1OJiRHPRQo"
      },
      "bounds": [
        18.105167,
        83.569522,
        18.901553,
        84.571252
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "gajapati",
      "name": "Gajapati",
      "key": "city_gajapati_v2",
      "seo_city_key": "India|Gajapati",
      "customer_city": "city_gajapati_v2",
      "state": "Odisha",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Gajapati",
        "gajapati",
        "Gajapati"
      ],
      "subcities": [
        "gajapati"
      ],
      "city_address_hint": "55RP+F7 Bhaliaganda, Odisha, India",
      "url_name": "gajapati",
      "country_name": "India",
      "postal_code": "761207",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 19.1912221,
        "long": 84.1857115,
        "details": "55RP+F7 Bhaliaganda, Odisha, India",
        "google_place_id": "ChIJa89WfxfbPDoRMtMCOYAVFaE"
      },
      "bounds": [
        18.920546,
        83.793481,
        19.637621,
        84.439466
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "valsad",
      "name": "Valsad",
      "key": "city_valsad_v2",
      "seo_city_key": "India|Valsad",
      "customer_city": "city_valsad_v2",
      "state": "Gujarat",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Valsad",
        "valsad",
        "Valsad"
      ],
      "subcities": [
        "valsad"
      ],
      "city_address_hint": "142, Gandhidham Road, Shiv Township Colony, West Railway Colony, Mundra Kutch, Valsad, Gujarat 370421, India",
      "url_name": "valsad",
      "country_name": "India",
      "postal_code": "370421",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 20.5992349,
        "long": 72.9342451,
        "details": "142, Gandhidham Road, Shiv Township Colony, West Railway Colony, Mundra Kutch, Valsad, Gujarat 370421, India",
        "google_place_id": "ChIJz6ZJgiDo4DsRE6iVTP0ptvY"
      },
      "bounds": [
        20.032721,
        72.612205,
        21.032485,
        73.413948
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "bhubaneswar",
      "name": "Bhubaneswar",
      "key": "city_bhubaneswar_v2",
      "seo_city_key": "india|bhubaneswar",
      "customer_city": "city_bhubaneswar_v2",
      "state": "Orissa",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "bhubaneswar"
      ],
      "subcities": [
        "Bhunaneswar",
        "bhubaneswar"
      ],
      "city_address_hint": "Neeladri Vihar, Bhubaneswar",
      "url_name": "bhubaneswar",
      "country_name": "India",
      "postal_code": "751001",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 19.97257,
        "long": 72.74742,
        "details": "Neeladri Vihar, Bhubaneswar",
        "google_place_id": "ChIJE7do_FQIGToR9Hx3bcQPnTI"
      },
      "bounds": [
        19.652751,
        85.441422,
        20.386127,
        86.844235
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "suryapet",
      "name": "Suryapet",
      "key": "city_suryapet_v2",
      "seo_city_key": "India|Suryapet",
      "customer_city": "city_suryapet_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "suryapet"
      ],
      "subcities": [
        "suryapet"
      ],
      "city_address_hint": "4JR7+85G, Thallagadda, Suryapet, Telangana 508213, India",
      "url_name": "suryapet",
      "country_name": "India",
      "postal_code": "508213",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 17.141312,
        "long": 79.612793,
        "details": "4JR7+85G, Thallagadda, Suryapet, Telangana 508213, India",
        "google_place_id": "ChIJb52xOrbbNDoROZAoFjmpRmo"
      },
      "bounds": [
        16.771852,
        79.503242,
        17.7034,
        80.01553
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Krishna",
      "name": "Krishna",
      "key": "city_krishna_v2",
      "seo_city_key": "India|Krishna",
      "customer_city": "city_krishna_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Krishna"
      ],
      "subcities": [
        "Krishna"
      ],
      "city_address_hint": "Postmaster, Post Office KONDURUPADU (BRANCH OFFICE), KRISHNA, ANDHRA PRADESH (AP), India (IN)",
      "url_name": "Krishna",
      "country_name": "India",
      "postal_code": "521110",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 15.8148706,
        "long": 79.9714467,
        "details": "Postmaster, Post Office KONDURUPADU (BRANCH OFFICE), KRISHNA, ANDHRA PRADESH (AP), India (IN)",
        "google_place_id": "ChIJicVBbgzxSjoRsR7Vv_0UmLc"
      },
      "bounds": [
        15.72937,
        80.863413,
        16.359272,
        81.402596
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "rajahmundry",
      "name": "Rajahmundry",
      "key": "city_rajahmundry_v2",
      "seo_city_key": "india|rajahmundry",
      "customer_city": "city_rajahmundry_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "rajahmundry",
        "Rajahmundry"
      ],
      "subcities": [
        "rajahmundry"
      ],
      "city_address_hint": "Kerala Complex, Rajahmundry",
      "url_name": "rajahmundry",
      "country_name": "India",
      "postal_code": "533103",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 17.008326,
        "long": 81.783572,
        "details": "Kerala Complex, Rajahmundry",
        "google_place_id": "ChIJgVQmm_SjNzoRcm-JJOdsmfM"
      },
      "bounds": [
        16.407107,
        80.891003,
        17.456454,
        82.727776
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "khammam",
      "name": "Khammam",
      "key": "city_khammam_v2",
      "seo_city_key": "india|khammam",
      "customer_city": "city_khammam_v2",
      "state": "Telangana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "khammam",
        "Khammam"
      ],
      "subcities": [
        "khammam"
      ],
      "city_address_hint": "South India Shopping Mall Khammam",
      "url_name": "khammam",
      "country_name": "India",
      "postal_code": "507001",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 17.24736,
        "long": 80.15072,
        "details": "South India Shopping Mall Khammam",
        "google_place_id": "ChIJ0eZEYz5ZNDoRfVnGYNv8VZc"
      },
      "bounds": [
        16.754062,
        80.034003,
        17.67868,
        80.890254
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "prakasam",
      "name": "Prakasam",
      "key": "city_prakasam_v2",
      "seo_city_key": "India|Prakasam",
      "customer_city": "city_prakasam_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Prakasam",
        "prakasam",
        "Prakasam"
      ],
      "subcities": [
        "prakasam"
      ],
      "city_address_hint": "2X89+2M Peda Arutla, Andhra Pradesh, India",
      "url_name": "prakasam",
      "country_name": "India",
      "postal_code": "523331",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 16.015009,
        "long": 78.969231,
        "details": "2X89+2M Peda Arutla, Andhra Pradesh, India",
        "google_place_id": "GhIJ8SHyp9cDMEARPdF14Qe-U0A"
      },
      "bounds": [
        15.122867,
        78.971379,
        16.122521,
        80.5781
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "nellore",
      "name": "Nellore",
      "key": "city_nellore_v2",
      "seo_city_key": "India|Nellore",
      "customer_city": "city_nellore_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Nellore",
        "nellore",
        "Nellore"
      ],
      "subcities": [
        "nellore"
      ],
      "city_address_hint": "15-365, Brindavanam, Nellore, Andhra Pradesh 524001, India",
      "url_name": "nellore",
      "country_name": "India",
      "postal_code": "524001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 14.4425987,
        "long": 79.98645599999999,
        "details": "15-365, Brindavanam, Nellore, Andhra Pradesh 524001, India",
        "google_place_id": "ChIJcYeVDsqMTDoRVR8WJSBsA9M"
      },
      "bounds": [
        13.765563,
        79.314937,
        15.118903,
        80.333361
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Guntur Rural",
      "name": "Guntur Rural",
      "key": "city_guntur_rural_v2",
      "seo_city_key": "India|Guntur Rural",
      "customer_city": "city_guntur_rural_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Guntur Rural"
      ],
      "subcities": [
        "guntur rural"
      ],
      "city_address_hint": "Guntur Rural, 522601",
      "url_name": "Guntur Rural",
      "country_name": "India",
      "postal_code": "522601",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 15.4776876,
        "long": 78.487285,
        "details": "Guntur Rural, 522601",
        "google_place_id": "ChIJTZKgRVCttTsRXSkVwnANISw"
      },
      "bounds": [
        16.132544,
        79.233029,
        16.682678,
        80.370323
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "wardha",
      "name": "Wardha",
      "key": "city_wardha_v2",
      "seo_city_key": "India|Wardha",
      "customer_city": "city_wardha_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Wardha",
        "wardha",
        "Wardha"
      ],
      "subcities": [
        "wardha"
      ],
      "city_address_hint": "9175241566, Mahadevpura, Wardha, Maharashtra 442001, India",
      "url_name": "wardha",
      "country_name": "India",
      "postal_code": "442001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 20.745319,
        "long": 78.60219459999999,
        "details": "9175241566, Mahadevpura, Wardha, Maharashtra 442001, India",
        "google_place_id": "ChIJnaZa8QR_1DsRbKaCM7E1buc"
      },
      "bounds": [
        20.539463,
        78.300685,
        20.976951,
        79.327747
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "nagpur",
      "name": "Nagpur",
      "key": "city_nagpur_v2",
      "seo_city_key": "india|nagpur",
      "customer_city": "city_nagpur_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "nagpur"
      ],
      "subcities": [
        "Nagpur",
        "nagpur"
      ],
      "city_address_hint": "Dhantoli, Nagpur",
      "url_name": "nagpur",
      "country_name": "India",
      "postal_code": "440001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 21.13344,
        "long": 79.08376,
        "details": "Dhantoli, Nagpur",
        "google_place_id": "ChIJ1esbupDA1DsR7_vQpJKicDU"
      },
      "bounds": [
        20.993155,
        78.587565,
        21.378258,
        79.502646
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Kancheepuram",
      "name": "Kancheepuram",
      "key": "city_kancheepuram_v2",
      "seo_city_key": "India|Kancheepuram",
      "customer_city": "city_kancheepuram_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Kancheepuram",
        "kancheepuram",
        "Kancheepuram"
      ],
      "subcities": [],
      "city_address_hint": "Nellukara St, Nellukara st, Kanchipuram, Tamil Nadu 631501, India",
      "url_name": "Kancheepuram",
      "country_name": "India",
      "postal_code": "631501",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 12.8372508,
        "long": 79.7041749,
        "details": "Nellukara St, Nellukara st, Kanchipuram, Tamil Nadu 631501, India",
        "google_place_id": "ChIJLfHH4PfCUjoRTSrLsYKGX94"
      },
      "bounds": [
        12.790415,
        79.437652,
        12.952699,
        80.029384
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "junagadh",
      "name": "Junagadh",
      "key": "city_junagadh_v2",
      "seo_city_key": "India|Junagadh",
      "customer_city": "city_junagadh_v2",
      "state": "Gujarat",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Junagadh",
        "junagadh",
        "Junagadh"
      ],
      "subcities": [
        "junagadh"
      ],
      "city_address_hint": "Jayshree Rd, Joshipura, Junagadh, Gujarat 362001, India",
      "url_name": "junagadh",
      "country_name": "India",
      "postal_code": "362001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 21.5222203,
        "long": 70.4579436,
        "details": "Jayshree Rd, Joshipura, Junagadh, Gujarat 362001, India",
        "google_place_id": "ChIJU38naowBWDkRSG6oIIUvtRM"
      },
      "bounds": [
        20.427531,
        68.546565,
        24.212099,
        71.539699
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "bangalore",
      "name": "Bangalore",
      "key": "city_bangalore_v2",
      "seo_city_key": "india|bangalore",
      "customer_city": "city_bangalore_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "bangalore",
        "bengaluru",
        "arisinakunte"
      ],
      "subcities": [
        "Bangalore",
        "Bengaluru",
        "Bangalore Urban",
        "Arisinakunte",
        "bangalore"
      ],
      "city_address_hint": "Vittal Mallya Road, Bangalore",
      "url_name": "bangalore",
      "country_name": "India",
      "postal_code": "560102",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 12.9714486,
        "long": 77.5935416,
        "details": "Vittal Mallya Road, Bangalore",
        "google_place_id": "ChIJVRVppHcWrjsRT6zUzOU4PhU"
      },
      "bounds": [
        12.704535,
        77.376052,
        13.255538,
        77.90099
      ],
      "offices": [
        {
          "name": "Bangalore",
          "is_live": true,
          "address": "2nd Floor 3rd floor, 4th floor, Royal Arcade, 6 Koramangala Industrial Area, 80 Feet Road, Koramangala, Bengaluru, Karnataka - 560095",
          "subcities": [
            "Bangalore",
            "Bangalore Urban",
            "Arisinakunte"
          ],
          "office_type": [
            "business",
            "corporate",
            "support",
            "training"
          ],
          "location_mapping": {
            "lat": 12.935345,
            "long": 77.614678
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "vadodara",
      "name": "Vadodara",
      "key": "city_vadodara_v2",
      "seo_city_key": "india|vadodra",
      "customer_city": "city_vadodara_v2",
      "state": "Gujrat",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "vadodara"
      ],
      "subcities": [
        "Vadodara",
        "vadodara"
      ],
      "city_address_hint": "Alkapuri, Vadodara",
      "url_name": "vadodara",
      "country_name": "India",
      "postal_code": "390001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 22.31423,
        "long": 73.1752,
        "details": "Alkapuri, Vadodara",
        "google_place_id": "ChIJe2vZ0bDIXzkRgRaolb5LoFg"
      },
      "bounds": [
        22.050485,
        73.025199,
        22.708894,
        73.811924
      ],
      "offices": [
        {
          "name": "Vadodara",
          "is_live": true,
          "address": "2nd floor, 50, Sampatrao Colony, Alkapuri, Vadodara - 390007",
          "subcities": [
            "Vadodara"
          ],
          "office_type": [
            "business",
            "corporate",
            "support",
            "training"
          ],
          "location_mapping": {
            "lat": 22.309201,
            "long": 73.75448
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "anand",
      "name": "Anand",
      "key": "city_anand_v2",
      "seo_city_key": "India|Anand",
      "customer_city": "city_anand_v2",
      "state": "Gujarat",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Anand",
        "anand",
        "Anand"
      ],
      "subcities": [
        "anand"
      ],
      "city_address_hint": "305,3rd Flor R.K center, opp. saffron tower, fatehgunj, Vadodara, Anand, Gujarat 390002, India",
      "url_name": "anand",
      "country_name": "India",
      "postal_code": "388345",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 22.5645175,
        "long": 72.928871,
        "details": "305,3rd Flor R.K center, opp. saffron tower, fatehgunj, Vadodara, Anand, Gujarat 390002, India",
        "google_place_id": "ChIJhYgM_X5OXjkRFVJLDDy5oKk"
      },
      "bounds": [
        22.357954,
        72.616109,
        22.595073,
        73.025051
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "kheda",
      "name": "Kheda",
      "key": "city_kheda_v2",
      "seo_city_key": "India|Kheda",
      "customer_city": "city_kheda_v2",
      "state": "Gujarat",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Kheda",
        "kheda",
        "Kheda"
      ],
      "subcities": [
        "kheda"
      ],
      "city_address_hint": "Kheda Chsndudi, Sghji, Mohammadi Nagar, Kheda, Gujarat 387411, India",
      "url_name": "kheda",
      "country_name": "India",
      "postal_code": "388230",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 22.750651,
        "long": 72.68466579999999,
        "details": "Kheda Chsndudi, Sghji, Mohammadi Nagar, Kheda, Gujarat 387411, India",
        "google_place_id": "ChIJg1z2ZqD1XjkR-IuGkUVqzx8"
      },
      "bounds": [
        22.710534,
        73.20214,
        22.872891,
        73.347872
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "bharuch",
      "name": "Bharuch",
      "key": "city_bharuch_v2",
      "seo_city_key": "India|Bharuch",
      "customer_city": "city_bharuch_v2",
      "state": "Gujarat",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Bharuch",
        "bharuch",
        "Bharuch"
      ],
      "subcities": [
        "bharuch"
      ],
      "city_address_hint": "PX4W+389, Moficer Jin Compound, Bharuch, Gujarat 392001, India",
      "url_name": "bharuch",
      "country_name": "India",
      "postal_code": "392001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 21.7051358,
        "long": 72.9958748,
        "details": "PX4W+389, Moficer Jin Compound, Bharuch, Gujarat 392001, India",
        "google_place_id": "ChIJIcQqsqIg4DsRKv0iRkJsEaQ"
      },
      "bounds": [
        21.440127,
        72.502727,
        21.970589,
        73.328751
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "BENGALURU RURAL",
      "name": "BENGALURU RURAL",
      "key": "city_bengaluru_rural_v2",
      "seo_city_key": "India|Bengaluru Rural",
      "customer_city": "city_bengaluru_rural_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "bengalururural"
      ],
      "subcities": [],
      "city_address_hint": "Postmaster, Post Office ALURDUDDANAHALLI (BRANCH OFFICE), BANGALORE RURAL, KARNATAKA (KA), India (IN)",
      "url_name": "BENGALURU RURAL",
      "country_name": "India",
      "postal_code": "562110",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 11.70817,
        "long": 92.7211179,
        "details": "Postmaster, Post Office ALURDUDDANAHALLI (BRANCH OFFICE), BANGALORE RURAL, KARNATAKA (KA), India (IN)",
        "google_place_id": "ChIJxVYP_Dq-iDARSdQXYYX4Og4"
      },
      "bounds": [
        13.263976,
        77.398824,
        13.391249,
        77.933083
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "solapur",
      "name": "Solapur",
      "key": "city_solapur_v2",
      "seo_city_key": "India|Solapur",
      "customer_city": "city_solapur_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Solapur",
        "solapur",
        "Solapur"
      ],
      "subcities": [
        "solapur"
      ],
      "city_address_hint": "Tilak Chowk, Sangameshwar Public School, 748/4, Vijapur Rd, Old Employment Chowk, Solapur, Maharashtra 413001, India",
      "url_name": "solapur",
      "country_name": "India",
      "postal_code": "413001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 17.660089,
        "long": 75.906051,
        "details": "Tilak Chowk, Sangameshwar Public School, 748/4, Vijapur Rd, Old Employment Chowk, Solapur, Maharashtra 413001, India",
        "google_place_id": "ChIJa3glVnHaxTsREk3xcJj3ppI"
      },
      "bounds": [
        17.367064,
        74.949588,
        18.501945,
        76.242886
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "purba bardhaman",
      "name": "PURBA BARDHAMAN",
      "key": "city_purba_bardhaman_v2",
      "seo_city_key": "India|PURBA BARDHAMAN",
      "customer_city": "city_purba_bardhaman_v2",
      "state": "West Bengal",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "PURBA BARDHAMAN"
      ],
      "subcities": [
        "purba bardhaman"
      ],
      "city_address_hint": "PX9M+PF Komarpur, West Bengal, India",
      "url_name": "purba bardhaman",
      "country_name": "India",
      "postal_code": "713129",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 23.719331,
        "long": 87.983743,
        "details": "PX9M+PF Komarpur, West Bengal, India",
        "google_place_id": "GhIJOn2YGCa4N0ARZOoJpvX-VUA"
      },
      "bounds": [
        23.045775,
        85.897378,
        24.519833,
        87.915988
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "indore",
      "name": "Indore",
      "key": "city_indore_v2",
      "seo_city_key": "india|indore",
      "customer_city": "city_indore_v2",
      "state": "Madhya Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "indore"
      ],
      "subcities": [
        "Indore",
        "indore"
      ],
      "city_address_hint": "63, Maharani Rd, Siyaganj, Indore, Madhya Pradesh 452007, India",
      "url_name": "indore",
      "country_name": "India",
      "postal_code": "452007",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 22.717199,
        "long": 75.865844,
        "details": "63, Maharani Rd, Siyaganj, Indore, Madhya Pradesh 452007, India",
        "google_place_id": "ChIJLczF6BH9YjkR-tvBi10qqDI"
      },
      "bounds": [
        22.61615,
        75.78966,
        22.83298,
        75.936
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "mahbubnagar",
      "name": "Mahbubnagar",
      "key": "city_mahbubnagar_v2",
      "seo_city_key": "India|Mahbubnagar",
      "customer_city": "city_mahbubnagar_v2",
      "state": "Telangana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Mahbubnagar",
        "mahbubnagar",
        "Mahbubnagar"
      ],
      "subcities": [
        "mahbubnagar"
      ],
      "city_address_hint": "Baithulmal Nagar, Nagercoil, Tamil Nadu ",
      "url_name": "mahbubnagar",
      "country_name": "India",
      "postal_code": "629002",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 16.7488379,
        "long": 78.00351719999999,
        "details": "Baithulmal Nagar, Nagercoil, Tamil Nadu ",
        "google_place_id": "ChIJdaSu-gMmyjsRZfEKRG1n48Y"
      },
      "bounds": [
        16.391296,
        77.696901,
        17.108043,
        78.441009
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "sharjah",
      "name": "Sharjah",
      "key": "city_sharjah_v2",
      "seo_city_key": "saudi_arabia|sharjah",
      "customer_city": "city_sharjah_v2",
      "state": "Sharjah state",
      "country_key": "UAE",
      "country_id": "UAE",
      "regex": [
        "sharjah",
        "??????",
        "kalba",
        "al majaz 1"
      ],
      "subcities": [
        "Sharjah",
        "sharjah"
      ],
      "city_address_hint": "Safari Mall Sharjah",
      "url_name": "sharjah",
      "country_name": "UAE",
      "postal_code": "33876",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 25.304563,
        "long": 55.452062,
        "details": "Safari Mall Sharjah",
        "google_place_id": "ChIJYwnq0CFfXz4RLLdpXUpAs9Q"
      },
      "bounds": [
        25.30047,
        55.34936,
        25.493015,
        55.723073
      ],
      "offices": [],
      "timezone": "Asia/Dubai"
    },
    {
      "is_live": true,
      "regex_key": "cuttack",
      "name": "Cuttack",
      "key": "city_cuttack_v2",
      "seo_city_key": "india|cuttack",
      "customer_city": "city_cuttack_v2",
      "state": "Orissa",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "cuttack",
        "Cuttack"
      ],
      "subcities": [
        "cuttack"
      ],
      "city_address_hint": "Dipti Plaza, Cuttack",
      "url_name": "cuttack",
      "country_name": "India",
      "postal_code": "753001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 20.474915,
        "long": 85.873641,
        "details": "Dipti Plaza, Cuttack",
        "google_place_id": "ChIJFbWB53USGToRtxUdbS_o21Y"
      },
      "bounds": [
        20.399,
        85.427586,
        20.709915,
        86.306267
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "bhagalpur",
      "name": "Bhagalpur",
      "key": "city_bhagalpur_v2",
      "seo_city_key": "India|Bhagalpur",
      "customer_city": "city_bhagalpur_v2",
      "state": "Bihar",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Bhagalpur",
        "bhagalpur",
        "Bhagalpur"
      ],
      "subcities": [
        "bhagalpur"
      ],
      "city_address_hint": "6XPF+VRG, Tilkamanjhi, Bhagalpur, Habibpur, Bihar 812002, India",
      "url_name": "bhagalpur",
      "country_name": "India",
      "postal_code": "812002",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 25.2371958,
        "long": 86.97457020000002,
        "details": "6XPF+VRG, Tilkamanjhi, Bhagalpur, Habibpur, Bihar 812002, India",
        "google_place_id": "ChIJlZyucCxL8DkRQoJJKGjH7Dc"
      },
      "bounds": [
        24.980782,
        86.745562,
        26.088622,
        87.777405
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "bilaspur",
      "name": "Bilaspur",
      "key": "city_bilaspur_v2",
      "seo_city_key": "India|Bilaspur",
      "customer_city": "city_bilaspur_v2",
      "state": "Chhattisgarh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Bilaspur",
        "bilaspur",
        "Bilaspur"
      ],
      "subcities": [
        "bilaspur"
      ],
      "city_address_hint": "00, Bilaspur, Masanganj, Chhattisgarh 495001, India",
      "url_name": "bilaspur",
      "country_name": "India",
      "postal_code": "495001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 22.0796545,
        "long": 82.1409152,
        "details": "00, Bilaspur, Masanganj, Chhattisgarh 495001, India",
        "google_place_id": "ChIJp7aaexELKDoRr3ysnp3488Y"
      },
      "bounds": [
        21.965709,
        81.977494,
        22.323777,
        82.251506
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "alwar",
      "name": "Alwar+rewari",
      "key": "city_alwar_v2",
      "seo_city_key": "india|alwar",
      "customer_city": "city_alwar_v2",
      "state": "Rajasthan",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "alwar",
        "Alwar"
      ],
      "subcities": [
        "alwar"
      ],
      "city_address_hint": "Hanuman Circle Park, Alwar",
      "url_name": "alwar",
      "country_name": "India",
      "postal_code": "301001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 27.55488,
        "long": 76.640655,
        "details": "Hanuman Circle Park, Alwar",
        "google_place_id": "ChIJR7PVA2GbcjkRnhDhuDwwjMg"
      },
      "bounds": [
        27.073092,
        76.1587,
        28.410028,
        76.789723
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "satara",
      "name": "Satara",
      "key": "city_satara_v2",
      "seo_city_key": "India|Satara",
      "customer_city": "city_satara_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Satara",
        "satara",
        "Satara"
      ],
      "subcities": [
        "satara"
      ],
      "city_address_hint": "HG89+X7R, Devarayamjal, Secunderabad, Telangana 500078, India",
      "url_name": "satara",
      "country_name": "India",
      "postal_code": "415001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 17.568849,
        "long": 78.51815,
        "details": "HG89+X7R, Devarayamjal, Secunderabad, Telangana 500078, India",
        "google_place_id": "ChIJo-lWVwCFyzsRH4pGKJHaD_I"
      },
      "bounds": [
        17.222573,
        73.709121,
        18.127336,
        74.854059
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Peddapalli",
      "name": "Peddapalli",
      "key": "city_peddapalli_v2",
      "seo_city_key": "India|Telangana",
      "customer_city": "city_peddapalli_v2",
      "state": "Telangana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Peddapalli",
        "peddapalli"
      ],
      "subcities": [
        "Peddapalli"
      ],
      "city_address_hint": "J9FH+HQ Peddapalli, Telangana, India",
      "url_name": "Peddapalli",
      "country_name": "India",
      "postal_code": "505172",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 18.623945,
        "long": 79.379389,
        "details": "J9FH+HQ Peddapalli, Telangana, India",
        "google_place_id": "GhIJsoAJ3LqfMkARal4f50fYU0A"
      },
      "bounds": [
        18.212047,
        78.936138,
        19.161404,
        79.826668
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "warangal",
      "name": "Warangal",
      "key": "city_warangal_v2",
      "seo_city_key": "india|warangal",
      "customer_city": "city_warangal_v2",
      "state": "Telangana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "warangal",
        "Warangal"
      ],
      "subcities": [
        "warangal",
        "warangal urban",
        "warangal rural"
      ],
      "city_address_hint": "Kiwi Public School, Warangal",
      "url_name": "warangal",
      "country_name": "India",
      "postal_code": "506002",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 17.97006,
        "long": 79.59272,
        "details": "Kiwi Public School, Warangal",
        "google_place_id": "ChIJNbbovTpFMzoRKooFPXdMwK8"
      },
      "bounds": [
        17.711544,
        79.23379,
        18.198171,
        79.885422
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Jhajjar",
      "name": "Jhajjar",
      "key": "city_jhajjar_v2",
      "seo_city_key": "India|Jhajjar",
      "customer_city": "city_jhajjar_v2",
      "state": "Haryana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Jhajjar",
        "jhajjar",
        "Jhajjar"
      ],
      "subcities": [],
      "city_address_hint": "JM43+5GR, Bhatti Gate, Jhajjar, Jhajjar, Jhajjarrural, Haryana 124103, India",
      "url_name": "Jhajjar",
      "country_name": "India",
      "postal_code": "124102",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 28.6054875,
        "long": 76.6537749,
        "details": "JM43+5GR, Bhatti Gate, Jhajjar, Jhajjar, Jhajjarrural, Haryana 124103, India",
        "google_place_id": "ChIJOdW99GVwDTkRETakusE0_0U"
      },
      "bounds": [
        28.465439,
        76.259208,
        28.933911,
        76.792662
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "thiruvallur",
      "name": "Thiruvallur",
      "key": "city_thiruvallur_v2",
      "seo_city_key": "India|Thiruvallur",
      "customer_city": "city_thiruvallur_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Thiruvallur",
        "thiruvallur",
        "Thiruvallur"
      ],
      "subcities": [
        "thiruvallur"
      ],
      "city_address_hint": "111, Egmore, Thiruvallur, Kakkalur, Tamil Nadu 602023, India",
      "url_name": "thiruvallur",
      "country_name": "India",
      "postal_code": "602001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 13.1230558,
        "long": 79.9119526,
        "details": "111, Egmore, Thiruvallur, Kakkalur, Tamil Nadu 602023, India",
        "google_place_id": "ChIJu37_EBeQUjoRtGgR-y9sEzg"
      },
      "bounds": [
        12.953699,
        79.802715,
        13.337785,
        80.030374
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "tirupati",
      "name": "Tirupati",
      "key": "city_tirupati_v2",
      "seo_city_key": "India|Tirupati",
      "customer_city": "city_tirupati_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Tirupati",
        "tirupati",
        "Tirupati"
      ],
      "subcities": [
        "tirupati"
      ],
      "city_address_hint": "17/5051A, Rajendra Nagar, Tilak Nagar, Tirupati, Andhra Pradesh 517501, India",
      "url_name": "tirupati",
      "country_name": "India",
      "postal_code": "517501",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 13.6287557,
        "long": 79.4191795,
        "details": "17/5051A, Rajendra Nagar, Tilak Nagar, Tirupati, Andhra Pradesh 517501, India",
        "google_place_id": "ChIJJwRiiA9LTToRrAzK2tFSQc8"
      },
      "bounds": [
        13.035666,
        78.537798,
        13.763113,
        79.786834
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "chitradurga",
      "name": "Chitradurga",
      "key": "city_chitradurga_v2",
      "seo_city_key": "India|Chitradurga",
      "customer_city": "city_chitradurga_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Chitradurga",
        "chitradurga",
        "Chitradurga"
      ],
      "subcities": [
        "chitradurga"
      ],
      "city_address_hint": "69GX+26M, Nehru Nagar, Chitradurga, Karnataka 577501, India",
      "url_name": "chitradurga",
      "country_name": "India",
      "postal_code": "577501",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 14.2250932,
        "long": 76.3980464,
        "details": "69GX+26M, Nehru Nagar, Chitradurga, Karnataka 577501, India",
        "google_place_id": "ChIJ2bvHTPh0ujsRnuKzsqs7Tyg"
      },
      "bounds": [
        13.735896,
        76.073274,
        14.516157,
        76.949352
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "gondia",
      "name": "Gondia",
      "key": "city_gondia_v2",
      "seo_city_key": "India|Gondia",
      "customer_city": "city_gondia_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Gondia",
        "gondia",
        "Gondia"
      ],
      "subcities": [
        "gondia"
      ],
      "city_address_hint": "K.K. Complex, Shree Talkies Road, F53W+XCG, Bajaj Nagar, Gondia, Maharashtra 441601, India",
      "url_name": "gondia",
      "country_name": "India",
      "postal_code": "441601",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 21.4549477,
        "long": 80.19607119999999,
        "details": "K.K. Complex, Shree Talkies Road, F53W+XCG, Bajaj Nagar, Gondia, Maharashtra 441601, India",
        "google_place_id": "ChIJdQFLCq2uKzoRloGIIdQHhnE"
      },
      "bounds": [
        20.789819,
        79.921202,
        21.542511,
        80.591926
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "raipur",
      "name": "Raipur",
      "key": "city_raipur_v2",
      "seo_city_key": "india|raipur",
      "customer_city": "city_raipur_v2",
      "state": "Chattisgarh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "raipur",
        "Raipur"
      ],
      "subcities": [
        "raipur",
        "Raipur"
      ],
      "city_address_hint": "7J2J+F5X, Ganjpara, Station Road, Moudhapara, Raipur, Chhattisgarh 492001, India",
      "url_name": "raipur",
      "country_name": "India",
      "postal_code": "492001",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 21.251323,
        "long": 81.630454,
        "details": "7J2J+F5X, Ganjpara, Station Road, Moudhapara, Raipur, Chhattisgarh 492001, India",
        "google_place_id": "ChIJ9XP225PdKDoRH2xbw2m40_k"
      },
      "bounds": [
        20.873439,
        80.616484,
        21.571755,
        81.92111
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "chandrapur",
      "name": "Chandrapur",
      "key": "city_chandrapur_v2",
      "seo_city_key": "India|Chandrapur",
      "customer_city": "city_chandrapur_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Chandrapur",
        "chandrapur",
        "Chandrapur"
      ],
      "subcities": [
        "chandrapur"
      ],
      "city_address_hint": "X76W+JF6, Civil Lines, Chandrapur, Maharashtra 442402, India",
      "url_name": "chandrapur",
      "country_name": "India",
      "postal_code": "442402",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 19.9615398,
        "long": 79.2961468,
        "details": "X76W+JF6, Civil Lines, Chandrapur, Maharashtra 442402, India",
        "google_place_id": "ChIJM8OtZNHV0jsRVRvwhX3lCkQ"
      },
      "bounds": [
        19.515665,
        78.81343,
        20.536847,
        80.570555
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "akola",
      "name": "Akola",
      "key": "city_akola_v2",
      "seo_city_key": "India|Akola",
      "customer_city": "city_akola_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Akola",
        "akola",
        "Akola"
      ],
      "subcities": [
        "akola"
      ],
      "city_address_hint": "P225+37M, Bhandaraj BK, Akola, Maharashtra 444002, India",
      "url_name": "akola",
      "country_name": "India",
      "postal_code": "444002",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 20.7002159,
        "long": 77.0081678,
        "details": "P225+37M, Bhandaraj BK, Akola, Maharashtra 444002, India",
        "google_place_id": "ChIJ8V0qw5Ix1zsRU7Im6JEqp88"
      },
      "bounds": [
        20.367774,
        76.752453,
        21.234555,
        77.281773
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "jalna",
      "name": "Jalna",
      "key": "city_jalna_v2",
      "seo_city_key": "India|Jalna",
      "customer_city": "city_jalna_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Jalna",
        "jalna",
        "Jalna"
      ],
      "subcities": [
        "jalna"
      ],
      "city_address_hint": "RVPJ+4GW, 13, Swaraj Rd, Kanchan Nagar, Bhagya Nagar, Jalna, Maharashtra 431213, India",
      "url_name": "jalna",
      "country_name": "India",
      "postal_code": "431213",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 19.835086,
        "long": 75.881351,
        "details": "RVPJ+4GW, 13, Swaraj Rd, Kanchan Nagar, Bhagya Nagar, Jalna, Maharashtra 431213, India",
        "google_place_id": "ChIJDWlj5kFX2jsRM5uDqxX3ZRY"
      },
      "bounds": [
        19.473025,
        75.787211,
        20.293033,
        76.068134
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "murshidabad",
      "name": "Murshidabad",
      "key": "city_murshidabad_v2",
      "seo_city_key": "India|Murshidabad",
      "customer_city": "city_murshidabad_v2",
      "state": "West Bengal",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Murshidabad",
        "murshidabad",
        "Murshidabad"
      ],
      "subcities": [
        "murshidabad"
      ],
      "city_address_hint": "L KHERI VILL & P.O. KALAAM, 57GJ+934, Lalbagh, Murshidabad, West Bengal 742149, India",
      "url_name": "murshidabad",
      "country_name": "India",
      "postal_code": "742149",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 24.1759039,
        "long": 88.2801785,
        "details": "L KHERI VILL & P.O. KALAAM, 57GJ+934, Lalbagh, Murshidabad, West Bengal 742149, India",
        "google_place_id": "ChIJ0dC-hETW-zkR_72wbxXAfBo"
      },
      "bounds": [
        23.713481,
        87.941609,
        24.650664,
        88.743439
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "nadia district",
      "name": "Nadia district",
      "key": "city_nadia_district_v2",
      "seo_city_key": "India|Nadia district",
      "customer_city": "city_nadia_district_v2",
      "state": "West Bengal",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Nadia district",
        "nadia district",
        "Nadia district"
      ],
      "subcities": [
        "nadia district"
      ],
      "city_address_hint": "FHC4+9JJ, Mahatpur, West Bengal 741164, India",
      "url_name": "nadia district",
      "country_name": "India",
      "postal_code": "741164",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 23.4709656,
        "long": 88.55653099999999,
        "details": "FHC4+9JJ, Mahatpur, West Bengal 741164, India",
        "google_place_id": "ChIJ-yLO0Vwg-TkRrUTJdP3vaUQ"
      },
      "bounds": [
        23.011199,
        88.016232,
        23.661477,
        88.801041
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Mahesana",
      "name": "Mahesana",
      "key": "city_mahesana_v2",
      "seo_city_key": "India|Mahesana",
      "customer_city": "city_mahesana_v2",
      "state": "Gujarat",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Mahesana",
        "mahesana",
        "Mahesana"
      ],
      "subcities": [
        "Mahesana"
      ],
      "city_address_hint": "50, સદાનંદ નાગર, ભુવનેશ્વરી ટેબાઉપર, પાંચોટ, મહેસાણા, ગુજરાત 384002, India",
      "url_name": "Mahesana",
      "country_name": "India",
      "postal_code": "384002",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 23.5879607,
        "long": 72.36932519999999,
        "details": "50, સદાનંદ નાગર, ભુવનેશ્વરી ટેબાઉપર, પાંચોટ, મહેસાણા, ગુજરાત 384002, India",
        "google_place_id": "ChIJ9Z54ryxCXDkR3Iu-uJC8Cxc"
      },
      "bounds": [
        23.509224,
        72.244541,
        24.074221,
        72.85238
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Hoshiarpur",
      "name": "Hoshiarpur",
      "key": "city_hoshiarpur_v2",
      "seo_city_key": "India|Hoshiarpur",
      "customer_city": "city_hoshiarpur_v2",
      "state": "Punjab",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Hoshiarpur",
        "hoshiarpur",
        "Hoshiarpur"
      ],
      "subcities": [],
      "city_address_hint": "Marwari, Vijay Nagar, Hoshiarpur, Punjab 146001, India",
      "url_name": "Hoshiarpur",
      "country_name": "India",
      "postal_code": "146001",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 31.5143178,
        "long": 75.911483,
        "details": "Marwari, Vijay Nagar, Hoshiarpur, Punjab 146001, India",
        "google_place_id": "ChIJtV9FpdHiGjkR2pLuhx7jUU0"
      },
      "bounds": [
        31.453634,
        75.656614,
        31.890411,
        76.068614
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Gurdaspur",
      "name": "Gurdaspur",
      "key": "city_gurdaspur_v2",
      "seo_city_key": "India|Gurdaspur",
      "customer_city": "city_gurdaspur_v2",
      "state": "Punjab",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Gurdaspur",
        "gurdaspur",
        "Gurdaspur"
      ],
      "subcities": [],
      "city_address_hint": "Jail Rd, Shaheed Bhagat Singh Nagar, Gurdaspur, Kotli Nangal, Punjab 143521, India",
      "url_name": "Gurdaspur",
      "country_name": "India",
      "postal_code": "143521",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 32.0413917,
        "long": 75.403086,
        "details": "Jail Rd, Shaheed Bhagat Singh Nagar, Gurdaspur, Kotli Nangal, Punjab 143521, India",
        "google_place_id": "ChIJbW6vtG2SGzkRi_mgraua2i8"
      },
      "bounds": [
        31.773411,
        74.930173,
        32.327657,
        75.617493
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "salem",
      "name": "Salem",
      "key": "city_salem_v2",
      "seo_city_key": "India|Salem",
      "customer_city": "city_salem_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Salem",
        "salem",
        "Salem"
      ],
      "subcities": [
        "salem"
      ],
      "city_address_hint": "211, Omalur Main Rd, next to Tanishq Jewellery, Parvathipuram, Indian Bank Colony, Arisipalayam, Salem, Tamil Nadu 636004, India",
      "url_name": "salem",
      "country_name": "India",
      "postal_code": "636005",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 11.664325,
        "long": 78.1460142,
        "details": "211, Omalur Main Rd, next to Tanishq Jewellery, Parvathipuram, Indian Bank Colony, Arisipalayam, Salem, Tamil Nadu 636004, India",
        "google_place_id": "ChIJC7os9czxqzsRR8pocACJme4"
      },
      "bounds": [
        11.408015,
        77.633282,
        12.206817,
        78.614474
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "ranipet",
      "name": "Ranipet",
      "key": "city_ranipet_v2",
      "seo_city_key": "India|Ranipet",
      "customer_city": "city_ranipet_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Ranipet",
        "ranipet",
        "Ranipet"
      ],
      "subcities": [
        "ranipet"
      ],
      "city_address_hint": "2JPH+58 Arakkonam, Tamil Nadu, India",
      "url_name": "ranipet",
      "country_name": "India",
      "postal_code": "631002",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 13.035437,
        "long": 79.628373,
        "details": "2JPH+58 Arakkonam, Tamil Nadu, India",
        "google_place_id": "GhIJ-R151iQSKkARimyMQjfoU0A"
      },
      "bounds": [
        12.850933,
        79.212628,
        13.023039,
        79.406862
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "vellore",
      "name": "VELLORE",
      "key": "city_vellore_v2",
      "seo_city_key": "India|VELLORE",
      "customer_city": "city_vellore_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "VELLORE"
      ],
      "subcities": [
        "VELLORE"
      ],
      "city_address_hint": "17, Officer's Line, Balaji Nagar, Vellore, Tamil Nadu 632001, India",
      "url_name": "vellore",
      "country_name": "India",
      "postal_code": "632001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 12.916797,
        "long": 79.132555,
        "details": "17, Officer's Line, Balaji Nagar, Vellore, Tamil Nadu 632001, India",
        "google_place_id": "ChIJVxuy_Ok4rTsRlRw4E8AWcwc"
      },
      "bounds": [
        12.853874,
        78.992218,
        13.004588,
        79.200994
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Yavatmal",
      "name": "Yavatmal",
      "key": "city_yavatmal_v2",
      "seo_city_key": "India|Yavatmal",
      "customer_city": "city_yavatmal_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Yavatmal",
        "yavatmal",
        "Yavatmal"
      ],
      "subcities": [
        "yavatmal"
      ],
      "city_address_hint": "17/1, Vaishnavi Nagar, Yavatmal, Maharashtra 445001, India",
      "url_name": "Yavatmal",
      "country_name": "India",
      "postal_code": "445001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 20.3899385,
        "long": 78.1306846,
        "details": "17/1, Vaishnavi Nagar, Yavatmal, Maharashtra 445001, India",
        "google_place_id": "ChIJ3U60i8zo0zsR4L7sQeqtd0g"
      },
      "bounds": [
        19.508182,
        77.307959,
        20.527754,
        78.733435
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "chengalpattu",
      "name": "CHENGALPATTU",
      "key": "city_chengalpattu_v2",
      "seo_city_key": "India|chengalpattu",
      "customer_city": "city_chengalpattu_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "chengalpattu"
      ],
      "subcities": [
        "chengalpattu"
      ],
      "city_address_hint": "155b, Maniyam street, near AG church, Alapakkam, Melamaiyur, Chengalpattu, Tamil Nadu 603002, India",
      "url_name": "chengalpattu",
      "country_name": "India",
      "postal_code": "603210",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 12.683552,
        "long": 79.987125,
        "details": "155b, Maniyam street, near AG church, Alapakkam, Melamaiyur, Chengalpattu, Tamil Nadu 603002, India",
        "google_place_id": "ChIJd9D8kj_8UjoR5GJKN2gllMs"
      },
      "bounds": [
        12.24374,
        79.712789,
        12.788292,
        80.276648
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "etawah",
      "name": "Etawah",
      "key": "city_etawah_v2",
      "seo_city_key": "India|Etawah",
      "customer_city": "city_etawah_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Etawah",
        "etawah",
        "Etawah"
      ],
      "subcities": [
        "etawah"
      ],
      "city_address_hint": "76593, near Aryawart Bank, Kashiram Colony, Chogurjee Nagar, Etawah, Uttar Pradesh 206130, India",
      "url_name": "etawah",
      "country_name": "India",
      "postal_code": "206130",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 26.7829103,
        "long": 79.027659,
        "details": "76593, near Aryawart Bank, Kashiram Colony, Chogurjee Nagar, Etawah, Uttar Pradesh 206130, India",
        "google_place_id": "ChIJGWLPhNjfdTkRxQT8TDM2oWo"
      },
      "bounds": [
        26.592337,
        78.863095,
        27.03157,
        79.448012
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Dammam",
      "name": "Dammam",
      "key": "city_dammam_v2",
      "seo_city_key": "Saudi Arabia|Dammam",
      "customer_city": "city_dammam_v2",
      "state": "Eastern Province",
      "country_key": "KSA",
      "country_id": "KSA",
      "regex": [
        "Dammam",
        "dammam",
        "Dammam"
      ],
      "subcities": [],
      "city_address_hint": "C3CQ+7GF, Al Itisalat, Dammam 32257, Saudi Arabia",
      "url_name": "Dammam",
      "country_name": "KSA",
      "postal_code": "32253",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 26.4206828,
        "long": 50.0887943,
        "details": "C3CQ+7GF, Al Itisalat, Dammam 32257, Saudi Arabia",
        "google_place_id": "ChIJAzRrJzIdNj4RdlZeeuwB2e8"
      },
      "bounds": [
        26.029303,
        49.746074,
        26.50852,
        50.239007
      ],
      "offices": [],
      "timezone": "Asia/Riyadh"
    },
    {
      "is_live": true,
      "regex_key": "buraydah",
      "name": "Buraydah",
      "key": "city_buraydah_v2",
      "seo_city_key": "Saudi Arabia|Buraydah",
      "customer_city": "city_buraydah_v2",
      "state": "Al Qassim",
      "country_key": "KSA",
      "country_id": "KSA",
      "regex": [
        "Buraydah",
        "buraydah",
        "Buraydah"
      ],
      "subcities": [
        "buraydah"
      ],
      "city_address_hint": "9X5J+MPV, Buraydah 52367, Saudi Arabia",
      "url_name": "buraydah",
      "country_name": "KSA",
      "postal_code": "52367",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 26.3592309,
        "long": 43.98181200000001,
        "details": "9X5J+MPV, Buraydah 52367, Saudi Arabia",
        "google_place_id": "ChIJd3uBg2ZYfxURYYpZ497BU1g"
      },
      "bounds": [
        25.981348,
        43.689537,
        26.528951,
        44.177914
      ],
      "offices": [],
      "timezone": "Asia/Riyadh"
    },
    {
      "is_live": true,
      "regex_key": "Taif",
      "name": "Taif",
      "key": "city_taif_v2",
      "seo_city_key": "Saudi Arabia|Taif",
      "customer_city": "city_taif_v2",
      "state": "Mecca",
      "country_key": "KSA",
      "country_id": "KSA",
      "regex": [
        "Taif",
        "taif"
      ],
      "subcities": [],
      "city_address_hint": "3139 Al Dammam, 7220, Al Rayyan, At Taif 26523, Saudi Arabia",
      "url_name": "Taif",
      "country_name": "KSA",
      "postal_code": "26513",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 21.2840782,
        "long": 40.42481919999999,
        "details": "3139 Al Dammam, 7220, Al Rayyan, At Taif 26523, Saudi Arabia",
        "google_place_id": "ChIJLz-jsMyO6RURp6IfNOHlP_o"
      },
      "bounds": [
        21.149246,
        40.243838,
        21.599509,
        40.741171
      ],
      "offices": [],
      "timezone": "Asia/Riyadh"
    },
    {
      "is_live": true,
      "regex_key": "sonipat",
      "name": "Sonipat",
      "key": "city_sonipat_v2",
      "seo_city_key": "india|sonipat",
      "customer_city": "city_sonipat_v2",
      "state": "Haryana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "sonipat",
        "Sonipat"
      ],
      "subcities": [
        "sonipat"
      ],
      "city_address_hint": "Civil Hospital, Sonipat",
      "url_name": "sonipat",
      "country_name": "India",
      "postal_code": "131001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 28.99121,
        "long": 77.03655,
        "details": "Civil Hospital, Sonipat",
        "google_place_id": "ChIJUz5Fij6wDTkRG-nMsZnIDAs"
      },
      "bounds": [
        28.947874,
        76.554788,
        29.545826,
        77.431292
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "hassan",
      "name": "Hassan",
      "key": "city_hassan_v2",
      "seo_city_key": "India|Hassan",
      "customer_city": "city_hassan_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Hassan",
        "hassan",
        "Hassan"
      ],
      "subcities": [
        "hassan"
      ],
      "city_address_hint": "83c, Bangalore - Mangalore Rd, Ammeer Mohalla, Hassan, Karnataka 573201, India",
      "url_name": "hassan",
      "country_name": "India",
      "postal_code": "573201",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 13.0033234,
        "long": 76.1003894,
        "details": "83c, Bangalore - Mangalore Rd, Ammeer Mohalla, Hassan, Karnataka 573201, India",
        "google_place_id": "ChIJRyekCyNIpTsRP_Wht7ZP27A"
      },
      "bounds": [
        13.014885,
        75.97003,
        13.465371,
        76.286005
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "ramanagara",
      "name": "Ramanagara",
      "key": "city_ramanagara_v2",
      "seo_city_key": "India|Ramanagara",
      "customer_city": "city_ramanagara_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Ramanagara",
        "ramanagara",
        "Ramanagara"
      ],
      "subcities": [
        "Ramanagara"
      ],
      "city_address_hint": "6360979133 Kumudan Mohalla, Mandipet, Agrahar, Ramanagara, Karnataka 562159, India",
      "url_name": "ramanagara",
      "country_name": "India",
      "postal_code": "562159",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 12.7208614,
        "long": 77.27989629999999,
        "details": "6360979133 Kumudan Mohalla, Mandipet, Agrahar, Ramanagara, Karnataka 562159, India",
        "google_place_id": "ChIJJeRmOthNrjsRCzp0Rh0guMw"
      },
      "bounds": [
        12.39,
        76.339778,
        12.995491,
        77.358713
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Ghazipur",
      "name": "Ghazipur",
      "key": "city_ghazipur_v2",
      "seo_city_key": "India|Ghazipur",
      "customer_city": "city_ghazipur_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Ghazipur",
        "ghazipur",
        "Ghazipur"
      ],
      "subcities": [
        "ghazipur"
      ],
      "city_address_hint": "1425, Phatehpur, Rauza, Chak Bhikhari, Ghazipur, Uttar Pradesh 233001, India",
      "url_name": "Ghazipur",
      "country_name": "India",
      "postal_code": "233001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 25.5877901,
        "long": 83.5783078,
        "details": "1425, Phatehpur, Rauza, Chak Bhikhari, Ghazipur, Uttar Pradesh 233001, India",
        "google_place_id": "ChIJv98LNXj_kTkRhjVQwFEkp8Q"
      },
      "bounds": [
        25.364968,
        83.187618,
        25.970478,
        83.7117
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "samastipur",
      "name": "Samastipur",
      "key": "city_samastipur_v2",
      "seo_city_key": "India|Samastipur",
      "customer_city": "city_samastipur_v2",
      "state": "Bihar",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Samastipur",
        "samastipur",
        "Samastipur"
      ],
      "subcities": [
        "samastipur"
      ],
      "city_address_hint": "11, Sharda Nagar, Samastipur, Bihar 848101, India",
      "url_name": "samastipur",
      "country_name": "India",
      "postal_code": "848101",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 25.8560271,
        "long": 85.7868233,
        "details": "11, Sharda Nagar, Samastipur, Bihar 848101, India",
        "google_place_id": "ChIJ3b1C-5CQ7TkRvTt0hbXbvGc"
      },
      "bounds": [
        25.665868,
        85.626245,
        26.148854,
        86.401933
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "meerut",
      "name": "Meerut",
      "key": "city_meerut_v2",
      "seo_city_key": "india|meerut",
      "customer_city": "city_meerut_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "meerut"
      ],
      "subcities": [
        "meerut",
        "Meerut"
      ],
      "city_address_hint": "Shohrab Gate",
      "url_name": "meerut",
      "country_name": "India",
      "postal_code": "250002",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 28.9817545,
        "long": 77.6924025,
        "details": "Shohrab Gate",
        "google_place_id": "ChIJJWO2V_RkDDkRXr6mhzOo-kI"
      },
      "bounds": [
        28.561444,
        77.623129,
        29.518588,
        78.537479
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "muzaffarpur",
      "name": "Muzaffarpur",
      "key": "city_muzaffarpur_v2",
      "seo_city_key": "India|Muzaffarpur",
      "customer_city": "city_muzaffarpur_v2",
      "state": "Bihar",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Muzaffarpur",
        "muzaffarpur",
        "Muzaffarpur"
      ],
      "subcities": [
        "muzaffarpur"
      ],
      "city_address_hint": "00000 Tamulia, Mahammadpur Kazi, Pokhraira, Muzaffarpur, Bihar 842001, India",
      "url_name": "muzaffarpur",
      "country_name": "India",
      "postal_code": "842001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 26.1196607,
        "long": 85.390982,
        "details": "00000 Tamulia, Mahammadpur Kazi, Pokhraira, Muzaffarpur, Bihar 842001, India",
        "google_place_id": "ChIJKVUXo-gQ7TkRnXUPaBnZwgc"
      },
      "bounds": [
        25.674182,
        85.013398,
        26.412627,
        85.612334
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "naini Tal",
      "name": "Naini Tal",
      "key": "city_naini_tal_v2",
      "seo_city_key": "India|Naini Tal",
      "customer_city": "city_naini_tal_v2",
      "state": "Uttarakhand",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Naini Tal",
        "naini tal",
        "Naini Tal"
      ],
      "subcities": [
        "nainital"
      ],
      "city_address_hint": "9FR3+X96, Mallital, Nainital, Uttarakhand 263001, India",
      "url_name": "naini Tal",
      "country_name": "India",
      "postal_code": "263001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 29.3924139,
        "long": 79.4533773,
        "details": "9FR3+X96, Mallital, Nainital, Uttarakhand 263001, India",
        "google_place_id": "ChIJYZ39KLyhoDkRs32YFql7rnw"
      },
      "bounds": [
        28.99065,
        78.874197,
        29.484467,
        79.623671
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "nashik",
      "name": "Nashik",
      "key": "city_nashik_v2",
      "seo_city_key": "india|nashik",
      "customer_city": "city_nashik_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Nashik",
        "nashik"
      ],
      "subcities": [
        "Nashik",
        "nashik"
      ],
      "city_address_hint": "2QGR+GF Nashik, Maharashtra, India",
      "url_name": "nashik",
      "country_name": "India",
      "postal_code": "422001",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 20.026361,
        "long": 73.791229,
        "details": "2QGR+GF Nashik, Maharashtra, India",
        "google_place_id": "GhIJIeKLm78GNEARLwlhf6NyUkA"
      },
      "bounds": [
        18.799802,
        73.599984,
        20.705315,
        74.857495
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "aurangabad",
      "name": "Aurangabad",
      "key": "city_aurangabad_v2",
      "seo_city_key": "india|aurangabad",
      "customer_city": "city_aurangabad_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "aurangabad",
        "Aurangabad"
      ],
      "subcities": [
        "aurangabad"
      ],
      "city_address_hint": "Kranti Chowk Police Station, Aurangabad",
      "url_name": "aurangabad",
      "country_name": "India",
      "postal_code": "431003",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 19.80904,
        "long": 75.24408,
        "details": "Kranti Chowk Police Station, Aurangabad",
        "google_place_id": "ChIJKyQSU2mY2zsR5jVtghEwn7I"
      },
      "bounds": [
        19.433912,
        75.002381,
        20.255448,
        75.689717
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "jalgaon",
      "name": "Jalgaon",
      "key": "city_jalgaon_v2",
      "seo_city_key": "India|Jalgaon",
      "customer_city": "city_jalgaon_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Jalgaon",
        "jalgaon",
        "Jalgaon"
      ],
      "subcities": [
        "jalgaon"
      ],
      "city_address_hint": "2, Pachora - Jalgaon Rd, Pratap Nagar, Jalgaon, Maharashtra 425003, India",
      "url_name": "jalgaon",
      "country_name": "India",
      "postal_code": "425001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 21.0076578,
        "long": 75.5626039,
        "details": "2, Pachora - Jalgaon Rd, Pratap Nagar, Jalgaon, Maharashtra 425003, India",
        "google_place_id": "ChIJD7nqoaQP2TsRPAr_G9J79jc"
      },
      "bounds": [
        20.553563,
        75.035891,
        21.348622,
        76.400943
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Hazaribagh",
      "name": "Hazaribagh",
      "key": "city_hazaribagh_v2",
      "seo_city_key": "India|Hazaribagh",
      "customer_city": "city_hazaribagh_v2",
      "state": "Jharkhand",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Hazaribagh",
        "hazaribagh",
        "Hazaribagh"
      ],
      "subcities": [],
      "city_address_hint": "X9R7+XFM, Suresh Colony, Hazaribagh, Jharkhand 825301, India",
      "url_name": "Hazaribagh",
      "country_name": "India",
      "postal_code": "825301",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 23.9924669,
        "long": 85.3636758,
        "details": "X9R7+XFM, Suresh Colony, Hazaribagh, Jharkhand 825301, India",
        "google_place_id": "ChIJj1QmTxGc9DkRH5Zhu2joRb0"
      },
      "bounds": [
        23.580508,
        85.142798,
        24.399947,
        85.78537
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "sambalpur",
      "name": "Sambalpur",
      "key": "city_sambalpur_v2",
      "seo_city_key": "India|Sambalpur",
      "customer_city": "city_sambalpur_v2",
      "state": "Odisha",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Sambalpur",
        "sambalpur",
        "Sambalpur"
      ],
      "subcities": [
        "sambalpur"
      ],
      "city_address_hint": "FX8J+PFV, Sakhipara, Sambalpur, Odisha 768001, India",
      "url_name": "sambalpur",
      "country_name": "India",
      "postal_code": "768001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 21.4668716,
        "long": 83.9811665,
        "details": "FX8J+PFV, Sakhipara, Sambalpur, Odisha 768001, India",
        "google_place_id": "ChIJtdl8BH8WIToRVdaE5gukYHY"
      },
      "bounds": [
        21.144951,
        83.215944,
        22.179696,
        84.405041
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Abha",
      "name": "Abha",
      "key": "city_abha_v2",
      "seo_city_key": "Saudi Arabia|Abha",
      "customer_city": "city_abha_v2",
      "state": "'Asir",
      "country_key": "KSA",
      "country_id": "KSA",
      "regex": [
        "Abha",
        "abha",
        "Abha"
      ],
      "subcities": [],
      "city_address_hint": "6GW6+JM4, As Sharafiyah, Abha 62542, Saudi Arabia",
      "url_name": "Abha",
      "country_name": "KSA",
      "postal_code": "62542",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 18.2464685,
        "long": 42.5117238,
        "details": "6GW6+JM4, As Sharafiyah, Abha 62542, Saudi Arabia",
        "google_place_id": "ChIJMQlyFWNU4xURtBmJcYxVd6E"
      },
      "bounds": [
        18.025425,
        42.383194,
        18.419929,
        42.914143
      ],
      "offices": [],
      "timezone": "Asia/Riyadh"
    },
    {
      "is_live": true,
      "regex_key": "udaipur",
      "name": "Udaipur",
      "key": "city_udaipur_v2",
      "seo_city_key": "india|udaipur",
      "customer_city": "city_udaipur_v2",
      "state": "Rajasthan",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "udaipur"
      ],
      "subcities": [
        "Udaipur",
        "udaipur"
      ],
      "city_address_hint": "City Palace, Udaipur",
      "url_name": "udaipur",
      "country_name": "India",
      "postal_code": "313001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 24.577203,
        "long": 73.68351,
        "details": "City Palace, Udaipur",
        "google_place_id": "ChIJ1adZBmTlZzkRDqvq-navV5I"
      },
      "bounds": [
        23.871735,
        73.054808,
        25.31376,
        75.683293
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "jodhpur",
      "name": "Jodhpur",
      "key": "city_jodhpur_v2",
      "seo_city_key": "india|jodhpur",
      "customer_city": "city_jodhpur_v2",
      "state": "Rajasthan",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "jodhpur",
        "Jodhpur"
      ],
      "subcities": [
        "jodhpur"
      ],
      "city_address_hint": "Umaid Bhawan Palace, Jodhpur",
      "url_name": "jodhpur",
      "country_name": "India",
      "postal_code": "342001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 26.281741,
        "long": 73.047345,
        "details": "Umaid Bhawan Palace, Jodhpur",
        "google_place_id": "ChIJ1adZBmTlZzkRDqvq-navV5I"
      },
      "bounds": [
        25.583637,
        71.920211,
        28.990123,
        74.025637
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "nalgonda",
      "name": "Nalgonda",
      "key": "city_nalgonda_v2",
      "seo_city_key": "India|Nalgonda",
      "customer_city": "city_nalgonda_v2",
      "state": "Telangana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Nalgonda",
        "nalgonda",
        "Nalgonda"
      ],
      "subcities": [
        "nalgonda"
      ],
      "city_address_hint": "3759+38Q, Nagarjunar Colony, Nalgonda, Telangana 508001, India",
      "url_name": "nalgonda",
      "country_name": "India",
      "postal_code": "508001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 17.0577054,
        "long": 79.26836229999999,
        "details": "3759+38Q, Nagarjunar Colony, Nalgonda, Telangana 508001, India",
        "google_place_id": "ChIJc-TyC6ApyzsRCWPXk8srcD4"
      },
      "bounds": [
        16.719892,
        78.73601,
        17.426649,
        79.477072
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "moradabad",
      "name": "Moradabad",
      "key": "city_moradabad_v2",
      "seo_city_key": "India|Moradabad",
      "customer_city": "city_moradabad_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Moradabad",
        "moradabad",
        "Moradabad"
      ],
      "subcities": [
        "moradabad"
      ],
      "city_address_hint": "MIG-67 RAM GANGA VIHAR EX. PHASE-2 NEAR DAP MANDIR MARADABAD, Pat Pat Sarai, Moradabad, Uttar Pradesh 244001, India",
      "url_name": "moradabad",
      "country_name": "India",
      "postal_code": "244001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 28.8386481,
        "long": 78.7733286,
        "details": "MIG-67 RAM GANGA VIHAR EX. PHASE-2 NEAR DAP MANDIR MARADABAD, Pat Pat Sarai, Moradabad, Uttar Pradesh 244001, India",
        "google_place_id": "ChIJyUZWL-r7CjkR25hT6eR8ybg"
      },
      "bounds": [
        28.406501,
        78.615932,
        29.198026,
        78.850165
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "kurnool",
      "name": "Kurnool",
      "key": "city_kurnool_v2",
      "seo_city_key": "India|Kurnool",
      "customer_city": "city_kurnool_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Kurnool",
        "kurnool",
        "Kurnool"
      ],
      "subcities": [
        "kurnool"
      ],
      "city_address_hint": "R2HP+7W2, River View Colony, Kurnool, Andhra Pradesh 518004, India",
      "url_name": "kurnool",
      "country_name": "India",
      "postal_code": "518004",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 15.8281257,
        "long": 78.0372792,
        "details": "R2HP+7W2, River View Colony, Kurnool, Andhra Pradesh 518004, India",
        "google_place_id": "ChIJyca3BvXdtTsR8tZY-HSspxk"
      },
      "bounds": [
        15.127521,
        77.137514,
        16.380926,
        78.938656
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "gorakhpur",
      "name": "Gorakhpur",
      "key": "city_gorakhpur_v2",
      "seo_city_key": "India|Gorakhpur",
      "customer_city": "city_gorakhpur_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Gorakhpur",
        "gorakhpur",
        "Gorakhpur"
      ],
      "subcities": [
        "gorakhpur"
      ],
      "city_address_hint": "9FV2+MR9, Head Post Office Rd, Mallital, Nainital, Uttarakhand 263002, India",
      "url_name": "gorakhpur",
      "country_name": "India",
      "postal_code": "273010",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 29.394158,
        "long": 79.452278,
        "details": "9FV2+MR9, Head Post Office Rd, Mallital, Nainital, Uttarakhand 263002, India",
        "google_place_id": "ChIJaxhblZShoDkRdhbK6h5imjM"
      },
      "bounds": [
        26.17123,
        83.060589,
        27.423281,
        84.161968
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "gaya",
      "name": "Gaya",
      "key": "city_gaya_v2",
      "seo_city_key": "India|Gaya",
      "customer_city": "city_gaya_v2",
      "state": "Bihar",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Gaya",
        "gaya",
        "Gaya"
      ],
      "subcities": [
        "gaya"
      ],
      "city_address_hint": "Q2R2+H3G, Nagmatia Colony, Gaya, Bihar 823001, India",
      "url_name": "gaya",
      "country_name": "India",
      "postal_code": "823001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 24.7913957,
        "long": 85.0002336,
        "details": "Q2R2+H3G, Nagmatia Colony, Gaya, Bihar 823001, India",
        "google_place_id": "ChIJHzwbCkQq8zkRpjS_vSOy9s4"
      },
      "bounds": [
        24.463792,
        84.460876,
        25.057256,
        85.33643
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "aligarh",
      "name": "Aligarh",
      "key": "city_aligarh_v2",
      "seo_city_key": "India|Aligarh",
      "customer_city": "city_aligarh_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Aligarh",
        "aligarh",
        "Aligarh"
      ],
      "subcities": [
        "aligarh"
      ],
      "city_address_hint": "I145, Begpur, Kasimpur Power House Colony, Aligarh, Uttar Pradesh 202001, India",
      "url_name": "aligarh",
      "country_name": "India",
      "postal_code": "202001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 27.8973944,
        "long": 78.0880129,
        "details": "I145, Begpur, Kasimpur Power House Colony, Aligarh, Uttar Pradesh 202001, India",
        "google_place_id": "ChIJi5xFhoakdDkREzYybSdn2ZU"
      },
      "bounds": [
        27.295768,
        77.256859,
        28.195197,
        78.54971
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "raigad",
      "name": "raigad",
      "key": "city_murud_(raigad)_v2",
      "seo_city_key": "India|Raigad",
      "customer_city": "city_murud_(raigad)_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "raigad"
      ],
      "subcities": [
        "raigad"
      ],
      "city_address_hint": "Near, Beach Rd, Murud, Maharashtra 402401, India",
      "url_name": "raigad",
      "country_name": "India",
      "postal_code": "402401",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 18.331926,
        "long": 72.9608202,
        "details": "Near, Beach Rd, Murud, Maharashtra 402401, India",
        "google_place_id": "ChIJd_v8spFD6DsR-fbJM21_LAY"
      },
      "bounds": [
        17.894197,
        72.856751,
        18.868919,
        73.576871
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "nalanda",
      "name": "Nalanda",
      "key": "city_nalanda_v2",
      "seo_city_key": "India|Nalanda",
      "customer_city": "city_nalanda_v2",
      "state": "Bihar",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Nalanda",
        "nalanda",
        "Nalanda"
      ],
      "subcities": [
        "nalanda"
      ],
      "city_address_hint": "7F6H+VGF, Bihar 803118, India",
      "url_name": "nalanda",
      "country_name": "India",
      "postal_code": "803118",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 25.2621826,
        "long": 85.47880649999999,
        "details": "7F6H+VGF, Bihar 803118, India",
        "google_place_id": "ChIJWzXTxKX08jkRBvmewGrDf4c"
      },
      "bounds": [
        24.998132,
        85.350685,
        25.436086,
        85.832011
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "kalaburgi",
      "name": "Kalaburgi",
      "key": "city_kalaburgi_v2",
      "seo_city_key": "India|Kalaburgi",
      "customer_city": "city_kalaburgi_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Kalaburgi",
        "kalaburgi",
        "Kalaburgi"
      ],
      "subcities": [
        "kalaburgi"
      ],
      "city_address_hint": "37, Public Garden Rd, Mahaveer Nagar, Halbarga, Brhampur, Kalaburagi, Karnataka 585105, India",
      "url_name": "kalaburgi",
      "country_name": "India",
      "postal_code": "585105",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 17.329731,
        "long": 76.8342957,
        "details": "37, Public Garden Rd, Mahaveer Nagar, Halbarga, Brhampur, Kalaburagi, Karnataka 585105, India",
        "google_place_id": "ChIJV06CW0XHyDsRn-1XaTbjy0Q"
      },
      "bounds": [
        16.939424,
        76.381406,
        17.656622,
        77.654843
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "mumbai",
      "name": "Mumbai",
      "key": "city_mumbai_v2",
      "seo_city_key": "india|mumbai",
      "customer_city": "city_mumbai_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "mumbai",
        "bombay",
        "navi mumbai",
        "navi-mumbai",
        "navi_mumbai",
        "thane",
        "mira bhayandar",
        "dombivli",
        "kalyan",
        "nilje gaon",
        "nilje-gaon",
        "nilje_gaon",
        "nala sopara",
        "nalasopara",
        "virar",
        "vasai",
        "naigaon"
      ],
      "subcities": [
        "Mumbai",
        "Thane",
        "Navi-Mumbai",
        "mumbai",
        "thane",
        "navi-mumbai",
        "Mira Bhayandar",
        "Dombivli",
        "Kalyan",
        "Nilje Gaon",
        "Nala Sopara",
        "Nalasopara",
        "Virar",
        "Vasai",
        "Naigaon"
      ],
      "city_address_hint": "Dadar, Mumbai",
      "url_name": "mumbai",
      "country_name": "India",
      "postal_code": "400071",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 19.021324,
        "long": 72.84241779999999,
        "details": "Dadar, Mumbai",
        "google_place_id": "ChIJD82gDtvO5zsR0FuZOVBGikI"
      },
      "bounds": [
        18.879368,
        72.667687,
        19.64772,
        73.379726
      ],
      "offices": [
        {
          "name": "Sion",
          "is_live": false,
          "address": "Urbanclap Technologies India Pvt Ltd Unit Nos. 1101 and 1102, 11th Floor in C Wing “Godrej Coliseum” C.T.S. No.638(part) of Kurla Village, Lokmanya Pan Bazaar, behind Everard Nagar, Sion (East), Mumbai – 400 022",
          "subcities": [
            "Mumbai",
            "Navi-Mumbai"
          ],
          "office_type": [
            "business",
            "corporate",
            "support",
            "training"
          ],
          "location_mapping": {
            "lat": 19.050042,
            "long": 72.8765241
          }
        },
        {
          "name": "Mumbai",
          "is_live": true,
          "address": "Urbanclap Technologies India Pvt Ltd, 2nd Floor, Mehra Estate, CTS No. 69, 69/1 to 52, L.B.S Marg, Vikhroli (West), Mumbai, Maharashtra 400079",
          "subcities": [
            "Mumbai"
          ],
          "office_type": [
            "business",
            "corporate",
            "support",
            "training"
          ],
          "location_mapping": {
            "lat": 28.50816,
            "long": 77.08999
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Nawada",
      "name": "Nawada",
      "key": "city_nawada_v2",
      "seo_city_key": "India|Nawada",
      "customer_city": "city_nawada_v2",
      "state": "Bihar",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Nawada",
        "nawada",
        "Nawada"
      ],
      "subcities": [],
      "city_address_hint": "VGPV+M9G, Nawada, Bihar 805111, India",
      "url_name": "Nawada",
      "country_name": "India",
      "postal_code": "805111",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 24.8866859,
        "long": 85.54345719999999,
        "details": "VGPV+M9G, Nawada, Bihar 805111, India",
        "google_place_id": "ChIJL_sSCF3-8jkRVp4sU0nxYLU"
      },
      "bounds": [
        24.580924,
        85.420804,
        24.997377,
        85.813479
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "jhansi",
      "name": "Jhansi",
      "key": "city_jhansi_v2",
      "seo_city_key": "India|Jhansi",
      "customer_city": "city_jhansi_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Jhansi",
        "jhansi",
        "Jhansi"
      ],
      "subcities": [
        "jhansi"
      ],
      "city_address_hint": "कुंज बिहारी मंदिर के पास आँटिया तालाब, Prathvipur, Civil Lines, Jhansi, Jhansi Rly. Settl, Uttar Pradesh 284001, India",
      "url_name": "jhansi",
      "country_name": "India",
      "postal_code": "284001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 25.4484257,
        "long": 78.5684594,
        "details": "कुंज बिहारी मंदिर के पास आँटिया तालाब, Prathvipur, Civil Lines, Jhansi, Jhansi Rly. Settl, Uttar Pradesh 284001, India",
        "google_place_id": "ChIJA3e6WNR2dzkRyoE0XKXN6ZY"
      },
      "bounds": [
        25.23142,
        78.346253,
        25.936126,
        79.226017
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "jalandhar",
      "name": "Jalandhar",
      "key": "city_jalandhar_v2",
      "seo_city_key": "India|Jalandhar",
      "customer_city": "city_jalandhar_v2",
      "state": "Punjab",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Jalandhar",
        "jalandhar",
        "Jalandhar"
      ],
      "subcities": [
        "jalandhar"
      ],
      "city_address_hint": "198, Fatehpur, Civil Line, Jalandhar, Makhdoom Pura, Punjab 144001, India",
      "url_name": "jalandhar",
      "country_name": "India",
      "postal_code": "144001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 31.3260152,
        "long": 75.57618289999999,
        "details": "198, Fatehpur, Civil Line, Jalandhar, Makhdoom Pura, Punjab 144001, India",
        "google_place_id": "ChIJkeupR1daGjkRuLSlWsA0S8c"
      },
      "bounds": [
        31.10317,
        75.186567,
        31.41886,
        75.747214
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "baleshwar",
      "name": "Baleshwar",
      "key": "city_baleshwar_v2",
      "seo_city_key": "India|Baleshwar",
      "customer_city": "city_baleshwar_v2",
      "state": "Odisha",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Baleshwar",
        "baleshwar",
        "Baleshwar"
      ],
      "subcities": [
        "baleshwar"
      ],
      "city_address_hint": "FWV7+89 Balasore, Odisha, India",
      "url_name": "baleshwar",
      "country_name": "India",
      "postal_code": "756060",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 21.4933578,
        "long": 86.9134794,
        "details": "FWV7+89 Balasore, Odisha, India",
        "google_place_id": "ChIJNeA28IRfHDoRfBVwHL8y01w"
      },
      "bounds": [
        20.748307,
        85.183278,
        22.596209,
        87.110088
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "ysr",
      "name": "Y.S.R",
      "key": "city_kadapa_v2",
      "seo_city_key": "India|ysr",
      "customer_city": "city_kadapa_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "ysr"
      ],
      "subcities": [
        "ysr"
      ],
      "city_address_hint": "2/417, Maria Puram, Nagarajupeta, Kadapa, Andhra Pradesh 516001, India",
      "url_name": "ysr",
      "country_name": "India",
      "postal_code": "516001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 14.467722,
        "long": 78.823595,
        "details": "2/417, Maria Puram, Nagarajupeta, Kadapa, Andhra Pradesh 516001, India",
        "google_place_id": "ChIJyX5hcBFyszsRzResEfLKkc4"
      },
      "bounds": [
        13.824788,
        78.166909,
        15.053102,
        79.312363
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "mysore",
      "name": "Mysore",
      "key": "city_mysore_v2",
      "seo_city_key": "india|mysore",
      "customer_city": "city_mysore_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "mysore",
        "Mysore"
      ],
      "subcities": [
        "mysore"
      ],
      "city_address_hint": "Mysore Palace, Mysore",
      "url_name": "mysore",
      "country_name": "India",
      "postal_code": "570001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 12.305163,
        "long": 76.6529862,
        "details": "Mysore Palace, Mysore",
        "google_place_id": "ChIJ-aH5AxFwrzsRDdokoeK6f8M"
      },
      "bounds": [
        12.18124,
        76.47574,
        12.383169,
        76.719693
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "ajmer",
      "name": "Ajmer",
      "key": "city_ajmer_v2",
      "seo_city_key": "India|Ajmer",
      "customer_city": "city_ajmer_v2",
      "state": "Rajasthan",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Ajmer",
        "ajmer",
        "Ajmer"
      ],
      "subcities": [
        "ajmer"
      ],
      "city_address_hint": "CJXQ+XX3, Nalasopra, Subhash Nagar, Ajmer, Rajasthan 305001, India",
      "url_name": "ajmer",
      "country_name": "India",
      "postal_code": "305001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 26.4498954,
        "long": 74.6399163,
        "details": "CJXQ+XX3, Nalasopra, Subhash Nagar, Ajmer, Rajasthan 305001, India",
        "google_place_id": "ChIJAc23_NjmazkR7gCB6xKPr8s"
      },
      "bounds": [
        25.925153,
        74.55007,
        26.699587,
        75.28166
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "patna",
      "name": "Patna",
      "key": "city_patna_v2",
      "seo_city_key": "india|patna",
      "customer_city": "city_patna_v2",
      "state": "Bihar",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "patna",
        "Patna",
        "Patliputra",
        "patliputra"
      ],
      "subcities": [
        "patna",
        "Patna",
        "Patliputra",
        "patliputra"
      ],
      "city_address_hint": "S/9, Fraser Road, Budh Vihar, Fraser Road Area, Patna, Bihar 800001, India",
      "url_name": "patna",
      "country_name": "India",
      "postal_code": "800001",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 25.60806,
        "long": 85.137729,
        "details": "S/9, Fraser Road, Budh Vihar, Fraser Road Area, Patna, Bihar 800001, India",
        "google_place_id": "ChIJWTL7Ml1Y7TkReQwocOKcQsY"
      },
      "bounds": [
        25.44553,
        84.80473,
        25.655621,
        85.276428
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "begusarai",
      "name": "Begusarai",
      "key": "city_begusarai_v2",
      "seo_city_key": "India|Begusarai",
      "customer_city": "city_begusarai_v2",
      "state": "Bihar",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Begusarai",
        "begusarai",
        "Begusarai"
      ],
      "subcities": [
        "begusarai"
      ],
      "city_address_hint": "Collegiate Rd, Vasant Vihar, Begusarai, Makhsaspur, Bihar 851101, India",
      "url_name": "begusarai",
      "country_name": "India",
      "postal_code": "851101",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 25.4181638,
        "long": 86.1271542,
        "details": "Collegiate Rd, Vasant Vihar, Begusarai, Makhsaspur, Bihar 851101, India",
        "google_place_id": "ChIJPVAc188a8jkRWK41dqe8PrY"
      },
      "bounds": [
        24.983737,
        85.839764,
        25.651768,
        86.66007
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "guntur",
      "name": "Guntur",
      "key": "city_guntur_v2",
      "seo_city_key": "india|guntur",
      "customer_city": "city_guntur_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "guntur",
        "Guntur"
      ],
      "subcities": [
        "guntur"
      ],
      "city_address_hint": "The Chennai Shopping Mall, Guntur",
      "url_name": "guntur",
      "country_name": "India",
      "postal_code": "522002",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 16.307974,
        "long": 80.43697,
        "details": "The Chennai Shopping Mall, Guntur",
        "google_place_id": "ChIJR88jlVx1SjoRCWKZ2ZVxlkk"
      },
      "bounds": [
        16.257651,
        80.386821,
        16.345961,
        80.487069
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "vijayawada",
      "name": "Vijayawada",
      "key": "city_vijayawada_v2",
      "seo_city_key": "india|vijayawada",
      "customer_city": "city_vijayawada_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "vijayawada"
      ],
      "subcities": [
        "vijayawada",
        "Vijayawada"
      ],
      "city_address_hint": "PVR Ripples",
      "url_name": "vijayawada",
      "country_name": "India",
      "postal_code": "520010",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 16.5011,
        "long": 80.6436,
        "details": "PVR Ripples",
        "google_place_id": "ChIJS5QtSPnvNToRZQJKq4R-m5M"
      },
      "bounds": [
        16.426042,
        80.52211,
        16.735035,
        80.874964
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "firozabad",
      "name": "Firozabad",
      "key": "city_firozabad_v2",
      "seo_city_key": "India|Firozabad",
      "customer_city": "city_firozabad_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Firozabad",
        "firozabad",
        "Firozabad"
      ],
      "subcities": [
        "firozabad"
      ],
      "city_address_hint": "10A, Vibhav Nagar, Arya Nagar, Firozabad, Uttar Pradesh 283203, India",
      "url_name": "firozabad",
      "country_name": "India",
      "postal_code": "283203",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 27.1591961,
        "long": 78.3957331,
        "details": "10A, Vibhav Nagar, Arya Nagar, Firozabad, Uttar Pradesh 283203, India",
        "google_place_id": "ChIJkem9cphGdDkR7qwRjDpmhN8"
      },
      "bounds": [
        26.969844,
        78.209105,
        27.279164,
        78.81218
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Vijayapura",
      "name": "Vijayapura",
      "key": "city_vijayapura_v2",
      "seo_city_key": "India|Vijayapura",
      "customer_city": "city_vijayapura_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Vijayapura",
        "vijayapura",
        "Vijayapura"
      ],
      "subcities": [],
      "city_address_hint": "Sahu Nagar, RPJ5+7X3, Upali Burj Area, Vijayapura, Karnataka 586101, India",
      "url_name": "Vijayapura",
      "country_name": "India",
      "postal_code": "586101",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 16.830652,
        "long": 75.709912,
        "details": "Sahu Nagar, RPJ5+7X3, Upali Burj Area, Vijayapura, Karnataka 586101, India",
        "google_place_id": "ChIJLwIox4H_xjsRuJgr-sNyJr4"
      },
      "bounds": [
        16.559285,
        75.491267,
        17.142594,
        76.093497
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Karnataka_Central",
      "name": "Karnataka_Central",
      "key": "city_karnataka_central_v2",
      "seo_city_key": "India|Karnataka_Central",
      "customer_city": "city_karnataka_central_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Belagavi",
        "Ballari",
        "Vijayapura",
        "Bagalkote",
        "Hubbali"
      ],
      "subcities": [
        "Belagavi",
        "ballari",
        "Bagalkote",
        "Hubballi",
        "Vijayapura"
      ],
      "city_address_hint": "Postmaster, Post Office HUBLI (HEAD OFFICE), DHARWAD, KARNATAKA (KA), India (IN)",
      "url_name": "Karnataka_Central",
      "country_name": "India",
      "postal_code": "580020",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 11.70817,
        "long": 92.7211179,
        "details": "Postmaster, Post Office HUBLI (HEAD OFFICE), DHARWAD, KARNATAKA (KA), India (IN)",
        "google_place_id": "ChIJxVYP_Dq-iDARSdQXYYX4Og4"
      },
      "bounds": [
        14.590013,
        74.317884,
        16.554389,
        77.096475
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "anantapur",
      "name": "Anantapur",
      "key": "city_anantapur_v2",
      "seo_city_key": "India|Anantapur",
      "customer_city": "city_anantapur_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Anantapur",
        "anantapur",
        "Anantapur"
      ],
      "subcities": [
        "anantapur"
      ],
      "city_address_hint": "1-1348-1, opposite Sakshi Office, Kamalanagar, Anantapur, Andhra Pradesh 515001, India",
      "url_name": "anantapur",
      "country_name": "India",
      "postal_code": "515001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 14.6818877,
        "long": 77.6005911,
        "details": "1-1348-1, opposite Sakshi Office, Kamalanagar, Anantapur, Andhra Pradesh 515001, India",
        "google_place_id": "ChIJN09A5sJKsTsR6HDO4mTQELg"
      },
      "bounds": [
        13.982699,
        77.171766,
        15.118533,
        78.130631
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "ballia",
      "name": "Ballia",
      "key": "city_ballia_v2",
      "seo_city_key": "India|Ballia",
      "customer_city": "city_ballia_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Ballia",
        "ballia",
        "Ballia"
      ],
      "subcities": [
        "ballia"
      ],
      "city_address_hint": "1, Ballia, Uttar Pradesh 243402, India",
      "url_name": "ballia",
      "country_name": "India",
      "postal_code": "243402",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 28.2006882,
        "long": 79.3651914,
        "details": "1, Ballia, Uttar Pradesh 243402, India",
        "google_place_id": "ChIJjyY9hJpVdTkRTJRLokzn2EA"
      },
      "bounds": [
        25.733716,
        83.734009,
        26.139902,
        84.319266
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "sundargarh",
      "name": "Sundargarh",
      "key": "city_sundargarh_v2",
      "seo_city_key": "India|Sundargarh",
      "customer_city": "city_sundargarh_v2",
      "state": "Odisha",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Sundargarh",
        "sundargarh",
        "Sundargarh"
      ],
      "subcities": [
        "sundargarh"
      ],
      "city_address_hint": "42CP+2V4, Sundargarh, Odisha 770001, India",
      "url_name": "sundargarh",
      "country_name": "India",
      "postal_code": "770001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 22.120021,
        "long": 84.037224,
        "details": "42CP+2V4, Sundargarh, Odisha 770001, India",
        "google_place_id": "ChIJX_tU17fsIDoRbGMU_kbrMdQ"
      },
      "bounds": [
        21.932187,
        84.64358,
        22.049123,
        84.766995
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "ujjain",
      "name": "Ujjain",
      "key": "city_ujjain_v2",
      "seo_city_key": "India|Ujjain",
      "customer_city": "city_ujjain_v2",
      "state": "Madhya Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Ujjain",
        "ujjain",
        "Ujjain"
      ],
      "subcities": [
        "ujjain"
      ],
      "city_address_hint": "127, agrsen nahar, Magalcolony, Ujjain, Madhya Pradesh 456010, India",
      "url_name": "ujjain",
      "country_name": "India",
      "postal_code": "456010",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 23.1764665,
        "long": 75.7885163,
        "details": "127, agrsen nahar, Magalcolony, Ujjain, Madhya Pradesh 456010, India",
        "google_place_id": "ChIJI_8A3ml0YzkREtSZeN-rgn8"
      },
      "bounds": [
        22.843314,
        75.303512,
        23.749958,
        76.384313
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "tumakuru",
      "name": "Tumakuru",
      "key": "city_tumakuru_v2",
      "seo_city_key": "India|Tumakuru",
      "customer_city": "city_tumakuru_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Tumakuru",
        "tumakuru",
        "Tumakuru"
      ],
      "subcities": [
        "tumakuru"
      ],
      "city_address_hint": "84Q8+5W4, Sri Shivakumaraswamiji Circle, S.S.Puram, Tumakuru, Karnataka 572103, India",
      "url_name": "tumakuru",
      "country_name": "India",
      "postal_code": "572103",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 13.3378762,
        "long": 77.117325,
        "details": "84Q8+5W4, Sri Shivakumaraswamiji Circle, S.S.Puram, Tumakuru, Karnataka 572103, India",
        "google_place_id": "ChIJuSMuYzsssDsRuzfX6TmyX-E"
      },
      "bounds": [
        13.230504,
        76.349058,
        13.733168,
        77.343191
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Bidar",
      "name": "Bidar",
      "key": "city_bidar_v2",
      "seo_city_key": "India|Bidar",
      "customer_city": "city_bidar_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Bidar",
        "bidar",
        "Bidar"
      ],
      "subcities": [],
      "city_address_hint": "WG69+5X3, Nandi Colony, Bidar, Karnataka 585401, India",
      "url_name": "Bidar",
      "country_name": "India",
      "postal_code": "585401",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 17.9103939,
        "long": 77.51990789999999,
        "details": "WG69+5X3, Nandi Colony, Bidar, Karnataka 585401, India",
        "google_place_id": "ChIJ5YyQ1iLHzjsRbP-tAG4bp7k"
      },
      "bounds": [
        17.656657,
        76.927292,
        18.334838,
        77.545445
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "ganjam",
      "name": "Ganjam",
      "key": "city_ganjam_v2",
      "seo_city_key": "India|Ganjam",
      "customer_city": "city_ganjam_v2",
      "state": "Odisha",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Ganjam",
        "ganjam",
        "Ganjam"
      ],
      "subcities": [
        "ganjam"
      ],
      "city_address_hint": "93P2+RWW, Ganjam, Odisha 761026, India",
      "url_name": "ganjam",
      "country_name": "India",
      "postal_code": "761120",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 19.3871214,
        "long": 85.05233559999999,
        "details": "93P2+RWW, Ganjam, Odisha 761026, India",
        "google_place_id": "ChIJ28-RR8j7FzoRxhTp5xWaTmY"
      },
      "bounds": [
        19.163783,
        84.456188,
        20.09329,
        85.134681
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "dehradun",
      "name": "Dehradun",
      "key": "city_dehradun_v2",
      "seo_city_key": "india|dehradun",
      "customer_city": "city_dehradun_v2",
      "state": "Uttarakhand",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "dehradun"
      ],
      "subcities": [
        "dehradun"
      ],
      "city_address_hint": "Doon Hospital",
      "url_name": "dehradun",
      "country_name": "India",
      "postal_code": "248001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 30.4712267,
        "long": 77.111402,
        "details": "Doon Hospital",
        "google_place_id": "ChIJr4jIVsMpCTkRmYdRMsBiNUw"
      },
      "bounds": [
        29.678743,
        77.390698,
        30.50396,
        78.360956
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "sikar",
      "name": "Sikar",
      "key": "city_sikar_v2",
      "seo_city_key": "India|Sikar",
      "customer_city": "city_sikar_v2",
      "state": "Rajasthan",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Sikar",
        "sikar",
        "Sikar"
      ],
      "subcities": [
        "SIKAR"
      ],
      "city_address_hint": "Sawaliya Circle (Bypass Sikhar), Subhash Chowk, Sikar, Rajasthan 332001, India",
      "url_name": "sikar",
      "country_name": "India",
      "postal_code": "332001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 27.6093912,
        "long": 75.1397935,
        "details": "Sawaliya Circle (Bypass Sikhar), Subhash Chowk, Sikar, Rajasthan 332001, India",
        "google_place_id": "ChIJK0c0I7ikbDkRVfNrOs5cSH8"
      },
      "bounds": [
        27.219909,
        74.916801,
        28.279817,
        75.905082
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Namakkal",
      "name": "Namakkal",
      "key": "city_namakkal_v2",
      "seo_city_key": "India|Namakkal",
      "customer_city": "city_namakkal_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Namakkal",
        "namakkal",
        "Namakkal"
      ],
      "subcities": [
        "namakkal"
      ],
      "city_address_hint": "மேலே திடுமல் கரிய காளியம்மன் கோவில், 2/120, THOTTIPALAYAM T, GOUNDAMPALAYAM, Kabilarmalai, Namakkal, Tamil Nadu 637204, India",
      "url_name": "Namakkal",
      "country_name": "India",
      "postal_code": "637014",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 11.2193848,
        "long": 78.16784179999999,
        "details": "மேலே திடுமல் கரிய காளியம்மன் கோவில், 2/120, THOTTIPALAYAM T, GOUNDAMPALAYAM, Kabilarmalai, Namakkal, Tamil Nadu 637204, India",
        "google_place_id": "ChIJTwEiP17OqzsRd0rDMu-Jq6A"
      },
      "bounds": [
        11.086566,
        78.021074,
        11.396264,
        78.314759
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Palghar",
      "name": "Palghar",
      "key": "city_palghar_v2",
      "seo_city_key": "India|Palghar",
      "customer_city": "city_palghar_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Palghar",
        "palghar",
        "Palghar"
      ],
      "subcities": [
        "PALGHAR"
      ],
      "city_address_hint": "MQW9+MXM, Mahim Rd, Punit Nagar, Vishnu Nagar, Palghar, Maharashtra 401404, India",
      "url_name": "Palghar",
      "country_name": "India",
      "postal_code": "401404",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 19.6967136,
        "long": 72.769885,
        "details": "MQW9+MXM, Mahim Rd, Punit Nagar, Vishnu Nagar, Palghar, Maharashtra 401404, India",
        "google_place_id": "ChIJd8Hdo94c5zsRJB2WKTaRK9s"
      },
      "bounds": [
        19.666299,
        72.582336,
        19.984509,
        73.140664
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Cachar",
      "name": "Cachar",
      "key": "city_cachar_v2",
      "seo_city_key": "India|Cachar",
      "customer_city": "city_cachar_v2",
      "state": "Assam",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Cachar",
        "cachar",
        "Cachar"
      ],
      "subcities": [],
      "city_address_hint": "QVJ5+V34, Bagpur Pt II, Assam 788101, India",
      "url_name": "Cachar",
      "country_name": "India",
      "postal_code": "788101",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 24.7821253,
        "long": 92.8577105,
        "details": "QVJ5+V34, Bagpur Pt II, Assam 788101, India",
        "google_place_id": "ChIJa1jJlXhKTjcR6Nk1p8A1HZI"
      },
      "bounds": [
        24.569206,
        92.431591,
        25.109776,
        93.190221
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "West Tripura",
      "name": "West Tripura",
      "key": "city_west_tripura_v2",
      "seo_city_key": "India|West Tripura",
      "customer_city": "city_west_tripura_v2",
      "state": "Tripura",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "West Tripura",
        "west tripura",
        "West Tripura"
      ],
      "subcities": [],
      "city_address_hint": "VCX3+VWG, Sibnagar, Tripura 799210, India",
      "url_name": "West Tripura",
      "country_name": "India",
      "postal_code": "799210",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 23.899682,
        "long": 91.4048249,
        "details": "VCX3+VWG, Sibnagar, Tripura 799210, India",
        "google_place_id": "ChIJ-_qVchP0UzcRHKwroj1Ylds"
      },
      "bounds": [
        23.737797,
        91.213949,
        23.98358,
        91.546685
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "krishnagiri",
      "name": "Krishnagiri",
      "key": "city_krishnagiri_v2",
      "seo_city_key": "India|Krishnagiri",
      "customer_city": "city_krishnagiri_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Krishnagiri",
        "krishnagiri",
        "Krishnagiri"
      ],
      "subcities": [
        "krishnagiri"
      ],
      "city_address_hint": "G6G7+JXG, Old Pet, Krishnagiri, Tamil Nadu 635001, India",
      "url_name": "krishnagiri",
      "country_name": "India",
      "postal_code": "635001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 12.5265661,
        "long": 78.2149575,
        "details": "G6G7+JXG, Old Pet, Krishnagiri, Tamil Nadu 635001, India",
        "google_place_id": "ChIJQXB4a5M0rDsR2zWYAgfJR4Q"
      },
      "bounds": [
        12.5252171197085,
        78.21360851970849,
        12.5279150802915,
        78.2163064802915
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "sangareddi",
      "name": "Sangareddi",
      "key": "city_sangareddi_v2",
      "seo_city_key": "India|Sangareddi",
      "customer_city": "city_sangareddi_v2",
      "state": "Telangana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Sangareddi",
        "sangareddi",
        "Sangareddi"
      ],
      "subcities": [
        "Sangareddi"
      ],
      "city_address_hint": "J35H+2W4, Prashant Nagar Colony, Prashanth Nagar Colony, Balaji Nagar, Sangareddy, Telangana 502001, India",
      "url_name": "sangareddi",
      "country_name": "India",
      "postal_code": "502001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 17.6075232,
        "long": 78.0798191,
        "details": "J35H+2W4, Prashant Nagar Colony, Prashanth Nagar Colony, Balaji Nagar, Sangareddy, Telangana 502001, India",
        "google_place_id": "ChIJnVpiwLj5yzsRGU8GN1uTSzM"
      },
      "bounds": [
        17.587785,
        78.048906,
        17.635716,
        78.096677
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "palakkad district",
      "name": "Palakkad district",
      "key": "city_palakkad_district_v2",
      "seo_city_key": "India|Palakkad district",
      "customer_city": "city_palakkad_district_v2",
      "state": "Kerala",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Palakkad district",
        "palakkad district",
        "Palakkad district"
      ],
      "subcities": [
        "palakkad"
      ],
      "city_address_hint": "XG2X+GG4, Kerala 678591, India",
      "url_name": "palakkad district",
      "country_name": "India",
      "postal_code": "678591",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 10.9512736,
        "long": 76.5488232,
        "details": "XG2X+GG4, Kerala 678591, India",
        "google_place_id": "ChIJWQs2Ju9tqDsRmbA67dugBGc"
      },
      "bounds": [
        10.766182,
        76.378781,
        10.961997,
        76.832004
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "puducherry",
      "name": "Puducherry",
      "key": "city_puducherry_v2",
      "seo_city_key": "India|Puducherry",
      "customer_city": "city_puducherry_v2",
      "state": "Puducherry",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Puducherry",
        "puducherry",
        "Puducherry"
      ],
      "subcities": [
        "Puducherry"
      ],
      "city_address_hint": "Pondicherry, Aruthra Nagar, Puducherry, 605009, India",
      "url_name": "puducherry",
      "country_name": "India",
      "postal_code": "605009",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 11.9415915,
        "long": 79.8083133,
        "details": "Pondicherry, Aruthra Nagar, Puducherry, 605009, India",
        "google_place_id": "ChIJz89JjqthUzoRTrDw0ibTa8w"
      },
      "bounds": [
        11.828952,
        79.60953,
        12.174518,
        80.011068
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "saran",
      "name": "Saran",
      "key": "city_saran_v2",
      "seo_city_key": "India|Saran",
      "customer_city": "city_saran_v2",
      "state": "Bihar",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Saran",
        "saran",
        "Saran"
      ],
      "subcities": [
        "saran"
      ],
      "city_address_hint": "VV44+9P Saiki, Bihar, India",
      "url_name": "saran",
      "country_name": "India",
      "postal_code": "841301",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 25.8559698,
        "long": 84.8567932,
        "details": "VV44+9P Saiki, Bihar, India",
        "google_place_id": "ChIJMUm2Xia7kjkRcjw9CoDga7s"
      },
      "bounds": [
        25.90215,
        84.825012,
        26.035732,
        85.005223
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Dakshina Kannada",
      "name": "Dakshina Kannada",
      "key": "city_dakshina_kannada_v2",
      "seo_city_key": "India|Dakshina Kannada",
      "customer_city": "city_dakshina_kannada_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Dakshina Kannada",
        "dakshina kannada",
        "Dakshina Kannada"
      ],
      "subcities": [
        "dakshin kannada"
      ],
      "city_address_hint": "R6VX+G56, Uppinangady, Karnataka 574241, India",
      "url_name": "Dakshina Kannada",
      "country_name": "India",
      "postal_code": "574241",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 12.8437814,
        "long": 75.2479061,
        "details": "R6VX+G56, Uppinangady, Karnataka 574241, India",
        "google_place_id": "ChIJvxb9K01aozsRXPsrJAvQjS8"
      },
      "bounds": [
        12.71474,
        75.100429,
        12.984517,
        75.450915
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "tiruchirappalli",
      "name": "Tiruchirappalli",
      "key": "city_tiruchirappalli_v2",
      "seo_city_key": "india|tiruchirappalli",
      "customer_city": "city_tiruchirappalli_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "tiruchirappalli",
        "Tiruchirappalli"
      ],
      "subcities": [
        "tiruchirappalli"
      ],
      "city_address_hint": "DMart Trichy, Tiruchirappalli",
      "url_name": "tiruchirappalli",
      "country_name": "India",
      "postal_code": "620008",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 10.806496,
        "long": 78.709497,
        "details": "DMart Trichy, Tiruchirappalli",
        "google_place_id": "ChIJ4wD_8hD1qjsRi3Kx23c160Y"
      },
      "bounds": [
        10.64498,
        78.545168,
        10.949676,
        78.850209
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Kolar",
      "name": "Kolar",
      "key": "city_kolar_v2",
      "seo_city_key": "India|Kolar",
      "customer_city": "city_kolar_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Kolar",
        "kolar",
        "Kolar"
      ],
      "subcities": [
        "kolar"
      ],
      "city_address_hint": "Antharagange Main Rd, Kuvempu Nagar, Kolar, Karnataka 563101, India",
      "url_name": "Kolar",
      "country_name": "India",
      "postal_code": "563101",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 13.1362143,
        "long": 78.12909859999999,
        "details": "Antharagange Main Rd, Kuvempu Nagar, Kolar, Karnataka 563101, India",
        "google_place_id": "ChIJzayVlYvwrTsR0PP9J1ST70M"
      },
      "bounds": [
        12.876823,
        77.945466,
        13.362356,
        78.422042
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "nizamabad",
      "name": "Nizamabad",
      "key": "city_nizamabad_v2",
      "seo_city_key": "India|Nizamabad",
      "customer_city": "city_nizamabad_v2",
      "state": "Telangana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Khanapur",
        "khanapur",
        "Khanapur"
      ],
      "subcities": [
        "nizamabad"
      ],
      "city_address_hint": "7-11-574, NRI Colony, Arsapally, Nizamabad, Telangana 503001, India",
      "url_name": "nizamabad",
      "country_name": "India",
      "postal_code": "503003",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 18.676086,
        "long": 78.088272,
        "details": "7-11-574, NRI Colony, Arsapally, Nizamabad, Telangana 503001, India",
        "google_place_id": "ChIJCZoQVz3bzTsRow5k8-Bk-ns"
      },
      "bounds": [
        18.571244,
        77.648792,
        19.360385,
        78.418093
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Mulugu",
      "name": "Mulugu",
      "key": "city_mulugu_v2",
      "seo_city_key": "India|Mulugu",
      "customer_city": "city_mulugu_v2",
      "state": "Telangana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Mulugu",
        "mulugu"
      ],
      "subcities": [
        "mulugu"
      ],
      "city_address_hint": "5WVR+V7H, Mulugu, Telangana 506343, India",
      "url_name": "Mulugu",
      "country_name": "India",
      "postal_code": "506343",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 18.195059,
        "long": 79.940915,
        "details": "5WVR+V7H, Mulugu, Telangana 506343, India",
        "google_place_id": "ChIJ2dWsKpsNMzoR8KYuv0Q25q8"
      },
      "bounds": [
        18.044686,
        79.954839,
        18.461818,
        80.372114
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "ambala",
      "name": "Ambala",
      "key": "city_ambala_v2",
      "seo_city_key": "India|Ambala",
      "customer_city": "city_ambala_v2",
      "state": "Haryana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Ambala",
        "ambala",
        "Ambala"
      ],
      "subcities": [
        "ambala"
      ],
      "city_address_hint": "9QGJ+3VR, Police Line, Ambala, Haryana 134003, India",
      "url_name": "ambala",
      "country_name": "India",
      "postal_code": "134003",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 30.3752011,
        "long": 76.782122,
        "details": "9QGJ+3VR, Police Line, Ambala, Haryana 134003, India",
        "google_place_id": "ChIJEW8eQiq2DzkRFI0l9ymK0us"
      },
      "bounds": [
        30.188662,
        76.708235,
        30.48448,
        77.193374
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "ratnagiri",
      "name": "Ratnagiri",
      "key": "city_maharashtra_ratnagiri_v2",
      "seo_city_key": "India|Ratnagiri",
      "customer_city": "city_maharashtra_ratnagiri_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Ratnagiri",
        "ratnagiri",
        "Ratnagiri"
      ],
      "subcities": [
        "ratnagiri"
      ],
      "city_address_hint": "X8R6+3RJ, Abhyudhya Nagar, Ratnagiri, Maharashtra 415612, India",
      "url_name": "ratnagiri",
      "country_name": "India",
      "postal_code": "415612",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 16.990215,
        "long": 73.31202329999999,
        "details": "X8R6+3RJ, Abhyudhya Nagar, Ratnagiri, Maharashtra 415612, India",
        "google_place_id": "ChIJf7umORgN6jsRYWW_eZuWq2M"
      },
      "bounds": [
        16.708219,
        72.858775,
        17.853331,
        73.706246
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Maldah",
      "name": "Maldah",
      "key": "city_maldah_v2",
      "seo_city_key": "India|Maldah",
      "customer_city": "city_maldah_v2",
      "state": "West Bengal",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "maldah"
      ],
      "subcities": [
        "maldah"
      ],
      "city_address_hint": "Maldah, West Bengal, 732101",
      "url_name": "Maldah",
      "country_name": "India",
      "postal_code": "732101",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 25.2381216,
        "long": 87.64535920000002,
        "details": "Maldah, West Bengal, 732101",
        "google_place_id": "ChIJbWuvxb6Y-jkRo5_UmpP6iVA"
      },
      "bounds": [
        24.720093,
        87.783036,
        25.546237,
        88.511266
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "kolkata",
      "name": "Kolkata",
      "key": "city_kolkata_v2",
      "seo_city_key": "india|kolkata",
      "customer_city": "city_kolkata_v2",
      "state": "West Bengal",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "kolkata",
        "calcutta",
        "belgachia",
        "howrah"
      ],
      "subcities": [
        "Kolkata",
        "kolkata",
        "Howrah"
      ],
      "city_address_hint": "Old Ballygunge Road, Kolkata",
      "url_name": "kolkata",
      "country_name": "India",
      "postal_code": "700017",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 22.5279046,
        "long": 88.3624861,
        "details": "Old Ballygunge Road, Kolkata",
        "google_place_id": "ChIJSw1kIfWEXjkRa5miqZfuU2g"
      },
      "bounds": [
        21.597141,
        87.138824,
        23.010552,
        88.880437
      ],
      "offices": [
        {
          "name": "Kolkata",
          "is_live": true,
          "address": "Urbanclap Technologies India Pvt Ltd, Asyst Park, 1st and 2nd floor, GN-37/1, Salt Lake Sector 5, WABEL More, Kolkata 700091",
          "subcities": [
            "Kolkata"
          ],
          "office_type": [
            "business",
            "corporate",
            "support",
            "training"
          ],
          "location_mapping": {
            "lat": 22.5721111,
            "long": 88.4309444
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "delhi-ncr",
      "name": "Delhi NCR",
      "key": "city_delhi_v2",
      "seo_city_key": "india|new_delhi",
      "customer_city": "city_delhi_v2",
      "state": "Delhi",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "delhi",
        "new delhi",
        "gurgaon",
        "gurugram",
        "ghaziabad",
        "faridabad",
        "noida",
        "greater noida",
        "greater-noida",
        "greater_noida",
        "sarhol",
        "samalka",
        "narela",
        "nangloi jat",
        "najafgarh",
        "mahrauli",
        "jawaharnagar",
        "connaught place",
        "azadpur",
        "kair",
        "dwarka",
        "janakpuri",
        "civil lines",
        "libaspur",
        "burari",
        "mundka"
      ],
      "subcities": [
        "Delhi",
        "delhi",
        "Delhi-Ncr",
        "Noida",
        "Ghaziabad",
        "Faridabad",
        "Gurgaon",
        "Greater-Noida",
        "delhi-ncr",
        "noida",
        "ghaziabad",
        "faridabad",
        "gurgaon",
        "greater-noida",
        "Gurugram",
        "Sarhol",
        "sarhol",
        "New Delhi"
      ],
      "city_address_hint": "Connaught Place, New Delhi",
      "url_name": "delhi-ncr",
      "country_name": "India",
      "postal_code": "110049",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 28.6325791,
        "long": 77.2200373,
        "details": "Connaught Place, New Delhi",
        "google_place_id": "ChIJV9BBtzf9DDkR8cOTc-SI7s0"
      },
      "bounds": [
        28.281403,
        76.810906,
        28.923427,
        77.61291
      ],
      "offices": [
        {
          "name": "New Delhi",
          "is_live": true,
          "address": "UrbanCompany Technologies India Pvt Ltd PNR House, R 5 Green Park Market New Delhi",
          "subcities": [
            "Delhi",
            "Delhi-Ncr",
            "Noida",
            "Ghaziabad",
            "Faridabad",
            "Gurgaon",
            "Greater-Noida",
            "Gurugram"
          ],
          "office_type": [
            "business",
            "support"
          ],
          "location_mapping": {
            "lat": 28.558629,
            "long": 77.208061
          }
        },
        {
          "name": "Gurgaon-HO",
          "is_live": true,
          "address": "UrbanCompany Technologies India Pvt Ltd Plot No 7th Floor, 183, Udyog Vihar Phase 1, Udyog Vihar, Sector 18, Gurugram, Haryana 122015",
          "subcities": [
            "Delhi",
            "Delhi-Ncr",
            "Noida",
            "Ghaziabad",
            "Faridabad",
            "Gurgaon",
            "Greater-Noida",
            "Gurugram"
          ],
          "office_type": [
            "corporate",
            "training"
          ],
          "location_mapping": {
            "lat": 28.518007,
            "long": 77.083243
          }
        },
        {
          "name": "Gurgaon Training centre",
          "is_live": true,
          "address": "UrbanCompany Technologies India Pvt Ltd 2nd floor, Plot no 96, Udyog Vihar Phase  1, Gurgaon, Haryana - 122015",
          "subcities": [
            "Delhi",
            "Delhi-Ncr",
            "Noida",
            "Ghaziabad",
            "Faridabad",
            "Gurgaon",
            "Greater-Noida",
            "Gurugram"
          ],
          "office_type": [
            "business",
            "support"
          ],
          "location_mapping": {
            "lat": 28.508655,
            "long": 77.089551
          }
        },
        {
          "name": "Noida",
          "is_live": true,
          "address": "G+2, Plot No. A-33, 34 Sector-16, NOIDA",
          "subcities": [
            "Delhi",
            "Delhi-Ncr",
            "Noida",
            "Ghaziabad",
            "Faridabad",
            "Gurgaon",
            "Greater-Noida",
            "Gurugram"
          ],
          "office_type": [
            "business",
            "corporate",
            "support",
            "training"
          ],
          "location_mapping": {
            "lat": 28.578696,
            "long": 77.317443
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "darjeeling",
      "name": "Darjeeling",
      "key": "city_darjeeling_v2",
      "seo_city_key": "India|Darjeeling",
      "customer_city": "city_darjeeling_v2",
      "state": "West Bengal",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Darjeeling",
        "darjeeling",
        "Darjeeling"
      ],
      "subcities": [
        "darjeeling"
      ],
      "city_address_hint": "18, Hill Cart Rd, West Point, Darjeeling, West Bengal 734101, India",
      "url_name": "darjeeling",
      "country_name": "India",
      "postal_code": "734102",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 27.0410218,
        "long": 88.2662745,
        "details": "18, Hill Cart Rd, West Point, Darjeeling, West Bengal 734101, India",
        "google_place_id": "ChIJuwH1TGUu5DkRKnDUeVlVdUE"
      },
      "bounds": [
        26.429076,
        87.97255,
        27.132919,
        88.939948
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "shimoga",
      "name": "Shimoga",
      "key": "city_shimoga_v2",
      "seo_city_key": "India|Shimoga",
      "customer_city": "city_shimoga_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Shimoga",
        "shimoga",
        "Shimoga"
      ],
      "subcities": [
        "shimoga"
      ],
      "city_address_hint": "18, 2nd Cross Rd, Vidyanagar, Madaripalya, Shivamogga, Karnataka 577201, India",
      "url_name": "shimoga",
      "country_name": "India",
      "postal_code": "577201",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 13.9299299,
        "long": 75.568101,
        "details": "18, 2nd Cross Rd, Vidyanagar, Madaripalya, Shivamogga, Karnataka 577201, India",
        "google_place_id": "ChIJlQRi7NCouzsRFxp2wjPXiVU"
      },
      "bounds": [
        13.756643,
        74.822515,
        14.317659,
        75.82077
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "beed",
      "name": "Beed",
      "key": "city_beed_v2",
      "seo_city_key": "India|Beed",
      "customer_city": "city_beed_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Beed",
        "beed",
        "Beed"
      ],
      "subcities": [
        "beed"
      ],
      "city_address_hint": "F8P8+CV5, Kalwakurthy - Nagarkurnool Rd, Nagarkurnool, Telangana 509209, India",
      "url_name": "beed",
      "country_name": "India",
      "postal_code": "431122",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 16.485938,
        "long": 78.317196,
        "details": "F8P8+CV5, Kalwakurthy - Nagarkurnool Rd, Nagarkurnool, Telangana 509209, India",
        "google_place_id": "ChIJXTbSmJ9syjsR_6h2L3ESDkA"
      },
      "bounds": [
        18.603933,
        75.003525,
        19.24391,
        76.584712
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "amravati",
      "name": "Amravati",
      "key": "city_amravati_v2",
      "seo_city_key": "India|Amravati",
      "customer_city": "city_amravati_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Amravati",
        "amravati",
        "Amravati"
      ],
      "subcities": [
        "amravati"
      ],
      "city_address_hint": "9, Amrawati Tahsil, Ladtha Colony, Amravati, Maharashtra 444701, India",
      "url_name": "amravati",
      "country_name": "India",
      "postal_code": "444701",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 20.9319821,
        "long": 77.7523039,
        "details": "9, Amrawati Tahsil, Ladtha Colony, Amravati, Maharashtra 444701, India",
        "google_place_id": "ChIJFbx0d6ak1jsRNZZPyng_ezw"
      },
      "bounds": [
        20.590206,
        77.32418,
        21.600939,
        78.273468
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "banas Kantha",
      "name": "Banas Kantha",
      "key": "city_banas_kantha_v2",
      "seo_city_key": "India|Banas Kantha",
      "customer_city": "city_banas_kantha_v2",
      "state": "Gujarat",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Banas Kantha",
        "banas kantha",
        "Banas Kantha"
      ],
      "subcities": [
        "banas Kantha"
      ],
      "city_address_hint": "8QW6+5VQ, Peparal, Gujarat 385310, India",
      "url_name": "banas Kantha",
      "country_name": "India",
      "postal_code": "385310",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 24.3454739,
        "long": 71.7622481,
        "details": "8QW6+5VQ, Peparal, Gujarat 385310, India",
        "google_place_id": "ChIJiTGoOkPpXDkRZ5ScxWXN7aQ"
      },
      "bounds": [
        24.243232,
        72.156047,
        24.562744,
        72.64356
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "purbi champaran",
      "name": "PURBI CHAMPARAN",
      "key": "city_purbi_champaran_v2",
      "seo_city_key": "India|Bettiah",
      "customer_city": "city_purbi_champaran_v2",
      "state": "Bihar",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "purbi champaran"
      ],
      "subcities": [
        "purbi champaran"
      ],
      "city_address_hint": "JV53+RQX, Turkauliya, Sankar Saraiya, Bihar 845437, India",
      "url_name": "purbi champaran",
      "country_name": "India",
      "postal_code": "845437",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 26.609755,
        "long": 84.854994,
        "details": "JV53+RQX, Turkauliya, Sankar Saraiya, Bihar 845437, India",
        "google_place_id": "ChIJr_R5K1UxkzkRfDE4xVuLGfc"
      },
      "bounds": [
        26.587913,
        84.771595,
        26.639958,
        84.886929
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "north goa",
      "name": "North Goa",
      "key": "city_north_goa_v2",
      "seo_city_key": "India|North Goa",
      "customer_city": "city_north_goa_v2",
      "state": "Goa",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "North Goa",
        "north goa",
        "North Goa"
      ],
      "subcities": [
        "north goa"
      ],
      "city_address_hint": "GX8M+G6C Rain water harvesting plant, Bharath kumar, Betgi, Goa 403107, India",
      "url_name": "north goa",
      "country_name": "India",
      "postal_code": "403107",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 15.5163112,
        "long": 73.98300290000002,
        "details": "GX8M+G6C Rain water harvesting plant, Bharath kumar, Betgi, Goa 403107, India",
        "google_place_id": "ChIJMaD6Uu3AvzsR0E3VfowKzRs"
      },
      "bounds": [
        15.36783,
        73.561595,
        15.901418,
        74.167296
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "vizianagaram",
      "name": "Vizianagaram",
      "key": "city_vizianagaram_v2",
      "seo_city_key": "India|Vizianagaram",
      "customer_city": "city_vizianagaram_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Vizianagaram",
        "vizianagaram",
        "Vizianagaram"
      ],
      "subcities": [
        "vizianagram"
      ],
      "city_address_hint": "1-142, Peddapavani, Railway Station Area, Vizianagaram, Andhra Pradesh 535003, India",
      "url_name": "vizianagaram",
      "country_name": "India",
      "postal_code": "535003",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 18.1066576,
        "long": 83.39555059999999,
        "details": "1-142, Peddapavani, Railway Station Area, Vizianagaram, Andhra Pradesh 535003, India",
        "google_place_id": "ChIJX4jw_BflOzoRjR0pX7sEUeg"
      },
      "bounds": [
        18.060232,
        83.359498,
        18.165855,
        83.44694
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "chamarajanagara",
      "name": "CHAMARAJANAGARA",
      "key": "city_chamarajanagara_v2",
      "seo_city_key": "India|chamarajanagara",
      "customer_city": "city_chamarajanagara_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "chamarajanagara"
      ],
      "subcities": [
        "chamarajanagara"
      ],
      "city_address_hint": "WWPG+4F Chamarajanagar, Karnataka, India",
      "url_name": "chamarajanagara",
      "country_name": "India",
      "postal_code": "571313",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 11.935282,
        "long": 76.92615,
        "details": "WWPG+4F Chamarajanagar, Karnataka, India",
        "google_place_id": "GhIJiRaPQd3eJ0ARj2voC0Y7U0A"
      },
      "bounds": [
        11.774603,
        76.737185,
        12.083387,
        77.163763
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "udupi",
      "name": "Udupi",
      "key": "city_udupi_v2",
      "seo_city_key": "India|Udupi",
      "customer_city": "city_udupi_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Udupi",
        "udupi",
        "Udupi"
      ],
      "subcities": [
        "udupi"
      ],
      "city_address_hint": "2-50, Saraswati Nagar, Udupi, Karnataka 576101, India",
      "url_name": "udupi",
      "country_name": "India",
      "postal_code": "576101",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 13.3408807,
        "long": 74.7421427,
        "details": "2-50, Saraswati Nagar, Udupi, Karnataka 576101, India",
        "google_place_id": "ChIJz0GPk2m7vDsRQwGFMeSZzMw"
      },
      "bounds": [
        13.117933,
        74.699049,
        13.624925,
        75.356123
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "patiala",
      "name": "Patiala",
      "key": "city_patiala_v2",
      "seo_city_key": "India|Patiala",
      "customer_city": "city_patiala_v2",
      "state": "Punjab",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Patiala",
        "patiala",
        "Patiala"
      ],
      "subcities": [
        "patiala"
      ],
      "city_address_hint": "89QP+WQ6, Green View Colony, Patiala, Punjab 147001, India",
      "url_name": "patiala",
      "country_name": "India",
      "postal_code": "147001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 30.3397809,
        "long": 76.3868797,
        "details": "89QP+WQ6, Green View Colony, Patiala, Punjab 147001, India",
        "google_place_id": "ChIJ3xMzWpMoEDkRf7yQO61WvNU"
      },
      "bounds": [
        30.247353,
        76.255932,
        30.574877,
        76.608868
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "villupuram",
      "name": "Villupuram",
      "key": "city_villupuram_v2",
      "seo_city_key": "India|Villupuram",
      "customer_city": "city_villupuram_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Villupuram",
        "villupuram",
        "Villupuram"
      ],
      "subcities": [
        "Villupuram"
      ],
      "city_address_hint": "WFRP+3F2, First St, Selva Nagar, Viluppuram, Tamil Nadu 605602, India",
      "url_name": "villupuram",
      "country_name": "India",
      "postal_code": "605602",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 11.9401378,
        "long": 79.4861449,
        "details": "WFRP+3F2, First St, Selva Nagar, Viluppuram, Tamil Nadu 605602, India",
        "google_place_id": "ChIJd2t7csBWUzoR8-USs6QViCw"
      },
      "bounds": [
        11.906084,
        79.289038,
        12.408272,
        79.554798
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "tirunelveli",
      "name": "Tirunelveli",
      "key": "city_tirunelveli_v2",
      "seo_city_key": "India|Tirunelveli",
      "customer_city": "city_tirunelveli_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Tirunelveli",
        "tirunelveli",
        "Tirunelveli"
      ],
      "subcities": [
        "tirunelveli"
      ],
      "city_address_hint": "PQ88+272, Tirunelveli, Tamil Nadu 627011, India",
      "url_name": "tirunelveli",
      "country_name": "India",
      "postal_code": "627011",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 8.715017999999999,
        "long": 77.765628,
        "details": "PQ88+272, Tirunelveli, Tamil Nadu 627011, India",
        "google_place_id": "ChIJGcVTUGIRBDsRTZo1GzYbea0"
      },
      "bounds": [
        8.132697,
        77.598958,
        8.764296,
        77.830466
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "thanjavur",
      "name": "Thanjavur",
      "key": "city_thanjavur_v2",
      "seo_city_key": "India|Thanjavur",
      "customer_city": "city_thanjavur_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Thanjavur",
        "thanjavur",
        "Thanjavur"
      ],
      "subcities": [
        "thanjavur"
      ],
      "city_address_hint": "Q4PQ+Q4W Arichandran Athiyaman, Rajakrisnapuram, Thanjavur, Tamil Nadu 613001, India",
      "url_name": "thanjavur",
      "country_name": "India",
      "postal_code": "613005",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 10.7869994,
        "long": 79.13782739999999,
        "details": "Q4PQ+Q4W Arichandran Athiyaman, Rajakrisnapuram, Thanjavur, Tamil Nadu 613001, India",
        "google_place_id": "ChIJOTBF6py4qjsR5itjH5vaE-E"
      },
      "bounds": [
        10.717285,
        79.086749,
        10.809616,
        79.177523
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "tirupathur",
      "name": "Tirupathur",
      "key": "city_tirupathur_v2",
      "seo_city_key": "India|tirupathur",
      "customer_city": "city_tirupathur_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "tirupathur"
      ],
      "subcities": [
        "tirupathur"
      ],
      "city_address_hint": "Vasantham Tuition Centre, Railway Station Road, opp. to Sakthi Supermarket, Achamangalam, Tirupathur, Tamil Nadu 635601, India",
      "url_name": "tirupathur",
      "country_name": "India",
      "postal_code": "635601",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 12.496449,
        "long": 78.564122,
        "details": "Vasantham Tuition Centre, Railway Station Road, opp. to Sakthi Supermarket, Achamangalam, Tirupathur, Tamil Nadu 635601, India",
        "google_place_id": "ChIJ-4tkUmhTrDsR5ndgD2FhE7M"
      },
      "bounds": [
        12.409502,
        78.451052,
        12.545013,
        78.68228
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "karur",
      "name": "Karur",
      "key": "city_karur_v2",
      "seo_city_key": "India|Karur",
      "customer_city": "city_karur_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Karur",
        "karur",
        "Karur"
      ],
      "subcities": [
        "karur"
      ],
      "city_address_hint": "773, E B Colony, North Gandhi Gramam, Karur, Tamil Nadu 639004, India",
      "url_name": "karur",
      "country_name": "India",
      "postal_code": "639001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 10.9600778,
        "long": 78.07660360000001,
        "details": "773, E B Colony, North Gandhi Gramam, Karur, Tamil Nadu 639004, India",
        "google_place_id": "ChIJjzmVJAcvqjsRG599H3r8fJQ"
      },
      "bounds": [
        10.902149,
        77.980099,
        11.004219,
        78.117021
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "jaunpur",
      "name": "Jaunpur",
      "key": "city_jaunpur_v2",
      "seo_city_key": "India|Jaunpur",
      "customer_city": "city_jaunpur_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Jaunpur",
        "jaunpur",
        "Jaunpur"
      ],
      "subcities": [
        "jaunpur"
      ],
      "city_address_hint": "PMWM+HF8, Olandganj, Jaunpur, Uttar Pradesh 222002, India",
      "url_name": "jaunpur",
      "country_name": "India",
      "postal_code": "222002",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 25.7464145,
        "long": 82.68370329999999,
        "details": "PMWM+HF8, Olandganj, Jaunpur, Uttar Pradesh 222002, India",
        "google_place_id": "ChIJFUeZkyw6kDkRInPJDfGp-QA"
      },
      "bounds": [
        25.722201,
        82.50161,
        25.799326,
        82.708033
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "coochbehar",
      "name": "COOCHBEHAR",
      "key": "city_coochbehar_v2",
      "seo_city_key": "India|Alipurduar",
      "customer_city": "city_coochbehar_v2",
      "state": "West Bengal",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Alipurduar",
        "alipurduar",
        "Alipurduar"
      ],
      "subcities": [
        "coochbehar"
      ],
      "city_address_hint": "8CWV+8P3, NH 17, Khagrabari, Cooch Behar, Mahishbathan Pratham Khanda, West Bengal 736179, India",
      "url_name": "coochbehar",
      "country_name": "India",
      "postal_code": "736179",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 26.345251,
        "long": 89.444498,
        "details": "8CWV+8P3, NH 17, Khagrabari, Cooch Behar, Mahishbathan Pratham Khanda, West Bengal 736179, India",
        "google_place_id": "ChIJofjuFo3-4jkRJUOd-2PVcek"
      },
      "bounds": [
        26.301608,
        89.393813,
        26.381723,
        89.49008
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "erode",
      "name": "Erode",
      "key": "city_erode_v2",
      "seo_city_key": "India|Erode",
      "customer_city": "city_erode_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Erode",
        "erode",
        "Erode"
      ],
      "subcities": [
        "erode"
      ],
      "city_address_hint": "26, Thiyagi Kumaran St, Municipal Colony, Muncipal Colony, Edayankattuvalasu, Erode, Tamil Nadu 638004, India",
      "url_name": "erode",
      "country_name": "India",
      "postal_code": "638009",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 11.343653,
        "long": 77.715752,
        "details": "26, Thiyagi Kumaran St, Municipal Colony, Muncipal Colony, Edayankattuvalasu, Erode, Tamil Nadu 638004, India",
        "google_place_id": "ChIJD2J3OjpvqTsRhPdfVam8tP0"
      },
      "bounds": [
        11.210734,
        77.53644,
        11.400358,
        77.872381
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "tiruppur",
      "name": "Tiruppur",
      "key": "city_tiruppur_v2",
      "seo_city_key": "India|Tiruppur",
      "customer_city": "city_tiruppur_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Tiruppur",
        "tiruppur",
        "Tiruppur"
      ],
      "subcities": [
        "tiruppur"
      ],
      "city_address_hint": "8, Avinashi - Tiruppur Rd, PSS Colony, Bridge Way Colony, Tiruppur, Tamil Nadu 641602, India",
      "url_name": "tiruppur",
      "country_name": "India",
      "postal_code": "641603",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 11.109855,
        "long": 77.340875,
        "details": "8, Avinashi - Tiruppur Rd, PSS Colony, Bridge Way Colony, Tiruppur, Tamil Nadu 641602, India",
        "google_place_id": "ChIJoeXNBq8HqTsR49C4cDNwv6Y"
      },
      "bounds": [
        10.958888,
        77.192173,
        11.309391,
        77.540946
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "cuddalore",
      "name": "Cuddalore",
      "key": "city_cuddalore_v2",
      "seo_city_key": "India|Cuddalore",
      "customer_city": "city_cuddalore_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Cuddalore",
        "cuddalore",
        "Cuddalore"
      ],
      "subcities": [
        "Cuddalore"
      ],
      "city_address_hint": "RQ29+M5 Kanniyakoil, Puducherry, India",
      "url_name": "cuddalore",
      "country_name": "India",
      "postal_code": "607204",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 11.801627,
        "long": 79.767921,
        "details": "RQ29+M5 Kanniyakoil, Puducherry, India",
        "google_place_id": "GhIJtSwE3m6aJ0AR-BrdnCXxU0A"
      },
      "bounds": [
        11.735865,
        79.382079,
        11.77057,
        79.793529
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "dindigul",
      "name": "Dindigul",
      "key": "city_dindigul_v2",
      "seo_city_key": "India|Dindigul",
      "customer_city": "city_dindigul_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Dindigul",
        "dindigul",
        "Dindigul"
      ],
      "subcities": [
        "dindigul"
      ],
      "city_address_hint": "153, W Car St, Dindigul, Begambur, Tamil Nadu 624001, India",
      "url_name": "dindigul",
      "country_name": "India",
      "postal_code": "624001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 10.362661,
        "long": 77.969166,
        "details": "153, W Car St, Dindigul, Begambur, Tamil Nadu 624001, India",
        "google_place_id": "ChIJvzJcx_aqADsRpvc0CCaJJPc"
      },
      "bounds": [
        10.358249,
        77.961175,
        10.366685,
        77.977801
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "sirsa",
      "name": "Sirsa",
      "key": "city_sirsa_v2",
      "seo_city_key": "India|Sirsa",
      "customer_city": "city_sirsa_v2",
      "state": "Haryana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Sirsa",
        "sirsa",
        "Sirsa"
      ],
      "subcities": [
        "sirsa"
      ],
      "city_address_hint": "G2JJ+VJ8, Gita Bhawan Street, near Bhagwan Parshuram Chowk, Rori Bazar, B Block, Ellenabad, Sirsa, Haryana 125055, India",
      "url_name": "sirsa",
      "country_name": "India",
      "postal_code": "125055",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 29.532188,
        "long": 75.0316,
        "details": "G2JJ+VJ8, Gita Bhawan Street, near Bhagwan Parshuram Chowk, Rori Bazar, B Block, Ellenabad, Sirsa, Haryana 125055, India",
        "google_place_id": "ChIJaRxWYbNNETkRfqcJm-RV7kM"
      },
      "bounds": [
        29.419208,
        74.854033,
        29.647482,
        75.212273
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "yamunanagar",
      "name": "Yamunanagar",
      "key": "city_yamunanagar_v2",
      "seo_city_key": "India|Yamunanagar",
      "customer_city": "city_yamunanagar_v2",
      "state": "Haryana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Yamunanagar",
        "yamunanagar",
        "Yamunanagar"
      ],
      "subcities": [
        "yamunanagar"
      ],
      "city_address_hint": "4, near Govt School, Harbanspura Colony, Vishnu Nagar, Yamuna Nagar, Haryana 135001, India",
      "url_name": "yamunanagar",
      "country_name": "India",
      "postal_code": "135001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 30.1290485,
        "long": 77.2673901,
        "details": "4, near Govt School, Harbanspura Colony, Vishnu Nagar, Yamuna Nagar, Haryana 135001, India",
        "google_place_id": "ChIJJeoZi5v5DjkRAhk5Hytuxw8"
      },
      "bounds": [
        30.1123897,
        77.2315216,
        30.1519554,
        77.30890269999999
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Hingoli",
      "name": "Hingoli",
      "key": "city_hingoli_v2",
      "seo_city_key": "India|Hingoli",
      "customer_city": "city_hingoli_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Hingoli",
        "hingoli",
        "Hingoli"
      ],
      "subcities": [
        "hingoli"
      ],
      "city_address_hint": "Zp Rd, Mohalla Paltan, Siddharth Nagar, Hingoli, Maharashtra 431513, India",
      "url_name": "Hingoli",
      "country_name": "India",
      "postal_code": "431513",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 19.7114963,
        "long": 77.1453846,
        "details": "Zp Rd, Mohalla Paltan, Siddharth Nagar, Hingoli, Maharashtra 431513, India",
        "google_place_id": "ChIJQxlVglRS0DsR3e3nrpvkwM0"
      },
      "bounds": [
        19.532852,
        77.043142,
        19.762063,
        77.215963
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "nabarangpur",
      "name": "Nabarangpur",
      "key": "city_nabarangpur_v2",
      "seo_city_key": "India|Nabarangpur",
      "customer_city": "city_nabarangpur_v2",
      "state": "Odisha",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Nabarangpur",
        "nabarangpur",
        "Nabarangpur"
      ],
      "subcities": [
        "nabarangpur"
      ],
      "city_address_hint": "6GHX+3JP, Nowrangpur, Odisha 764059, India",
      "url_name": "nabarangpur",
      "country_name": "India",
      "postal_code": "764059",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 19.2277163,
        "long": 82.5490885,
        "details": "6GHX+3JP, Nowrangpur, Odisha 764059, India",
        "google_place_id": "ChIJ_f1_8Pa3OjoR7twIjxYJnhU"
      },
      "bounds": [
        19.218226,
        82.537031,
        19.242197,
        82.563114
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "nanded",
      "name": "Nanded",
      "key": "city_nanded_v2",
      "seo_city_key": "India|Nanded",
      "customer_city": "city_nanded_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Nanded",
        "nanded",
        "Nanded"
      ],
      "subcities": [
        "nanded"
      ],
      "city_address_hint": "48X9+JMW, Old Mondha, Hyder Bagh, Dashmesh Nagar, Harsh Nagar, Nanded-Waghala, Nanded, Maharashtra 431604, India",
      "url_name": "nanded",
      "country_name": "India",
      "postal_code": "431604",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 19.149086,
        "long": 77.319138,
        "details": "48X9+JMW, Old Mondha, Hyder Bagh, Dashmesh Nagar, Harsh Nagar, Nanded-Waghala, Nanded, Maharashtra 431604, India",
        "google_place_id": "ChIJC4DkcTjW0TsR4otE4OWuvOo"
      },
      "bounds": [
        19.084182,
        77.253971,
        19.241467,
        77.377739
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Bharatpur",
      "name": "Bharatpur",
      "key": "city_bharatpur_v2",
      "seo_city_key": "India|Bharatpur",
      "customer_city": "city_bharatpur_v2",
      "state": "Rajasthan",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Bharatpur",
        "bharatpur",
        "Bharatpur"
      ],
      "subcities": [
        "bharatpur"
      ],
      "city_address_hint": "6G83+36C, Patpara Mohalla, Bharatpur, Rajasthan 321001, India",
      "url_name": "Bharatpur",
      "country_name": "India",
      "postal_code": "321001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 27.2151863,
        "long": 77.5029996,
        "details": "6G83+36C, Patpara Mohalla, Bharatpur, Rajasthan 321001, India",
        "google_place_id": "ChIJb3NahAqjczkRCM7ukzUQD1o"
      },
      "bounds": [
        27.191101,
        77.353363,
        27.264623,
        77.551759
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "ayodhya",
      "name": "Ayodhya",
      "key": "city_ayodhya_v2",
      "seo_city_key": "India|Ayodhya",
      "customer_city": "city_ayodhya_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Ayodhya",
        "ayodhya",
        "Ayodhya"
      ],
      "subcities": [
        "ayodha"
      ],
      "city_address_hint": "Q5RX+VW7, Ram Nagar, Ayodhya, Uttar Pradesh 224123, India",
      "url_name": "ayodhya",
      "country_name": "India",
      "postal_code": "224123",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 26.7921605,
        "long": 82.1997954,
        "details": "Q5RX+VW7, Ram Nagar, Ayodhya, Uttar Pradesh 224123, India",
        "google_place_id": "ChIJIyhtfpMHmjkRKyJ_sYP2yF8"
      },
      "bounds": [
        26.735082,
        82.046625,
        26.843834,
        82.268283
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "sindhudurg",
      "name": "Sindhudurg",
      "key": "city_sindhudurg_v2",
      "seo_city_key": "India|Sindhudurg",
      "customer_city": "city_sindhudurg_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Sindhudurg",
        "sindhudurg",
        "Sindhudurg"
      ],
      "subcities": [],
      "city_address_hint": "QRXC+H4 Madura, Maharashtra, India",
      "url_name": "sindhudurg",
      "country_name": "India",
      "postal_code": "416514",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 15.798901,
        "long": 73.820287,
        "details": "QRXC+H4 Madura, Maharashtra, India",
        "google_place_id": "GhIJxYA2gwmZL0ARKvV2lX90UkA"
      },
      "bounds": [
        15.426124,
        72.981281,
        16.633772,
        74.296815
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "sangli",
      "name": "Sangli",
      "key": "city_sangli_v2",
      "seo_city_key": "India|Sangli",
      "customer_city": "city_sangli_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Sangli",
        "sangli",
        "Sangli"
      ],
      "subcities": [
        "sangli"
      ],
      "city_address_hint": "321, South Shivaji Nagar, Nishant Colony, Sangli Miraj Kupwad, Sangli, Maharashtra 416416, India",
      "url_name": "sangli",
      "country_name": "India",
      "postal_code": "416415",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 16.8523973,
        "long": 74.5814773,
        "details": "321, South Shivaji Nagar, Nishant Colony, Sangli Miraj Kupwad, Sangli, Maharashtra 416416, India",
        "google_place_id": "ChIJ62Dwh4EMwTsRs93BzVMfkTc"
      },
      "bounds": [
        16.818344,
        74.539275,
        17.037993,
        74.628925
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "kolhapur",
      "name": "Kolhapur",
      "key": "city_kolhapur_v2",
      "seo_city_key": "India|Kolhapur",
      "customer_city": "city_kolhapur_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Kolhapur",
        "kolhapur",
        "Kolhapur"
      ],
      "subcities": [
        "kolhapur"
      ],
      "city_address_hint": "1116, opp. Panch Bungalow, E Ward, Shahupuri, Kolhapur, Maharashtra 416001, India",
      "url_name": "kolhapur",
      "country_name": "India",
      "postal_code": "416001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 16.7049873,
        "long": 74.24325270000001,
        "details": "1116, opp. Panch Bungalow, E Ward, Shahupuri, Kolhapur, Maharashtra 416001, India",
        "google_place_id": "ChIJKXrA3gwAwTsRL-RSKWTq6Ow"
      },
      "bounds": [
        16.597067,
        74.080725,
        16.938095,
        74.351692
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "saharsa",
      "name": "Saharsa",
      "key": "city_saharsa_v2",
      "seo_city_key": "India|Saharsa",
      "customer_city": "city_saharsa_v2",
      "state": "Bihar",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Saharsa",
        "saharsa",
        "Saharsa"
      ],
      "subcities": [
        "saharsa"
      ],
      "city_address_hint": "VHGV+X43, Naya Bazar, Saharsa, Bihar 852201, India",
      "url_name": "saharsa",
      "country_name": "India",
      "postal_code": "852201",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 25.8773651,
        "long": 86.5927887,
        "details": "VHGV+X43, Naya Bazar, Saharsa, Bihar 852201, India",
        "google_place_id": "ChIJz417rpU97jkR5Yb-IfXQvJA"
      },
      "bounds": [
        25.695315,
        86.428957,
        25.998889,
        86.660683
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "vidisha",
      "name": "Vidisha",
      "key": "city_vidisha_v2",
      "seo_city_key": "India|Vidisha",
      "customer_city": "city_vidisha_v2",
      "state": "Madhya Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Vidisha",
        "vidisha",
        "Vidisha"
      ],
      "subcities": [
        "vidisha"
      ],
      "city_address_hint": "64, Baripura, Vidisha, Madhya Pradesh 464001, India",
      "url_name": "vidisha",
      "country_name": "India",
      "postal_code": "464001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 23.5235719,
        "long": 77.81397179999999,
        "details": "64, Baripura, Vidisha, Madhya Pradesh 464001, India",
        "google_place_id": "ChIJ9WYxKlAEfDkRE4JUMWOJpn0"
      },
      "bounds": [
        23.477359,
        77.788187,
        23.576869,
        77.972481
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "ratlam",
      "name": "Ratlam",
      "key": "city_ratlam_v2",
      "seo_city_key": "India|Ratlam",
      "customer_city": "city_ratlam_v2",
      "state": "Madhya Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Ratlam",
        "ratlam",
        "Ratlam"
      ],
      "subcities": [
        "ratlam"
      ],
      "city_address_hint": "62, near Radha Krishn Mandir, Katju Nagar, Gandhi Nagar, Ratlam, Madhya Pradesh 457001, India",
      "url_name": "ratlam",
      "country_name": "India",
      "postal_code": "457001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 23.3315103,
        "long": 75.0366677,
        "details": "62, near Radha Krishn Mandir, Katju Nagar, Gandhi Nagar, Ratlam, Madhya Pradesh 457001, India",
        "google_place_id": "ChIJW5sic6P-YzkRcFrkXUAiDMs"
      },
      "bounds": [
        23.190986,
        74.893032,
        23.659104,
        75.259152
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "bhojpur",
      "name": "Bhojpur",
      "key": "city_bhojpur_v2",
      "seo_city_key": "India|Bhojpur",
      "customer_city": "city_bhojpur_v2",
      "state": "Bihar",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Bhojpur",
        "bhojpur",
        "Bhojpur"
      ],
      "subcities": [
        "bhojpur"
      ],
      "city_address_hint": "FG8C+FV9, Aer, Bihar 802162, India",
      "url_name": "bhojpur",
      "country_name": "India",
      "postal_code": "802162",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 25.466155,
        "long": 84.5222189,
        "details": "FG8C+FV9, Aer, Bihar 802162, India",
        "google_place_id": "ChIJGQxF_11fjTkR_doBJrJRHTI"
      },
      "bounds": [
        25.156195,
        84.207309,
        25.733427,
        84.785452
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "koraput",
      "name": "Koraput",
      "key": "city_koraput_v2",
      "seo_city_key": "India|Koraput",
      "customer_city": "city_koraput_v2",
      "state": "Odisha",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Koraput",
        "koraput",
        "Koraput"
      ],
      "subcities": [
        "koraput"
      ],
      "city_address_hint": "NH26, Koraput, Odisha 764020, India",
      "url_name": "koraput",
      "country_name": "India",
      "postal_code": "764020",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 18.813487,
        "long": 82.71233269999999,
        "details": "NH26, Koraput, Odisha 764020, India",
        "google_place_id": "ChIJ6-BZw13wOjoR2-NMW31qm2U"
      },
      "bounds": [
        18.468006,
        82.309484,
        19.115895,
        82.971325
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "Thrissur",
      "name": "Thrissur",
      "key": "city_thrissur_v2",
      "seo_city_key": "India|Thrissur",
      "customer_city": "city_thrissur_v2",
      "state": "Kerala",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Thrissur",
        "thrissur",
        "Thrissur"
      ],
      "subcities": [],
      "city_address_hint": "Kachery, G6H7+3Q3, Round North, Thrissur, Kerala 680020, India",
      "url_name": "Thrissur",
      "country_name": "India",
      "postal_code": "680007",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 10.5276416,
        "long": 76.2144349,
        "details": "Kachery, G6H7+3Q3, Round North, Thrissur, Kerala 680020, India",
        "google_place_id": "ChIJu9FC7RXupzsR26dsAapFLgg"
      },
      "bounds": [
        10.397164,
        75.990372,
        10.706569,
        76.384718
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "vikarabad",
      "name": "Vikarabad",
      "key": "city_vikarabad_v2",
      "seo_city_key": "India|Vikarabad",
      "customer_city": "city_vikarabad_v2",
      "state": "Telangana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Vikarabad",
        "vikarabad",
        "Vikarabad"
      ],
      "subcities": [
        "vikarabad"
      ],
      "city_address_hint": "8WP3+HWP, Vikarabad, Telangana 501101, India",
      "url_name": "vikarabad",
      "country_name": "India",
      "postal_code": "501102",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 17.3364555,
        "long": 77.9048268,
        "details": "8WP3+HWP, Vikarabad, Telangana 501101, India",
        "google_place_id": "ChIJz-rZDqJfyTsRCGrqI4qREJI"
      },
      "bounds": [
        17.323232,
        77.86917,
        17.358153,
        77.927914
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "bareilly",
      "name": "Bareilly",
      "key": "city_bareilly_v2",
      "seo_city_key": "India|Bareilly",
      "customer_city": "city_bareilly_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Bareilly",
        "bareilly",
        "Bareilly"
      ],
      "subcities": [
        "bareilly"
      ],
      "city_address_hint": "23, vikramaditya puri, sbi coloney, Bareilly, Haziyapur, Uttar Pradesh 243005, India",
      "url_name": "bareilly",
      "country_name": "India",
      "postal_code": "243005",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 28.3670355,
        "long": 79.4304381,
        "details": "23, vikramaditya puri, sbi coloney, Bareilly, Haziyapur, Uttar Pradesh 243005, India",
        "google_place_id": "ChIJjZkCTTMHoDkRf-ge80zUuQU"
      },
      "bounds": [
        28.299998,
        79.351273,
        28.441883,
        79.493294
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "kamareddy",
      "name": "Kamareddy",
      "key": "city_kamareddy_v2",
      "seo_city_key": "India|Kamareddy",
      "customer_city": "city_kamareddy_v2",
      "state": "Telangana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Kamareddy",
        "kamareddy",
        "Kamareddy"
      ],
      "subcities": [
        "kamareddy"
      ],
      "city_address_hint": "1-3-890/1, Kamareddy, Telangana 503111, India",
      "url_name": "kamareddy",
      "country_name": "India",
      "postal_code": "503111",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 18.3204832,
        "long": 78.3369523,
        "details": "1-3-890/1, Kamareddy, Telangana 503111, India",
        "google_place_id": "ChIJ8TVBgAVJzDsRQxeDa7Hdx6I"
      },
      "bounds": [
        18.220954,
        78.267288,
        18.428113,
        78.435817
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "medak",
      "name": "Medak",
      "key": "city_medak_v2",
      "seo_city_key": "India|Medak",
      "customer_city": "city_medak_v2",
      "state": "Telangana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Medak",
        "medak",
        "Medak"
      ],
      "subcities": [
        "medak"
      ],
      "city_address_hint": "27W7+F7M Devidas, Chaman, Fathe Nagar, Medak, Telangana 502110, India",
      "url_name": "medak",
      "country_name": "India",
      "postal_code": "502110",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 18.0462192,
        "long": 78.2631756,
        "details": "27W7+F7M Devidas, Chaman, Fathe Nagar, Medak, Telangana 502110, India",
        "google_place_id": "ChIJ1bo7YEMVzDsRPPXvn3LNTtU"
      },
      "bounds": [
        17.77823,
        77.691088,
        18.158695,
        78.58836
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "madinah",
      "name": "Al Madinah",
      "key": "city_madinah_v2",
      "seo_city_key": "Saudi Arabia|Al Furaysh",
      "customer_city": "city_madinah_v2",
      "state": "Al Madinah",
      "country_key": "KSA",
      "country_id": "KSA",
      "regex": [
        "Al Furaysh",
        "al furaysh",
        "Al Furaysh"
      ],
      "subcities": [
        "madinah"
      ],
      "city_address_hint": "677F+GH3, Al Furaysh 42537, Saudi Arabia",
      "url_name": "madinah",
      "country_name": "KSA",
      "postal_code": "42331",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 24.2137683,
        "long": 39.2739088,
        "details": "677F+GH3, Al Furaysh 42537, Saudi Arabia",
        "google_place_id": "ChIJ6cPgkYAqvBURWd7HIU_P1Mw"
      },
      "bounds": [
        24.087216,
        39.135447,
        24.668312,
        40.005426
      ],
      "offices": [],
      "timezone": "Asia/Riyadh"
    },
    {
      "is_live": true,
      "regex_key": "hofuf",
      "name": "Al Hufūf",
      "key": "city_hufuf_v2",
      "seo_city_key": "Saudi Arabia|Al Hufūf",
      "customer_city": "city_hufuf_v2",
      "state": "Eastern Province",
      "country_key": "KSA",
      "country_id": "KSA",
      "regex": [
        "Al Hufuf",
        "al hufuf",
        "Al Hufūf"
      ],
      "subcities": [
        "hofuf"
      ],
      "city_address_hint": "9HJQ+2G6, Historicalcenter Hafuf, Al Hofuf 36361, Saudi Arabia",
      "url_name": "hofuf",
      "country_name": "KSA",
      "postal_code": "36361",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 25.380026,
        "long": 49.5887652,
        "details": "9HJQ+2G6, Historicalcenter Hafuf, Al Hofuf 36361, Saudi Arabia",
        "google_place_id": "ChIJW9_SDuOWNz4RzXAjAan6QCM"
      },
      "bounds": [
        25.216356,
        49.440879,
        25.582898,
        49.783001
      ],
      "offices": [],
      "timezone": "Asia/Riyadh"
    },
    {
      "is_live": true,
      "regex_key": "al-ain",
      "name": "Al Ain",
      "key": "city_alain_v2",
      "seo_city_key": "united_arab_emirates|al_ain",
      "customer_city": "city_alain_v2",
      "state": "Abu Dhabi Emirate",
      "country_key": "UAE",
      "country_id": "UAE",
      "regex": [
        "al ain",
        "Al Ain"
      ],
      "subcities": [
        "al-ain"
      ],
      "city_address_hint": "Al Ghadeer - Abu Dhabi - United Arab Emirates",
      "url_name": "al-ain",
      "country_name": "UAE",
      "postal_code": "30011",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 24.20473,
        "long": 55.619681,
        "details": "Al Ghadeer - Abu Dhabi - United Arab Emirates",
        "google_place_id": "ChIJTRS4ZoGuij4R-Oju-4SMPL8"
      },
      "bounds": [
        24.067234,
        55.429558,
        24.410585,
        55.937404
      ],
      "offices": [],
      "timezone": "Asia/Dubai"
    },
    {
      "is_live": true,
      "regex_key": "ras-al-khaimah",
      "name": "Ras Al Khaimah",
      "key": "city_ras_v2",
      "seo_city_key": "united_arab_emirates|ras",
      "customer_city": "city_ras_v2",
      "state": "Ras al-Khaimah",
      "country_key": "UAE",
      "country_id": "UAE",
      "regex": [
        "Ras Al Khaimah",
        "ras al khaimah",
        "Ras Al Khaimah"
      ],
      "subcities": [
        "ras-al-khaimah"
      ],
      "city_address_hint": "Al Nakheel - Ras al Khaimah - United Arab Emirates",
      "url_name": "ras-al-khaimah",
      "country_name": "UAE",
      "postal_code": "30999",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 25.798486,
        "long": 55.967397,
        "details": "Al Nakheel - Ras al Khaimah - United Arab Emirates",
        "google_place_id": "ChIJBzG-RTJx9j4RDGqZ7JstqIY"
      },
      "bounds": [
        25.767435,
        55.944905,
        25.832034,
        56.030617
      ],
      "offices": [],
      "timezone": "Asia/Dubai"
    },
    {
      "is_live": true,
      "regex_key": "mangaluru",
      "name": "Mangaluru",
      "key": "city_mangaluru_v2",
      "seo_city_key": "India|Mangaluru",
      "customer_city": "city_mangaluru_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Mangaluru",
        "mangaluru",
        "Mangaluru"
      ],
      "subcities": [
        "mangaluru"
      ],
      "city_address_hint": "Bejai Kavoor Rd, Mullakad, Ranipura Ulliya, Gandhi Nagar, Mangaluru, Karnataka 575013, India",
      "url_name": "mangaluru",
      "country_name": "India",
      "postal_code": "575013",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 12.9141417,
        "long": 74.8559568,
        "details": "Bejai Kavoor Rd, Mullakad, Ranipura Ulliya, Gandhi Nagar, Mangaluru, Karnataka 575013, India",
        "google_place_id": "ChIJj0i_N0xaozsRZP78dHq8e4I"
      },
      "bounds": [
        12.840423,
        74.796166,
        13.01359,
        74.914141
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "davanagere",
      "name": "Davanagere",
      "key": "city_davanagere_v2",
      "seo_city_key": "India|Davanagere",
      "customer_city": "city_davanagere_v2",
      "state": "Karnataka",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Davanagere",
        "davanagere",
        "Davanagere"
      ],
      "subcities": [
        "davanagere"
      ],
      "city_address_hint": "023 Kusanur, KTJ Nagar, Nittuvalli, Davanagere, Karnataka 577002, India",
      "url_name": "davanagere",
      "country_name": "India",
      "postal_code": "577002",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 14.4644085,
        "long": 75.921758,
        "details": "023 Kusanur, KTJ Nagar, Nittuvalli, Davanagere, Karnataka 577002, India",
        "google_place_id": "ChIJ5SJianIlujsRctTGR-ENEko"
      },
      "bounds": [
        14.417557,
        75.871582,
        14.500502,
        75.961018
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "hisar",
      "name": "Hisar",
      "key": "city_hisar_v2",
      "seo_city_key": "India|Hisar",
      "customer_city": "city_hisar_v2",
      "state": "Haryana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Hisar",
        "hisar",
        "Hisar"
      ],
      "subcities": [
        "hisar"
      ],
      "city_address_hint": "4PXC+MMC Jindal tower, Malik Chowk, Old Courts Commercial Complex, Lajpat Nagar, Hisar, Haryana 125001, India",
      "url_name": "hisar",
      "country_name": "India",
      "postal_code": "125001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 29.1491875,
        "long": 75.7216527,
        "details": "4PXC+MMC Jindal tower, Malik Chowk, Old Courts Commercial Complex, Lajpat Nagar, Hisar, Haryana 125001, India",
        "google_place_id": "ChIJNwwdAdgyEjkReBGvBfENPx0"
      },
      "bounds": [
        29.105827,
        75.685158,
        29.181841,
        75.795879
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "jammu",
      "name": "Jammu",
      "key": "city_jammu_v2",
      "seo_city_key": "India|Jammu",
      "customer_city": "city_jammu_v2",
      "state": "Jammu and Kashmir",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Jammu",
        "jammu",
        "Jammu"
      ],
      "subcities": [
        "jammu"
      ],
      "city_address_hint": "PVG4+JRR, Resham Ghar Colony, Jammu, 180016",
      "url_name": "jammu",
      "country_name": "India",
      "postal_code": "180016",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 32.7266016,
        "long": 74.8570259,
        "details": "PVG4+JRR, Resham Ghar Colony, Jammu, 180016",
        "google_place_id": "ChIJJTWdFr-EHjkRjf247og0Iw8"
      },
      "bounds": [
        32.328825,
        74.138437,
        33.946442,
        75.703371
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "abudhabi",
      "name": "Abu Dhabi",
      "key": "city_abudhabi_v2",
      "seo_city_key": "united_arab_emirates|abu_dhabi",
      "customer_city": "city_abudhabi_v2",
      "state": "Abu Dhabi",
      "country_key": "UAE",
      "country_id": "UAE",
      "regex": [
        "abu dhabi",
        "??? ???",
        "al ain city",
        "al mafraq",
        "khalifah a city",
        "musaffah city"
      ],
      "subcities": [
        "Abu-Dhabi",
        "abu-dhabi",
        "abu dhabi",
        "??? ???"
      ],
      "city_address_hint": "Khalidiyah Street - Abu Dhabi - United Arab Emirates",
      "url_name": "abudhabi",
      "country_name": "UAE",
      "postal_code": "380051",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 25.1975148,
        "long": 55.2748732,
        "details": "Khalidiyah Street - Abu Dhabi - United Arab Emirates",
        "google_place_id": "ChIJO7H92gtmXj4RP0WTA_Ogr8A"
      },
      "bounds": [
        24.013185,
        54.127906,
        24.713429,
        55.088178
      ],
      "offices": [],
      "timezone": "Asia/Dubai"
    },
    {
      "is_live": true,
      "regex_key": "riyadh",
      "name": "Riyadh",
      "key": "city_riyadh_v2",
      "seo_city_key": "saudi_arabia|riyadh",
      "customer_city": "city_riyadh_v2",
      "state": "Riyadh state",
      "country_key": "KSA",
      "country_id": "KSA",
      "regex": [
        "riyadh",
        "??????",
        "az zulfi",
        "al mubarraz",
        "al kharj",
        "afif",
        "al musaybir",
        "al hazm",
        "salam"
      ],
      "subcities": [
        "Riyadh",
        "riyadh",
        "??????"
      ],
      "city_address_hint": "Kingdom Centre, Al Olaya",
      "url_name": "riyadh",
      "country_name": "KSA",
      "postal_code": "12214",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 24.71226,
        "long": 46.674214,
        "details": "Kingdom Centre, Al Olaya",
        "google_place_id": "GhIJvD_eq1a2OEARhcFGo0xWR0A"
      },
      "bounds": [
        24.230601,
        46.3727,
        25.168818,
        46.963215
      ],
      "offices": [
        {
          "name": "Riyadh Office",
          "is_live": true,
          "address": "2488, 8653, 3rd Floor, Le Cygne Commercial Center, Next to Reem Residnecy, Kaab Bin Malik, Olaya, Riyadh 12611 MMFV+RC Al Olaya, Riyadh",
          "subcities": [
            "Riyadh"
          ],
          "office_type": [
            "business"
          ],
          "location_mapping": {
            "lat": 24.674503,
            "long": 46.6935984
          }
        }
      ],
      "timezone": "Asia/Riyadh"
    },
    {
      "is_live": true,
      "regex_key": "pune",
      "name": "Pune",
      "key": "city_pune_v2",
      "seo_city_key": "india|pune",
      "customer_city": "city_pune_v2",
      "state": "Maharashtra",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "pune",
        "pimpri-chinchwad"
      ],
      "subcities": [
        "Pune",
        "pune"
      ],
      "city_address_hint": "Deccan Gymkhana, Pune",
      "url_name": "pune",
      "country_name": "India",
      "postal_code": "411045",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 18.5165009,
        "long": 73.832731,
        "details": "Deccan Gymkhana, Pune",
        "google_place_id": "ChIJfS8qMI-_wjsRZC5c1rF2ha4"
      },
      "bounds": [
        18.363324,
        73.626587,
        18.79435,
        74.081832
      ],
      "offices": [
        {
          "name": "Pune",
          "is_live": true,
          "address": "Urbanclap Technologies India Pvt Ltd, Ground, 1st, 2nd, 3rd and 4th Floor, Survey no. 15/6/29, P Square Capital, off Bangalore Highway, Baner, Pune - 411045",
          "subcities": [
            "Pune"
          ],
          "office_type": [
            "business",
            "corporate",
            "support",
            "training"
          ],
          "location_mapping": {
            "lat": 18.56292,
            "long": 73.764654
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "hyderabad",
      "name": "Hyderabad",
      "key": "city_hyderabad_v2",
      "seo_city_key": "india|hyderabad",
      "customer_city": "city_hyderabad_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "hyderabad",
        "secunderabad"
      ],
      "subcities": [
        "Hyderabad",
        "Secunderabad",
        "hyderabad",
        "secunderabad"
      ],
      "city_address_hint": "Banjara Hills, Hyderabad",
      "url_name": "hyderabad",
      "country_name": "India",
      "postal_code": "500081",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 17.4159557,
        "long": 78.4182496,
        "details": "Banjara Hills, Hyderabad",
        "google_place_id": "ChIJpTDC5yiXyzsRoMr39VKX9Qs"
      },
      "bounds": [
        17.169002,
        78.208237,
        17.658417,
        78.732834
      ],
      "offices": [
        {
          "name": "Hyderabad",
          "is_live": true,
          "address": "Trendz Enclave, First Floor, Plot No. 44, Survey no 74&75P, Block No. 1, Lane Opposite Seasons Indoor Swimming Pool, Jai Hind Colony, Madhapur - 500081",
          "subcities": [
            "Hyderabad",
            "Secunderabad"
          ],
          "office_type": [
            "corporate",
            "training",
            "business",
            "support"
          ],
          "location_mapping": {
            "lat": 17.458681,
            "long": 78.385718
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "singapore",
      "name": "Singapore",
      "key": "city_singapore_v2",
      "seo_city_key": "singapore|singapore",
      "customer_city": "city_singapore_v2",
      "state": "Singapore",
      "country_key": "SGP",
      "country_id": "SGP",
      "regex": [
        "singapore"
      ],
      "subcities": [
        "Singapore",
        "singapore"
      ],
      "city_address_hint": "Orchard Rd, Singapore",
      "url_name": "singapore",
      "country_name": "Singapore",
      "postal_code": "238857",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 1.303224,
        "long": 103.836156,
        "details": "Orchard Rd, Singapore",
        "google_place_id": "ChIJSSB81ZMZ2jERTxekeovnJv0"
      },
      "bounds": [
        1.20531,
        103.5871,
        1.49997,
        104.04475
      ],
      "offices": [
        {
          "name": "Singapore",
          "is_live": true,
          "address": "8 Burn Rd, Trivex, Singapore 369977",
          "subcities": [
            "Singapore"
          ],
          "office_type": [
            "corporate",
            "training"
          ],
          "location_mapping": {
            "lat": 1.337829,
            "long": 103.885177
          }
        }
      ],
      "timezone": "Asia/Singapore"
    },
    {
      "is_live": true,
      "regex_key": "chandigarh",
      "name": "Chandigarh Tricity",
      "key": "city_chandigarh_v2",
      "seo_city_key": "india|chandigarh",
      "customer_city": "city_chandigarh_v2",
      "state": "Punjab and Haryana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "chandigarh",
        "mohali",
        "zirakpur",
        "panchkula",
        "Sahibzada Ajit Singh",
        "sahibzada ajit singh",
        "Sahibzada Ajit Singh Nagar"
      ],
      "subcities": [
        "Chandigarh",
        "Mohali",
        "Zirakpur",
        "Panchkula",
        "Sahibzada Ajit Singh",
        "Sahibzada Ajit Singh Nagar",
        "sahibzada ajit singh",
        "chandigarh",
        "mohali",
        "zirakpur",
        "panchkula"
      ],
      "city_address_hint": "Chandigarh, India",
      "url_name": "chandigarh",
      "country_name": "India",
      "postal_code": "160022",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 30.7333148,
        "long": 76.7794179,
        "details": "Chandigarh, India",
        "google_place_id": "ChIJa8lu5gvtDzkR_hlzUvln_6U"
      },
      "bounds": [
        30.587852,
        76.5827,
        30.815279,
        76.92602
      ],
      "offices": [
        {
          "name": "Chandigarh",
          "is_live": true,
          "address": "Plot No:- 66, Phase-2, Industrial Area, Chandigarh",
          "subcities": [
            "Chandigarh",
            "Mohali",
            "Zirakpur",
            "Panchkula",
            "Sahibzada Ajit Singh",
            "Sahibzada Ajit Singh Nagar"
          ],
          "office_type": [
            "business",
            "corporate",
            "support",
            "training"
          ],
          "location_mapping": {
            "lat": 30.700561,
            "long": 76.788204
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "kota",
      "name": "Kota",
      "key": "city_kota_v2",
      "seo_city_key": "india|kota",
      "customer_city": "city_kota_v2",
      "state": "Rajasthan",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "kota",
        "Kota"
      ],
      "subcities": [
        "kota"
      ],
      "city_address_hint": "Bharat Vikas Parishad Hospital, Kota",
      "url_name": "kota",
      "country_name": "India",
      "postal_code": "324009",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 25.1624838,
        "long": 75.8292584,
        "details": "Bharat Vikas Parishad Hospital, Kota",
        "google_place_id": "ChIJwViAk8qEbzkR_1327jfqb5E"
      },
      "bounds": [
        25.112431,
        75.794086,
        25.248672,
        75.926608
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "ahmedabad",
      "name": "Ahmedabad",
      "key": "city_ahmedabad_v2",
      "seo_city_key": "india|ahmedabad",
      "customer_city": "city_ahmedabad_v2",
      "state": "Gujarat",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "ahmedabad",
        "gandhinagar"
      ],
      "subcities": [
        "Ahmedabad",
        "ahmedabad"
      ],
      "city_address_hint": "Navrangpura, Ahmedabad",
      "url_name": "ahmedabad",
      "country_name": "India",
      "postal_code": "380051",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 23.0388478,
        "long": 72.5525566,
        "details": "Navrangpura, Ahmedabad",
        "google_place_id": "ChIJSw1kIfWEXjkRa5miqZfuU2g"
      },
      "bounds": [
        22.873552,
        72.296191,
        23.336158,
        72.874408
      ],
      "offices": [
        {
          "name": "Ahmedabad",
          "is_live": true,
          "address": "UrbanCompany Technologies India Pvt Ltd 424 & 425, 4th Floor, Indraprasth Business Park, Makarba, Ahmedabad",
          "subcities": [
            "Ahmedabad"
          ],
          "office_type": [
            "business",
            "corporate",
            "support",
            "training"
          ],
          "location_mapping": {
            "lat": 22.992948,
            "long": 72.501625
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "dubai",
      "name": "Dubai",
      "key": "city_dubai_v2",
      "seo_city_key": "united_arab_emirates|dubai",
      "customer_city": "city_dubai_v2",
      "state": "Dubai",
      "country_key": "UAE",
      "country_id": "UAE",
      "regex": [
        "dubai",
        "???",
        "jumayra",
        "emirates hill second",
        "bur dubai",
        "mirdif"
      ],
      "subcities": [
        "Dubai",
        "dubai",
        "???"
      ],
      "city_address_hint": "1 Sheikh Mohammed bin Rashid Blvd - Dubai - United Arab Emirates",
      "url_name": "dubai",
      "country_name": "UAE",
      "postal_code": "380051",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 25.1975148,
        "long": 55.2748732,
        "details": "1 Sheikh Mohammed bin Rashid Blvd - Dubai - United Arab Emirates",
        "google_place_id": "ChIJ2Y-H54FCXz4R2gdP3D5Mk24"
      },
      "bounds": [
        24.85799,
        54.97693,
        25.29843,
        55.62406
      ],
      "offices": [
        {
          "name": "UAE",
          "is_live": true,
          "address": "# 2101, Indigo Icon Tower, Cluster F, Jumeirah Lake Towers (JLT), Dubai",
          "subcities": [
            "Dubai"
          ],
          "office_type": [
            "business",
            "corporate",
            "support",
            "training"
          ],
          "location_mapping": {
            "lat": 25.075416,
            "long": 55.145625
          }
        }
      ],
      "timezone": "Asia/Dubai"
    },
    {
      "is_live": true,
      "regex_key": "thiruvananthapuram",
      "name": "Thiruvananthapuram",
      "key": "city_thiruvananthapuram_v2",
      "seo_city_key": "india|thiruvananthapuram",
      "customer_city": "city_thiruvananthapuram_v2",
      "state": "Kerala",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "thiruvananthapuram",
        "Thiruvananthapuram",
        "Trivandrum",
        "trivandrum"
      ],
      "subcities": [
        "thiruvananthapuram",
        "Thiruvananthapuram",
        "Trivandrum",
        "trivandrum"
      ],
      "city_address_hint": "FXQ3+35J, Thampanoor, Thiruvananthapuram, Kerala 695014, India",
      "url_name": "thiruvananthapuram",
      "country_name": "India",
      "postal_code": "695014",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 8.487486,
        "long": 76.952868,
        "details": "FXQ3+35J, Thampanoor, Thiruvananthapuram, Kerala 695014, India",
        "google_place_id": "ChIJRWIgqqi7BTsRnwu3kfhXzE4"
      },
      "bounds": [
        8.293807,
        76.691403,
        8.792803,
        77.270936
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "madurai",
      "name": "Madurai",
      "key": "city_madurai_v2",
      "seo_city_key": "india|madurai",
      "customer_city": "city_madurai_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "madurai",
        "Madurai"
      ],
      "subcities": [
        "madurai"
      ],
      "url_name": "madurai",
      "country_name": "India",
      "postal_code": "625001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 9.920873,
        "long": 78.112276,
        "details": "Hotel Supreme, Madurai",
        "google_place_id": "ChIJhUS6dIfFADsR6QNqZJ1JR88110"
      },
      "bounds": [
        9.37954,
        77.79542,
        10.23206,
        78.54798
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "amritsar",
      "name": "Amritsar",
      "key": "city_amritsar_v2",
      "seo_city_key": "india|amritsar",
      "customer_city": "city_amritsar_v2",
      "state": "Punjab",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "amritsar",
        "Amritsar"
      ],
      "subcities": [
        "amritsar"
      ],
      "url_name": "amritsar",
      "country_name": "India",
      "postal_code": "143001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 31.6334677,
        "long": 74.7300352,
        "details": "Golden Temple, Amritsar",
        "google_place_id": "ChIJZwBQLlRjGTkR-6tJnPwIHAc"
      },
      "bounds": [
        31.57382,
        74.61953,
        31.70663,
        75.00954
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "gwalior",
      "name": "Gwalior",
      "key": "city_gwalior_v2",
      "seo_city_key": "india|gwalior",
      "customer_city": "city_gwalior_v2",
      "state": "Madhya Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "gwalior",
        "Gwalior"
      ],
      "subcities": [
        "gwalior"
      ],
      "url_name": "gwalior",
      "country_name": "India",
      "postal_code": "474007",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 26.214088,
        "long": 78.0508127,
        "details": "Gwalior Zoo,’Gwalior",
        "google_place_id": "ChIJqejUwSfEdjkRSqfBwqi0lFA"
      },
      "bounds": [
        26.17419,
        78.11713,
        26.31238,
        78.2808
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "prayagraj",
      "name": "Prayagraj",
      "key": "city_prayagraj_v2",
      "seo_city_key": "india|prayagraj",
      "customer_city": "city_prayagraj_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "prayagraj",
        "allahabad",
        "ilahabad"
      ],
      "subcities": [
        "prayagraj"
      ],
      "url_name": "prayagraj",
      "country_name": "India",
      "postal_code": "211003",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 25.4021974,
        "long": 81.6614982,
        "details": "Prayagraj Fort, Allahabad",
        "google_place_id": "ChIJu0-pK65KhTkRUgI4wRKJMno"
      },
      "bounds": [
        25.14819,
        81.66409,
        25.59737,
        81.97308
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "jabalpur",
      "name": "Jabalpur",
      "key": "city_jabalpur_v2",
      "seo_city_key": "india|jabalpur",
      "customer_city": "city_jabalpur_v2",
      "state": "Madhya Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "jabalpur",
        "jubbulpore"
      ],
      "subcities": [
        "jabalpur",
        "Jabalpur"
      ],
      "url_name": "jabalpur",
      "country_name": "India",
      "postal_code": "482009",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 23.1758374,
        "long": 79.8987131,
        "details": "Nehru Park",
        "google_place_id": "ChIJfam2DxqugTkRueNDvBYGAkQ"
      },
      "bounds": [
        23.00929,
        79.807,
        23.34345,
        80.07811
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "ludhiana",
      "name": "Ludhiana",
      "key": "city_ludhiana_v2",
      "seo_city_key": "india|ludhiana",
      "customer_city": "city_ludhiana_v2",
      "state": "Punjab",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "ludhiana"
      ],
      "subcities": [
        "Ludhiana",
        "ludhiana"
      ],
      "city_address_hint": "Sarabha Nagar",
      "url_name": "ludhiana",
      "country_name": "India",
      "postal_code": "141401",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 30.89274,
        "long": 75.81882,
        "details": "Sarabha Nagar, Ludhiana",
        "google_place_id": "ChIJtWw19tGDGjkRpQwYst-1eHg"
      },
      "bounds": [
        30.82956,
        75.75622,
        30.95256,
        75.97234
      ],
      "offices": [
        {
          "name": "Ludhiana",
          "is_live": true,
          "address": "3rd floor, Bedi Electronics World, Ferozepur Road, Bhai Bala Chowk, Civil Lines, Ludhiana - 141001",
          "subcities": [
            "ludhiana"
          ],
          "office_type": [
            "business",
            "corporate",
            "support",
            "training"
          ],
          "location_mapping": {
            "lat": 30.89274,
            "long": 75.81882
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "karnal",
      "name": "Karnal",
      "key": "city_karnal_v2",
      "seo_city_key": "india|panipat",
      "customer_city": "city_karnal_v2",
      "state": "Haryana",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "karnal",
        "Karnal"
      ],
      "subcities": [
        "karnal"
      ],
      "url_name": "karnal",
      "country_name": "India",
      "postal_code": "132001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 29.68692,
        "long": 76.98641,
        "details": "Karan Taal Park, Karnal",
        "google_place_id": "ChIJhap4lONxDjkRKIatmdUsqdY"
      },
      "bounds": [
        29.58041,
        76.8509,
        29.78323,
        77.13002
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "jamshedpur",
      "name": "Jamshedpur",
      "key": "city_jamshedpur_v2",
      "seo_city_key": "india|jamshedpur",
      "customer_city": "city_jamshedpur_v2",
      "state": "Jharkhand",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "jamshedpur",
        "tatanagar"
      ],
      "subcities": [
        "jamshedpur",
        "Jamshedpur"
      ],
      "url_name": "jamshedpur",
      "country_name": "India",
      "postal_code": "831001",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 22.7838999,
        "long": 86.1740702,
        "details": "Parvati Ghat",
        "google_place_id": "ChIJteLwiRnj9TkRRLPpHOjI7g4"
      },
      "bounds": [
        22.63453,
        86.06733,
        22.90679,
        86.37765
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "ranchi",
      "name": "Ranchi",
      "key": "city_ranchi_v2",
      "seo_city_key": "india|ranchi",
      "customer_city": "city_ranchi_v2",
      "state": "Jharkhand",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "ranchi"
      ],
      "subcities": [
        "ranchi"
      ],
      "url_name": "ranchi",
      "country_name": "India",
      "postal_code": "834002",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 23.3431425,
        "long": 85.1812392,
        "details": "Ashok Nagar",
        "google_place_id": "ChIJ3bddqgTh9DkRPvSZaJ3UCdw"
      },
      "bounds": [
        23.12168,
        85.14897,
        23.53592,
        85.42981
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "jaipur",
      "name": "Jaipur",
      "key": "city_jaipur_v2",
      "seo_city_key": "india|jaipur",
      "customer_city": "city_jaipur_v2",
      "state": "Rajasthan",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "jaipur"
      ],
      "subcities": [
        "Jaipur",
        "jaipur"
      ],
      "city_address_hint": "eg. Ashok Nagar, Jaipur",
      "url_name": "jaipur",
      "country_name": "India",
      "postal_code": "302005",
      "is_hindi_city": true,
      "location_mapping": {
        "lat": 26.91617,
        "long": 75.77752,
        "details": "Ashok Nagar, Jaipur",
        "google_place_id": "ChIJwZvVDqq2bTkRQKrJ2WRMAJQ"
      },
      "bounds": [
        26.738379,
        75.622975,
        27.029072,
        75.954401
      ],
      "offices": [
        {
          "name": "Jaipur",
          "is_live": true,
          "address": "Urbanclap Technologies India Pvt Ltd C-123, First floor, Janpath, Lalkothi (Opposite Jyoti Nagar Police station), Jaipur (302005)",
          "subcities": [
            "Jaipur"
          ],
          "office_type": [
            "corporate",
            "training",
            "business",
            "support"
          ],
          "location_mapping": {
            "lat": 26.891634,
            "long": 75.794923
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "jeddah",
      "name": "Jeddah",
      "key": "city_jeddah_v2",
      "seo_city_key": "saudi_arabia|jeddah",
      "customer_city": "city_jeddah_v2",
      "state": "Jeddah state",
      "country_key": "KSA",
      "country_id": "KSA",
      "regex": [
        "jeddah",
        "جدة"
      ],
      "subcities": [
        "Jeddah",
        "jeddah",
        "جدة"
      ],
      "city_address_hint": "eg. Al Faisaliyyah",
      "url_name": "jeddah",
      "country_name": "KSA",
      "postal_code": "23444",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 21.571111,
        "long": 39.187716,
        "details": "World of Saving, Prince Saud Al Faisal",
        "google_place_id": "ChIJnc1CWFDQwxURN0vSStLYS5M"
      },
      "bounds": [
        21.011638,
        38.869166,
        21.945611,
        39.518333
      ],
      "offices": [],
      "timezone": "Asia/Riyadh"
    },
    {
      "is_live": true,
      "regex_key": "bhopal",
      "name": "Bhopal",
      "key": "city_bhopal_v2",
      "seo_city_key": "india|bhopal",
      "customer_city": "city_bhopal_v2",
      "state": "Madhya Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "bhopal"
      ],
      "subcities": [
        "bhopal",
        "Bhopal"
      ],
      "city_address_hint": "Jinsi Circle",
      "url_name": "bhopal",
      "country_name": "India",
      "postal_code": "462010",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 23.2494,
        "long": 77.4173,
        "details": "Jinsi Circle",
        "google_place_id": "ChIJvY_Wj49CfDkR-NRy1RZXFQI"
      },
      "bounds": [
        23.1279,
        77.08323,
        23.40533,
        77.5403
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "guwahati",
      "name": "Guwahati",
      "key": "city_guwahati_v2",
      "seo_city_key": "india|guwahati",
      "customer_city": "city_guwahati_v2",
      "state": "Assam",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "guwahati"
      ],
      "subcities": [
        "guwahati",
        "Guwahati"
      ],
      "city_address_hint": "GS Road",
      "url_name": "guwahati",
      "country_name": "India",
      "postal_code": "781006",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 26.148,
        "long": 91.7313,
        "details": "GS Road"
      },
      "bounds": [
        26.01929,
        91.56498,
        26.31717,
        91.88071
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "varanasi",
      "name": "Varanasi",
      "key": "city_varanasi_v2",
      "seo_city_key": "india|varanasi",
      "customer_city": "city_varanasi_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Varanasi",
        "Banaras",
        "varanasi",
        "banaras"
      ],
      "subcities": [
        "Varanasi",
        "Banaras",
        "varanasi",
        "banaras"
      ],
      "city_address_hint": "Varanasi Junction",
      "url_name": "varanasi",
      "country_name": "India",
      "postal_code": "221002",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 25.3268,
        "long": 82.9863,
        "details": "Varanasi Junction"
      },
      "bounds": [
        25.0949,
        82.84908,
        25.47825,
        83.13583
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "coimbatore",
      "name": "Coimbatore",
      "key": "city_coimbatore_v2",
      "seo_city_key": "india|coimbatore",
      "customer_city": "city_coimbatore_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "coimbatore",
        "covai"
      ],
      "subcities": [
        "coimbatore",
        "Coimbatore",
        "Covai",
        "covai"
      ],
      "city_address_hint": "Gandhipuram",
      "url_name": "coimbatore",
      "country_name": "India",
      "postal_code": "641012",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 11.0176,
        "long": 76.9674,
        "details": "Gandhipuram"
      },
      "bounds": [
        10.9191473,
        76.8556653,
        11.154287,
        77.078277
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "surat",
      "name": "Surat",
      "key": "city_surat_v2",
      "seo_city_key": "india|surat",
      "customer_city": "city_surat_v2",
      "state": "Gujarat",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "surat"
      ],
      "subcities": [
        "Surat",
        "surat"
      ],
      "city_address_hint": "eg. Athwa Gate",
      "url_name": "surat",
      "country_name": "India",
      "postal_code": "395003",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 21.18589,
        "long": 76.7794179,
        "details": "Athwa Gate, Surat",
        "google_place_id": "ChIJ5wmyqHBO4DsRVlAXm_9D-ZU"
      },
      "bounds": [
        21.06519,
        72.70968,
        21.27585,
        72.96443
      ],
      "offices": [
        {
          "name": "Surat",
          "is_live": true,
          "address": "318, 3rd Floor, Exult Shoppers, Nr. Siddhivinayak Temple, Vesu Main Road, Surat, Gujarat 395007",
          "subcities": [
            "Surat"
          ],
          "office_type": [
            "corporate"
          ],
          "location_mapping": {
            "lat": 21.18589,
            "long": 76.7794179
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "agra",
      "name": "Agra",
      "key": "city_agra_v2",
      "seo_city_key": "india|agra",
      "customer_city": "city_agra_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "Agra",
        "agra"
      ],
      "subcities": [
        "Agra",
        "agra"
      ],
      "city_address_hint": "Sanjay Place",
      "url_name": "agra",
      "country_name": "India",
      "postal_code": "282002",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 27.1987,
        "long": 78.006,
        "details": "Sanjay Place",
        "google_place_id": "ChIJ2UEvfIUNdDkRQjtSqTjvSng"
      },
      "bounds": [
        27.1024,
        77.8746,
        27.2365,
        78.0909
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "kanpur",
      "name": "Kanpur",
      "key": "city_kanpur_v2",
      "seo_city_key": "india|kanpur",
      "customer_city": "city_kanpur_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "kanpur"
      ],
      "subcities": [
        "Kanpur",
        "kanpur"
      ],
      "city_address_hint": "eg. Tilak Nagar",
      "url_name": "kanpur",
      "country_name": "India",
      "postal_code": "208001",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 26.490931,
        "long": 80.323517,
        "details": "Tilak Nagar, Kanpur",
        "google_place_id": "ChIJ54o0gF84nDkRhC4NbwJdAkc"
      },
      "bounds": [
        26.35406,
        80.10806,
        26.60343,
        80.44092
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "kochi",
      "name": "Kochi",
      "key": "city_kochi_v2",
      "seo_city_key": "india|kochi",
      "customer_city": "city_kochi_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "kochi",
        "cochin"
      ],
      "subcities": [
        "kochi",
        "Kochi",
        "cochin"
      ],
      "city_address_hint": "Kochi Post Office",
      "url_name": "kochi",
      "country_name": "India",
      "postal_code": "682016",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 9.9671,
        "long": 76.3031,
        "details": "Kochi Post Office"
      },
      "bounds": [
        9.24619,
        76.21739,
        10.32654,
        76.43455
      ],
      "offices": [],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "lucknow",
      "name": "Lucknow",
      "key": "city_lucknow_v2",
      "seo_city_key": "india|lucknow",
      "customer_city": "city_lucknow_v2",
      "state": "Uttar Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "lucknow"
      ],
      "subcities": [
        "Lucknow",
        "lucknow"
      ],
      "city_address_hint": "eg. Gomti Nagar",
      "url_name": "lucknow",
      "country_name": "India",
      "postal_code": "226004",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 26.851311,
        "long": 81.012421,
        "details": "Gomti Nagar, Lucknow",
        "google_place_id": "ChIJQ6hg_En9mzkRaj9im-Fy_JI"
      },
      "bounds": [
        26.65993,
        80.74154,
        27.03848,
        81.23976
      ],
      "offices": [
        {
          "name": "Lucknow",
          "is_live": true,
          "address": "3rd Floor, Eldeco corporate chamber 1, Vibhuti khand, Gomti Nagar, Lucknow - 226010",
          "subcities": [
            "Lucknow"
          ],
          "office_type": [
            "corporate",
            "training",
            "business",
            "support"
          ],
          "location_mapping": {
            "lat": 26.859022,
            "long": 80.98721
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "visakhapatnam",
      "name": "Visakhapatnam",
      "key": "city_vishakapatnam_v2",
      "seo_city_key": "india|visakhapatnam",
      "customer_city": "city_vishakapatnam_v2",
      "state": "Andhra Pradesh",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "visakhapatnam"
      ],
      "subcities": [
        "Visakhapatnam",
        "visakhapatnam"
      ],
      "city_address_hint": "Kailasapuram",
      "url_name": "visakhapatnam",
      "country_name": "India",
      "postal_code": "530016",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 17.73931,
        "long": 83.28939,
        "details": "Kailasapuram, Visakhapatnam",
        "google_place_id": "ChIJLT1ujypDOToRtHNiUeVQRIo"
      },
      "bounds": [
        17.56489,
        83.03943,
        17.9254,
        83.48025
      ],
      "offices": [
        {
          "name": "Visakhapatnam",
          "is_live": true,
          "address": "3rd floor, Front Side, Grand Palace, Dwarka Nagar, Vishakapatnam",
          "subcities": [
            "Visakhapatnam"
          ],
          "office_type": [
            "business",
            "corporate",
            "support",
            "training"
          ],
          "location_mapping": {
            "lat": 17.72608,
            "long": 83.305394
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    },
    {
      "is_live": true,
      "regex_key": "chennai",
      "name": "Chennai",
      "key": "city_chennai_v2",
      "seo_city_key": "india|chennai",
      "customer_city": "city_chennai_v2",
      "state": "Tamil Nadu",
      "country_key": "IND",
      "country_id": "IND",
      "regex": [
        "chennai",
        "madras"
      ],
      "subcities": [
        "Chennai",
        "chennai"
      ],
      "city_address_hint": "eg. Sector A, Anna Nagar West Extension",
      "url_name": "chennai",
      "country_name": "India",
      "postal_code": "600032",
      "is_hindi_city": false,
      "location_mapping": {
        "lat": 13.0610943,
        "long": 80.2343035,
        "details": "Nungambakkam, Chennai",
        "google_place_id": "ChIJvzjXp2dmUjoRIkQgNnWVB_c"
      },
      "bounds": [
        12.810792,
        80.030689,
        13.1958275,
        80.3217316
      ],
      "offices": [
        {
          "name": "Chennai",
          "is_live": true,
          "address": "C 32 A Cipet Road, Thiru Vi Ka Industrial Estate, SIDCO Industrial Estate, Guindy, Chennai, Tamil Nadu - 600032",
          "subcities": [
            "Chennai"
          ],
          "office_type": [
            "business",
            "corporate",
            "support",
            "training"
          ],
          "location_mapping": {
            "lat": 13.012201,
            "long": 80.208527
          }
        }
      ],
      "timezone": "Asia/Kolkata"
    }
  ],
  "countries": [
    {
      "is_country_live": true,
      "isd_code": "+966",
      "isd_code_int": 966,
      "phone_validation": {
        "number_length": [
          9
        ]
      },
      "country_key": "KSA",
      "country_id": "KSA",
      "iso_code": "SA",
      "country_name": "KSA",
      "distance_unit": "Km",
      "display_name": "Saudi Arabia",
      "google_country_filter": "SA",
      "locale": "en_US",
      "currency_code": "SAR",
      "currency_code_symbol": "SAR",
      "tz": "Asia/Riyadh",
      "country_flag": {
        "low_res": "/t_low_res_template",
        "medium_res": "/t_medium_res_template",
        "high_res": "/t_high_res_template",
        "s3_path": "/images/growth/home-screen/1612361663672-94027b.png",
        "base_url": "https://res.cloudinary.com/urbanclap/image/upload",
        "thumb": {
          "low_res": "/t_low_res_portfolio_thumb,q_auto:low,f_auto",
          "medium_res": "/t_medium_res_portfolio_thumb,q_auto:low,f_auto",
          "high_res": "/t_high_res_portfolio_thumb,q_auto:low,f_auto"
        },
        "medium": {
          "low_res": "/t_low_res_portfolio_medium,q_auto:low,f_auto",
          "medium_res": "/t_medium_res_portfolio_medium,q_auto:low,f_auto",
          "high_res": "/t_high_res_portfolio_medium,q_auto:low,f_auto"
        }
      },
      "company_details": {
        "legal_name": "Urban Company Arabia for Information Technology",
        "name": "Urban Company",
        "domain_name": "www.urbancompany.com",
        "logo": ""
      },
      "customer_supported_languages": {
        "default_language": {
          "code": "en",
          "key": "english",
          "value": "English"
        },
        "supported_languages": [
          {
            "code": "en",
            "key": "english",
            "value": "English"
          },
          {
            "code": "ar",
            "key": "arabic",
            "value": "Arabic"
          }
        ]
      },
      "provider_supported_languages": {
        "default_language": {
          "code": "en",
          "key": "english",
          "value": "English"
        },
        "supported_languages": [
          {
            "code": "en",
            "key": "english",
            "value": "English"
          },
          {
            "code": "ar",
            "key": "arabic",
            "value": "Arabic"
          }
        ]
      },
      "login_sources": [
        {
          "name": "otp",
          "skip_email": false,
          "skip_name": false
        },
        {
          "name": "otp_without_email",
          "skip_email": true,
          "skip_name": true
        },
        {
          "name": "truecaller",
          "skip_email": false,
          "skip_name": false
        },
        {
          "name": "otp_with_email",
          "skip_email": false,
          "skip_name": true,
          "min_version": {
            "android": "7.2.01",
            "ios": "3.85"
          }
        }
      ],
      "brands_active": [
        "urbanCompany",
        "yammak"
      ]
    },
    {
      "is_country_live": true,
      "isd_code": "+91",
      "isd_code_int": 91,
      "phone_validation": {
        "number_length": [
          10
        ]
      },
      "country_key": "IND",
      "country_id": "IND",
      "iso_code": "IN",
      "country_name": "India",
      "distance_unit": "Km",
      "display_name": "India",
      "google_country_filter": "IN",
      "locale": "en_IN",
      "currency_code": "Rs.",
      "currency_code_symbol": "₹",
      "tz": "Asia/Kolkata",
      "country_flag": {
        "low_res": "/t_low_res_template",
        "medium_res": "/t_medium_res_template",
        "high_res": "/t_high_res_template",
        "s3_path": "/images/supply/partner-app-supply/1661338258375-6c99b1.png",
        "base_url": "https://res.cloudinary.com/urbanclap/image/upload",
        "thumb": {
          "low_res": "/t_low_res_portfolio_thumb,q_auto:low,f_auto",
          "medium_res": "/t_medium_res_portfolio_thumb,q_auto:low,f_auto",
          "high_res": "/t_high_res_portfolio_thumb,q_auto:low,f_auto"
        },
        "medium": {
          "low_res": "/t_low_res_portfolio_medium,q_auto:low,f_auto",
          "medium_res": "/t_medium_res_portfolio_medium,q_auto:low,f_auto",
          "high_res": "/t_high_res_portfolio_medium,q_auto:low,f_auto"
        }
      },
      "company_details": {
        "legal_name": "UrbanClap Technologies India Pvt. Ltd.",
        "name": "Urban Company",
        "domain_name": "www.urbancompany.com",
        "logo": ""
      },
      "customer_supported_languages": {
        "default_language": {
          "code": "en",
          "key": "english",
          "value": "English"
        },
        "supported_languages": [
          {
            "code": "en",
            "key": "english",
            "value": "English"
          }
        ]
      },
      "provider_supported_languages": {
        "default_language": {
          "code": "en",
          "key": "english",
          "value": "English"
        },
        "supported_languages": [
          {
            "code": "en",
            "key": "english",
            "value": "English"
          }
        ]
      },
      "login_sources": [
        {
          "name": "otp",
          "skip_email": false,
          "skip_name": false
        },
        {
          "name": "otp_without_email",
          "skip_email": true,
          "skip_name": true
        },
        {
          "name": "truecaller",
          "skip_email": false,
          "skip_name": false
        }
      ],
      "brands_active": [
        "urbanCompany"
      ]
    },
    {
      "is_country_live": true,
      "isd_code": "+971",
      "isd_code_int": 971,
      "phone_validation": {
        "number_length": [
          9
        ]
      },
      "country_key": "UAE",
      "country_id": "UAE",
      "iso_code": "AE",
      "country_name": "UAE",
      "distance_unit": "Km",
      "display_name": "United Arab Emirates",
      "google_country_filter": "AE",
      "locale": "en_IN",
      "currency_code": "AED",
      "currency_code_symbol": "AED",
      "tz": "Asia/Dubai",
      "country_flag": {
        "low_res": "/t_low_res_template",
        "medium_res": "/t_medium_res_template",
        "high_res": "/t_high_res_template",
        "s3_path": "/images/growth/home-screen/1661338391105-ee4996.png",
        "base_url": "https://res.cloudinary.com/urbanclap/image/upload",
        "thumb": {
          "low_res": "/t_low_res_portfolio_thumb,q_auto:low,f_auto",
          "medium_res": "/t_medium_res_portfolio_thumb,q_auto:low,f_auto",
          "high_res": "/t_high_res_portfolio_thumb,q_auto:low,f_auto"
        },
        "medium": {
          "low_res": "/t_low_res_portfolio_medium,q_auto:low,f_auto",
          "medium_res": "/t_medium_res_portfolio_medium,q_auto:low,f_auto",
          "high_res": "/t_high_res_portfolio_medium,q_auto:low,f_auto"
        }
      },
      "company_details": {
        "legal_name": "UrbanClap Technologies DMCC",
        "name": "Urban Company",
        "domain_name": "www.urbancompany.com",
        "logo": ""
      },
      "customer_supported_languages": {
        "default_language": {
          "code": "en",
          "key": "english",
          "value": "English"
        },
        "supported_languages": [
          {
            "code": "en",
            "key": "english",
            "value": "English"
          },
          {
            "code": "ar",
            "key": "arabic",
            "value": "Arabic"
          }
        ]
      },
      "provider_supported_languages": {
        "default_language": {
          "code": "en",
          "key": "english",
          "value": "English"
        },
        "supported_languages": [
          {
            "code": "en",
            "key": "english",
            "value": "English"
          },
          {
            "code": "ar",
            "key": "arabic",
            "value": "Arabic"
          }
        ]
      },
      "login_sources": [
        {
          "name": "otp",
          "skip_email": false,
          "skip_name": false
        },
        {
          "name": "otp_without_email",
          "skip_email": true,
          "skip_name": true
        },
        {
          "name": "truecaller",
          "skip_email": false,
          "skip_name": false
        },
        {
          "name": "otp_with_email",
          "skip_email": false,
          "skip_name": true,
          "min_version": {
            "android": "7.2.01",
            "ios": "3.85"
          }
        }
      ],
      "consent_context": {
        "consent_type": "Explicit",
        "allowed_modes": [
          "Sms",
          "Email"
        ],
        "mandatory_modes": [
          "Sms"
        ]
      },
      "brands_active": [
        "urbanCompany"
      ]
    },
    {
      "is_country_live": true,
      "isd_code": "+65",
      "isd_code_int": 65,
      "phone_validation": {
        "number_length": [
          8
        ]
      },
      "country_key": "SGP",
      "country_id": "SGP",
      "iso_code": "SG",
      "country_name": "Singapore",
      "distance_unit": "Km",
      "display_name": "Singapore",
      "google_country_filter": "SG",
      "locale": "en_SG",
      "currency_code": "SGD",
      "currency_code_symbol": "S$",
      "tz": "Asia/Singapore",
      "country_flag": {
        "low_res": "/t_low_res_template",
        "medium_res": "/t_medium_res_template",
        "high_res": "/t_high_res_template",
        "s3_path": "/categories/category_v2/category_03847930.png",
        "base_url": "https://res.cloudinary.com/urbanclap/image/upload",
        "thumb": {
          "low_res": "/t_low_res_portfolio_thumb,q_auto:low,f_auto",
          "medium_res": "/t_medium_res_portfolio_thumb,q_auto:low,f_auto",
          "high_res": "/t_high_res_portfolio_thumb,q_auto:low,f_auto"
        },
        "medium": {
          "low_res": "/t_low_res_portfolio_medium,q_auto:low,f_auto",
          "medium_res": "/t_medium_res_portfolio_medium,q_auto:low,f_auto",
          "high_res": "/t_high_res_portfolio_medium,q_auto:low,f_auto"
        }
      },
      "company_details": {
        "legal_name": "Urban Home Experts Pvt Ltd",
        "name": "Urban Company",
        "domain_name": "www.urbancompany.com",
        "logo": ""
      },
      "customer_supported_languages": {
        "default_language": {
          "code": "en",
          "key": "english",
          "value": "English"
        },
        "supported_languages": [
          {
            "code": "en",
            "key": "english",
            "value": "English"
          }
        ]
      },
      "provider_supported_languages": {
        "default_language": {
          "code": "en",
          "key": "english",
          "value": "English"
        },
        "supported_languages": [
          {
            "code": "en",
            "key": "english",
            "value": "English"
          }
        ]
      },
      "login_sources": [
        {
          "name": "otp",
          "skip_email": false,
          "skip_name": false
        },
        {
          "name": "otp_without_email",
          "skip_email": true,
          "skip_name": true
        },
        {
          "name": "truecaller",
          "skip_email": false,
          "skip_name": false
        },
        {
          "name": "otp_with_email",
          "skip_email": false,
          "skip_name": true,
          "min_version": {
            "android": "7.2.01",
            "ios": "3.85"
          }
        }
      ],
      "consent_context": {
        "consent_type": "ExplicitOptIn",
        "allowed_modes": [
          "Sms",
          "Email"
        ],
        "mandatory_modes": [
          "Sms"
        ]
      },
      "brands_active": [
        "urbanCompany"
      ]
    }
  ],
  "excludedGoogleIds": [
    "ChIJWzUAEOAZDTkR1wJwaxHAI4A",
    "ChIJ1XnUY9LxDDkR-Hxcc4Zexh4",
    "ChIJq4D3exr9DDkR5qdgIcEHMA0",
    "ChIJHVLRKDKEXjkRfnKeB6HNMhg",
    "ChIJ03AFdA_9DDkRuW2vyViPeAs",
    "ChIJ72ppYKZpEDkRaxAVduWJxzs",
    "ChIJLbZ-NFv9DDkRzk0gTkm3wlI",
    "ChIJL_P_CXMEDTkRw0ZdG-0GVvw",
    "ChIJSdRbuoqEXjkRFmVPYRHdzk8",
    "ChIJbU60yXAWrjsR4E9-UejD3_g",
    "ChIJa8lu5gvtDzkR_hlzUvln_6U",
    "ChIJV7ei1m6TDzkR8EAbBtdohok",
    "ChIJH_imbZDuDzkR2AjlbPGYKVE",
    "ChIJYTN9T-plUjoRM9RjaAunYW4",
    "ChIJx9Lr6tqZyzsRwvu6koO3k64",
    "ChIJgeJXTN9KbDkRCS7yDDrG4Qw",
    "ChIJZ_YISduC-DkRvCxsj-Yw40M",
    "ChIJwe1EZjDG5zsRaYxkjY_tpF0",
    "ChIJARFGZy6_wjsRQ-Oenb9DjYI",
    "ChIJWYjjgtUZDTkRHkvG5ehfzwI",
    "ChIJRcbZaklDXz4RYlEphFBu5r0",
    "ChIJufI-cg9EXj4RCBGXQZMuzMc",
    "ChIJE68fo6XA1DsRKz670AZ9sxk",
    "ChIJfVo0YnSDGjkREAbGjjQCEWg",
    "ChIJP5fmiRNDOToRaIRJlQPC2ZI",
    "ChIJq92jkavIXzkRuD9H4b_TOaw",
    "ChIJa7EyH5n9mzkR54uXCYm6zJM",
    "ChIJb8QnsXBHnDkRQXu-nyoweBc",
    "ChIJYxUdQVlO4DsRQrA4CSlYRf4",
    "ChIJ2w1BG638YjkR9EBiNdrEbgk",
    "ChIJv8a-SlENCDsRkkGEpcqC1Qs",
    "ChIJpQoX1dIJGToRqD-zaCsOWPw"
  ],
  "companyInfo": {
    "default": {
      "name": "Urban Company",
      "legal_name": "Urban Company Technologies Inc.",
      "logo": "",
      "domain_name": "www.urbancompany.com"
    },
    "KSA": {
      "legal_name": "Urban Company Arabia for Information Technology",
      "name": "Urban Company",
      "domain_name": "www.urbancompany.com",
      "logo": ""
    },
    "USA": {
      "legal_name": "Urban Company Technologies Inc.",
      "name": "Urban Company",
      "domain_name": "www.urbancompany.com",
      "logo": ""
    },
    "AUS": {
      "legal_name": "Urban Home Experts Pvt Ltd",
      "name": "Urban Company",
      "domain_name": "www.urbancompany.com",
      "logo": ""
    },
    "IND": {
      "legal_name": "UrbanClap Technologies India Pvt. Ltd.",
      "name": "Urban Company",
      "domain_name": "www.urbancompany.com",
      "logo": ""
    },
    "UAE": {
      "legal_name": "UrbanClap Technologies DMCC",
      "name": "Urban Company",
      "domain_name": "www.urbancompany.com",
      "logo": ""
    },
    "SGP": {
      "legal_name": "Urban Home Experts Pvt Ltd",
      "name": "Urban Company",
      "domain_name": "www.urbancompany.com",
      "logo": ""
    }
  },
  "brandConfig": [
    {
      "_id": "67e0fc2c8148170024c73609",
      "key": "yammak",
      "names": {
        "short": "Yammak",
        "legal": "Waed Khadmat Al-Munzal For Marketing",
        "default": "Yammak"
      },
      "logos": {
        "default": "https://images.urbanclap.com/image/upload/images/growth/home-screen/1741165365142-485c17.jpeg",
        "short": "https://images.urbanclap.com/image/upload/images/growth/home-screen/1741165365142-485c17.jpeg",
        "inverted": "https://images.urbanclap.com/image/upload/images/growth/home-screen/1741165365142-485c17.jpeg"
      },
      "createdAt": "2025-03-24T06:31:08.922Z",
      "updatedAt": "2025-03-24T06:31:08.922Z",
      "__v": 0,
      "common": {
        "links": {
          "termsAndConditions": "https://www.yammak.com/terms"
        }
      },
      "app": {
        "ios": {
          "appAssetIds": {
            "brandLogo": "yammakBrandLogo",
            "splashScreen": "JVSmascoLaunchScreen"
          },
          "appIconId": {
            "debug": "SmascoAppIconDebug",
            "release": "SmascoAppIcon"
          },
          "appName": {
            "debug": "YammakDebug",
            "release": "YammakRelease"
          },
          "appPackageId": "com.jvmasco.customer",
          "thirdPartyTokens": {
            "crashlyticsAPIKey": "bsass121",
            "otpAutoReadHash": null
          }
        },
        "android": {
          "appAssetIds": {
            "brandLogo": null,
            "splashScreen": "splash"
          },
          "appIconId": {
            "debug": "ic_launcher",
            "release": "ic_launcher"
          },
          "appName": {
            "debug": "YAMMAK",
            "release": "YAMMAK"
          },
          "appPackageId": null,
          "thirdPartyTokens": {
            "crashlyticsAPIKey": null,
            "otpAutoReadHash": "Z6mBFFzeBFz"
          }
        }
      },
      "web": {
        "domain": "www.yammak.com"
      }
    },
    {
      "_id": "67e0fcbf7fe9a700272bf57a",
      "key": "urbanCompany",
      "names": {
        "short": "UC",
        "legal": "Urban Company Ltd.",
        "default": "Urban Company"
      },
      "logos": {
        "default": "https://images.urbanclap.com/image/upload/images/growth/home-screen/1687285683825-e6cf23.jpeg",
        "short": "https://images.urbanclap.com/image/upload/images/growth/home-screen/1688650021762-cc2e3d.jpeg",
        "inverted": "https://images.urbanclap.com/image/upload/images/growth/home-screen/1631097450980-d2de38.png"
      },
      "createdAt": "2025-03-24T06:33:35.648Z",
      "updatedAt": "2025-04-02T03:58:43.441Z",
      "__v": 0,
      "common": {
        "links": {
          "termsAndConditions": "https://www.urbancompany.com/terms"
        }
      },
      "app": {
        "ios": {
          "appAssetIds": {
            "brandLogo": "urban_company_new_logo",
            "splashScreen": "Launch Screen"
          },
          "appIconId": {
            "debug": "AppIconDebug",
            "release": "AppIcon"
          },
          "appName": {
            "debug": "Urban Company",
            "release": "Urban Company"
          },
          "appPackageId": "com.urbanclap.customer",
          "thirdPartyTokens": {
            "crashlyticsAPIKey": "asass121",
            "otpAutoReadHash": null
          }
        },
        "android": {
          "appAssetIds": {
            "brandLogo": null,
            "splashScreen": "splash"
          },
          "appIconId": {
            "debug": "ic_launcher",
            "release": "ic_launcher"
          },
          "appName": {
            "debug": "Urban Company",
            "release": "Urban Company"
          },
          "appPackageId": null,
          "thirdPartyTokens": {
            "crashlyticsAPIKey": null,
            "otpAutoReadHash": "gEcqWzJu2Pl"
          }
        }
      },
      "web": {
        "domain": "www.urbancompany.com"
      }
    }
  ],
  "helpCenterDetails": [
    {
      "is_help_center_enabled": false,
      "is_partner_email_us_enabled": false,
      "provider_support_phone": "+966547961317",
      "customer_support_phone": "0115136102",
      "email": "help@urbancompany.com",
      "customer_support_email": "help@urbancompany.com",
      "partner_support_email": "help@urbancompany.com",
      "country_key": "KSA"
    },
    {
      "is_help_center_enabled": true,
      "is_partner_email_us_enabled": false,
      "provider_support_phone": "+911244577300",
      "customer_support_phone": "18605000020",
      "email": "help@urbancompany.com",
      "customer_support_email": "help@urbancompany.com",
      "partner_support_email": "help@urbancompany.com",
      "country_key": "IND"
    },
    {
      "is_help_center_enabled": true,
      "is_partner_email_us_enabled": true,
      "provider_support_phone": "048722302",
      "customer_support_phone": "048722301",
      "email": "help@urbanclap.com",
      "customer_support_email": "help@urbanclap.com",
      "partner_support_email": "uae-partners@urbanclap.com",
      "country_key": "UAE"
    },
    {
      "is_help_center_enabled": false,
      "is_partner_email_us_enabled": false,
      "provider_support_phone": "+6562557966",
      "customer_support_phone": "+6562557866",
      "email": "help@urbanclap.com",
      "customer_support_email": "help@urbancompany.com",
      "partner_support_email": "help@urbancompany.com",
      "country_key": "SGP"
    }
  ]
};